unit DieselDepots;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ComCtrls, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, WEBLib.Buttons,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCBitmapContainer,System.DateUtils, WEBLib.REST;

type
  TfrmDieselDepots = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPageControl1: TPageControl;
    WebPageControl1Sheet1: TTabSheet;
    WebPageControl1Sheet2: TTabSheet;
    WebPageControl1Sheet3: TTabSheet;
    WebPanel3: TPanel;
    WebPanel4: TPanel;
    WebPanel5: TPanel;
    WebButton1: TButton;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDBEdit5: TDBEdit;
    WebDBEdit6: TDBEdit;
    WebDBEdit7: TDBEdit;
    WebDBEdit8: TDBEdit;
    WebDBEdit10: TDBEdit;
    WebDBEdit11: TDBEdit;
    WebDBEdit12: TDBEdit;
    WebLabel1: TLabel;
    WebDBMemo1: TDBMemo;
    WebDBEdit13: TDBEdit;
    WebDBEdit14: TDBEdit;
    WebDBEdit15: TDBEdit;
    WebDBEdit16: TDBEdit;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebButton3: TButton;
    WebDBCheckBox1: TDBCheckBox;
    WebDBCheckBox2: TDBCheckBox;
    WebDBCheckBox3: TDBCheckBox;
    WebDBCheckBox4: TDBCheckBox;
    WebDBCheckBox5: TDBCheckBox;
    WebLabel15: TLabel;
    WebDBEdit17: TDBEdit;
    WebGroupBox1: TGroupBox;
    WebDBCheckBox6: TDBCheckBox;
    WebDBCheckBox7: TDBCheckBox;
    WebDBCheckBox8: TDBCheckBox;
    WebPanel6: TPanel;
    btnSaveDepotInfo: TButton;
    WebButton5: TButton;
    WebButton6: TButton;
    WebPanel7: TPanel;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    WebPanel8: TPanel;
    btnNewPrice: TButton;
    btnConfirmPrice: TButton;
    btnOpenPrice: TButton;
    WebPanel9: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    edtDepotPriceEdit: TEdit;
    btnInsertDepot: TButton;
    btnEditDepot: TButton;
    btnSuspended: TButton;
    WebPageControl1Sheet4: TTabSheet;
    WebPanel18: TPanel;
    WebPanel19: TPanel;
    WebPanel20: TPanel;
    WebPanel21: TPanel;
    WebLabel40: TLabel;
    WebButton44: TButton;
    dgDepots: TTMSFNCDataGrid;
    dgdbaDieselDepots: TTMSFNCDataGridDatabaseAdapter;
    wcDieselDepots: TXDataWebClient;
    wdsDieselDepots: TXDataWebDataSet;
    dsDieselDepots: TDataSource;
    WebPanel22: TPanel;
    WebPanel23: TPanel;
    wdsDieselDepotsDEPOTCODE: TIntegerField;
    wdsDieselDepotsDEPOTNAME: TStringField;
    wdsDieselDepotsDEPOTTEL: TStringField;
    wdsDieselDepotsDEPOTFAX: TStringField;
    wdsDieselDepotsDEPOTEMAIL: TStringField;
    wdsDieselDepotsDEPOTCONTACTPERSONE: TStringField;
    wdsDieselDepotsSUSPENDED: TBooleanField;
    wdsDieselDepotsINVENTORYGL: TStringField;
    wdsDieselDepotsAUTOPRINT: TBooleanField;
    wdsDieselDepotsPRINTER: TStringField;
    wdsDieselDepotsCOSTGL: TStringField;
    wdsDieselDepotsSALESGL: TStringField;
    wdsDieselDepotsCONTROLSTOCK: TBooleanField;
    wdsDieselDepotsCRECODE: TStringField;
    wdsDieselDepotsCARDSYSTEM: TBooleanField;
    wdsDieselDepotsMERCHANTNO: TStringField;
    wdsDieselDepotsTOWN: TStringField;
    wdsDieselDepotsSAGEPROJECT: TStringField;
    wdsDieselDepotsNONSAGEEXPORT: TBooleanField;
    wdsDieselDepotsBOWSERCODE: TStringField;
    wdsDieselDepotsBULKORDERPREFIX: TStringField;
    wdsDieselDepotsDELVADDRESS1: TStringField;
    wdsDieselDepotsDELVADDRESS2: TStringField;
    wdsDieselDepotsDELVADDRESS3: TStringField;
    wdsDieselDepotsDELVADDRESS4: TStringField;
    wdsDieselDepotsDELVADDRESSCODE: TStringField;
    wdsDieselDepotstfnonlinelink: TBooleanField;
    wdsDieselDepotstfnsuppliercode: TStringField;
    wdsDieselDepotstfndepotcode: TIntegerField;
    wdsDieselDepotsfmsonlinelink: TBooleanField;
    wdsDieselDepotsfmssupplier: TStringField;
    wdsDieselDepotsstdepotcode: TIntegerField;
    wdsDieselDepotstfnproduct: TStringField;
    wdsDieselDepotstfnuseinvoice: TBooleanField;
    wdsDieselDepotsstonlinelink: TBooleanField;
    wdsDieselDepotsstsupplier: TStringField;
    wdsDieselDepotsfmsdepotcode: TIntegerField;
    wdsDieselDepotsstautocreateorder: TBooleanField;
    wdsDieselDepotsautocancelorders: TBooleanField;
    wdsDieselDepotsautocanceldays: TIntegerField;
    wdsDieselDepotsshiptechlink: TBooleanField;
    wdsDieselDepotsshiptechaccount: TStringField;
    wdsDieselDepotsshiptechdepot: TIntegerField;
    wdsDieselDepotssendexternalsms: TBooleanField;
    wdsDieselDepotswholesalelic: TStringField;
    wdsDieselDepotsfuelusupplier: TStringField;
    wdsDieselDepotsfueludepotcode: TIntegerField;
    wdsDieselDepotsfueluonlinelink: TBooleanField;
    wdsDieselDepotsfuelonlinesystem: TBooleanField;
    wdsDieselDepotsfuelmanmanualorders: TBooleanField;
    wdsDieselDepotsfuelmancardpayments: TBooleanField;
    wdsDieselDepotsxfuelsonlinelink: TBooleanField;
    wdsDieselDepotsxfuelssuppliers: TStringField;
    wdsDieselDepotsxfuelsdepotcode: TIntegerField;
    wdsDieselDepotsregion: TIntegerField;
    WebSpeedButton5: TSpeedButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton8: TSpeedButton;
    edtDieselDepotsPC: TEdit;
    edtDepotSearch: TEdit;
    wcDepotPriceList: TXDataWebClient;
    wdsDepotPriceList: TXDataWebDataSet;
    dsDepotPriceList: TDataSource;
    WebSpeedButton9: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton12: TSpeedButton;
    edtDepotPriceList: TEdit;
    wdsDepotPriceListAUTONO: TIntegerField;
    wdsDepotPriceListDEPOTCODE: TIntegerField;
    wdsDepotPriceListCOSTPRICE: TFloatField;
    wdsDepotPriceListSTDPRICE: TFloatField;
    wdsDepotPriceListDEDSUBPRICE: TFloatField;
    wdsDepotPriceListSPECIALPRICE: TFloatField;
    wdsDepotPriceListPRICELOADBY: TStringField;
    wdsDepotPriceListPRICECONFIRMBY: TStringField;
    wdsDepotPriceListPRICECONFIRMED: TBooleanField;
    wdsDepotPriceListfueltype: TIntegerField;
    wdsDepotPriceListfueltypename: TStringField;
    TempLabel: TLabel;
    btnSaveDepotInfoPriceList: TButton;
    WebButton18: TButton;
    cbxSuspended: TCheckBox;
    dgDepotPriceListSetup: TTMSFNCDataGrid;
    dgdbaDepotPriceListEdit: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCDataGrid3: TTMSFNCDataGrid;
    TMSFNCDataGridDatabaseAdapter1: TTMSFNCDataGridDatabaseAdapter;
    dgdbaDepotPriceListView: TTMSFNCDataGridDatabaseAdapter;
    BitmapContainer1: TTMSFNCBitmapContainer;
    msgdlgDepotPriceList: TMessageDlg;
    wdsDepotPriceListFROMDATE: TStringField;
    wdsDepotPriceListTODATE: TStringField;
    wdsDepotPriceListPRICELOADDATE: TStringField;
    wdsDepotPriceListPRICECONFIRMDATE: TStringField;
    RESTClient1: TRESTClient;
    wcTFNDepot: TXDataWebClient;
    wdsTFNDepots: TXDataWebDataSet;
    wdsTFNDepotsnumber: TIntegerField;
    wdsTFNDepotsname: TStringField;
    wdsTFNDepotsregion: TStringField;
    dsTFNDepots: TDataSource;
    wdsTFNProducts: TXDataWebDataSet;
    dsTFNProducts: TDataSource;
    wdsTFNProductscode: TStringField;
    wdsTFNProductsname: TStringField;
    wcTFNProduct: TXDataWebClient;
    wcProduct: TXDataWebClient;
    wdsProduct: TXDataWebDataSet;
    dsProduct: TDataSource;
    wdsProductfueltype: TIntegerField;
    wdsProductfueltypename: TStringField;
    wdsDieselDepotsTFNDepotName: TStringField;
    wdsDieselDepotsMasterAccount: TStringField;
    wdsDieselDepotsTFNFuelTypeName: TStringField;
    wdsDieselDepotsTFNProductName: TStringField;
    wdsDieselDepotsSummaTechCRName: TStringField;
    wdsDieselDepotsstdName: TStringField;
    wdsDieselDepotsstFuelTypeName: TStringField;
    wdsDieselDepotsFMSCRName: TStringField;
    wdsDieselDepotsfmsDepotName: TStringField;
    wdsDieselDepotsfmsFuelTypeName: TStringField;
    wdsDieselDepotsshiptechDepotName: TStringField;
    wdsDieselDepotsShipTechFuelTypeName: TStringField;
    wdsDieselDepotsFuelUCRName: TStringField;
    wdsDieselDepotsFuelUDepotName: TStringField;
    wdsDieselDepotsFuelUFueltypeName: TStringField;
    wdsDieselDepotsxFuelCRName: TStringField;
    wdsDieselDepotsXFuelDepotName: TStringField;
    wdsDieselDepotsxfuelFueleName: TStringField;
    WebButton13: TButton;
    wdsDieselDepotsTFNCRName: TStringField;
    wdsDieselDepotsShiptechCRName: TStringField;
    dbedtMasterAccount: TDBEdit;
    wdsDieselDepotsfueltypename: TStringField;
    wdsDieselDepotstfninternalproduct: TIntegerField;
    wdsDieselDepotssummatechfueltype: TIntegerField;
    wdsDieselDepotsfmsfueltype: TIntegerField;
    wdsDieselDepotsshiptechfueltype: TIntegerField;
    wdsDieselDepotsfuelufueltype: TIntegerField;
    wdsDieselDepotsxfuelfueltype: TIntegerField;
    WebPanel26: TPanel;
    WebPanel10: TPanel;
    PageControl: TPageControl;
    wpcSageAccounting: TTabSheet;
    WebPanel11: TPanel;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebDBEdit18: TDBEdit;
    WebDBEdit19: TDBEdit;
    WebDBEdit20: TDBEdit;
    WebDBCheckBox9: TDBCheckBox;
    WebButton12: TButton;
    wpcBulkOrderInfo: TTabSheet;
    WebPanel12: TPanel;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    WebDBEdit21: TDBEdit;
    WebDBEdit22: TDBEdit;
    WebDBEdit23: TDBEdit;
    WebDBEdit24: TDBEdit;
    WebDBEdit25: TDBEdit;
    WebDBEdit26: TDBEdit;
    wpcTFNLinkInformation: TTabSheet;
    WebPanel13: TPanel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebDBCheckBox10: TDBCheckBox;
    WebDBCheckBox11: TDBCheckBox;
    WebButton25: TButton;
    dbedtTFNSupplier: TDBEdit;
    WebDBEdit27: TDBEdit;
    WebDBEdit28: TDBEdit;
    WebDBEdit29: TDBEdit;
    WebButton2: TButton;
    WebButton7: TButton;
    WebButton10: TButton;
    WebButton16: TButton;
    wpcSummatechLink: TTabSheet;
    WebPanel14: TPanel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebButton26: TButton;
    WebDBCheckBox12: TDBCheckBox;
    WebDBCheckBox13: TDBCheckBox;
    WebButton14: TButton;
    WebDBEdit30: TDBEdit;
    WebDBEdit9: TDBEdit;
    WebButton21: TButton;
    WebDBEdit32: TDBEdit;
    WebButton22: TButton;
    wpcFMSLink: TTabSheet;
    WebPanel15: TPanel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    WebLabel30: TLabel;
    WebDBCheckBox14: TDBCheckBox;
    WebDBEdit34: TDBEdit;
    WebDBEdit35: TDBEdit;
    WebButton30: TButton;
    WebDBEdit31: TDBEdit;
    WebButton15: TButton;
    WebButton23: TButton;
    WebButton24: TButton;
    wpcShiptechLink: TTabSheet;
    WebPanel16: TPanel;
    WebLabel31: TLabel;
    WebLabel32: TLabel;
    WebLabel33: TLabel;
    WebDBCheckBox15: TDBCheckBox;
    WebDBEdit37: TDBEdit;
    WebDBEdit38: TDBEdit;
    WebDBEdit39: TDBEdit;
    WebButton31: TButton;
    WebButton32: TButton;
    WebButton33: TButton;
    wpcFuelULink: TTabSheet;
    WebPanel17: TPanel;
    WebLabel34: TLabel;
    WebLabel35: TLabel;
    WebLabel36: TLabel;
    WebDBCheckBox16: TDBCheckBox;
    WebDBEdit40: TDBEdit;
    WebDBEdit41: TDBEdit;
    WebDBEdit42: TDBEdit;
    WebButton34: TButton;
    WebButton35: TButton;
    WebButton36: TButton;
    WebButton40: TButton;
    wpcXFuelsLink: TTabSheet;
    WebPanel24: TPanel;
    WebLabel38: TLabel;
    WebLabel39: TLabel;
    WebLabel37: TLabel;
    WebDBCheckBox17: TDBCheckBox;
    WebDBEdit43: TDBEdit;
    WebDBEdit44: TDBEdit;
    WebButton38: TButton;
    WebButton37: TButton;
    WebDBEdit45: TDBEdit;
    WebButton39: TButton;
    WebPanel25: TPanel;
    WebButton19: TButton;
    btnSaveDepotInfoThirdParty: TButton;
    wcUserAccess: TXDataWebClient;
    procedure WebButton6Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebButton44Click(Sender: TObject);
    procedure dgDepotsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure btnEditDepotClick(Sender: TObject);
    procedure WebButton5Click(Sender: TObject);
    procedure btnInsertDepotClick(Sender: TObject);
    procedure btnSaveDepotInfoClick(Sender: TObject);
    procedure WebDBCheckBox9Click(Sender: TObject);
    procedure WebDBCheckBox10Click(Sender: TObject);
    procedure WebDBCheckBox11Click(Sender: TObject);
    procedure WebDBCheckBox12Click(Sender: TObject);
    procedure WebDBCheckBox13Click(Sender: TObject);
    procedure WebDBCheckBox14Click(Sender: TObject);
    procedure WebDBCheckBox15Click(Sender: TObject);
    procedure WebDBCheckBox16Click(Sender: TObject);
    procedure WebDBCheckBox17Click(Sender: TObject);
    procedure WebDBCheckBox2Click(Sender: TObject);
    procedure WebDBCheckBox3Click(Sender: TObject);
    procedure WebDBCheckBox4Click(Sender: TObject);
    procedure WebDBCheckBox5Click(Sender: TObject);
    procedure WebDBCheckBox1Click(Sender: TObject);
    procedure WebDBCheckBox6Click(Sender: TObject);
    procedure WebDBCheckBox7Click(Sender: TObject);
    procedure WebDBCheckBox8Click(Sender: TObject);
    procedure btnSaveDepotInfoPriceListClick(Sender: TObject);
    procedure btnSaveDepotInfoThirdPartyClick(Sender: TObject);
    procedure WebButton19Click(Sender: TObject);
    procedure WebButton18Click(Sender: TObject);
    procedure cbxSuspendedClick(Sender: TObject);
    procedure WebCheckBox1Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton12Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure btnNewPriceClick(Sender: TObject);
    procedure WebButton8Click(Sender: TObject);
    procedure dgDepotPriceListSetupCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure btnSuspendedClick(Sender: TObject);
    procedure dgDepotPriceListSetupGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgDepotPriceListSetupGetCellLayout(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure btnConfirmPriceClick(Sender: TObject);
    procedure btnOpenPriceClick(Sender: TObject);
    procedure WebButton13Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton14Click(Sender: TObject);
    procedure WebButton15Click(Sender: TObject);
    procedure WebButton31Click(Sender: TObject);
    procedure WebButton34Click(Sender: TObject);
    procedure WebButton37Click(Sender: TObject);
    procedure WebButton7Click(Sender: TObject);
    procedure WebButton16Click(Sender: TObject);
    procedure WebButton10Click(Sender: TObject);
    procedure WebButton21Click(Sender: TObject);
    procedure WebButton22Click(Sender: TObject);
    procedure WebButton23Click(Sender: TObject);
    procedure WebButton24Click(Sender: TObject);
    procedure WebButton33Click(Sender: TObject);
    procedure WebButton32Click(Sender: TObject);
    procedure WebButton35Click(Sender: TObject);
    procedure WebButton36Click(Sender: TObject);
    procedure WebButton38Click(Sender: TObject);
    procedure WebButton39Click(Sender: TObject);
    procedure dgDepotPriceListSetupSelectCell(Sender: TObject; AStartCell,
      AEndCell: TTMSFNCDataGridCellCoord);
    procedure dgDepotsSelectCell(Sender: TObject; AStartCell,
      AEndCell: TTMSFNCDataGridCellCoord);
  private
    { Private declarations }

    iDieselDepotPC , iDieselDepotMaxPC : Integer;
    iDepotPriceListPC , iDepotPriceListMaxPC : Integer;
    iDepotCode, iState : Integer;
    iAutoNum : Integer;
    sSearchDepot : String;
    ActiveRow : Integer;
    iOldRowPriceList : Integer;
    iOldRowDepot : Integer;

    procedure LoadDieselDepots;
    procedure LoadDepotPriceList;

    procedure LoadLookups;


    procedure SaveDepot;
    procedure CloseDepot;

    procedure GetUserAccess;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmDieselDepots: TfrmDieselDepots;

implementation

{$R *.dfm}

uses
  stfmssystem.connection ,  share.common, DieselDepotPricesSetup, Search.MasterAccount, Search.TFNDepots, Search.FuelType,
  Search.STSupplier, Search.FMSSuppliers, Search.ShiptechDepots, Search.FuelU,
  Search.XFuelsDepots, stfmssystem.main, share.classes ;

procedure TfrmDieselDepots.btnInsertDepotClick(Sender: TObject);
begin

  btnInsertDepot.Enabled := false;
  btnEditDepot.Enabled := false;
  btnSuspended.Enabled := false;

  wdsDieselDepots.ClearFields;
  wdsDieselDepots.Insert;

  WebPageControl1Sheet4.TabVisible := false;

  WebPageControl1Sheet1.TabVisible := True;
  WebPageControl1Sheet2.TabVisible := True;
  WebPageControl1Sheet3.TabVisible := True;

  cbxSuspended.Enabled := false;

  WebPageControl1.TabIndex := 0;

  iState := 1;

end;

procedure TfrmDieselDepots.btnNewPriceClick(Sender: TObject);
var
    newform : TfrmDepotPriceSetup;
    iAutoNo : Integer;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
          iDepotCodeSetup := iDepotCode;
          //iFuelType := wdsDepotPriceList.FieldByName('').AsInteger;

        end;
    end;
  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadDepotPriceList;
    end;
  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          //wcCompInfo.RawInvoke('IstfmsSystemService.Put_InvoiceNumber_Delete',[tmsGridNumbers.Cells[0,ARow]]);
          //LoadInvoiceNumbers;
        End
      else
        Exit;
    end;
begin

  if True then    //user access
    begin
      newform := TfrmDepotPriceSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);
    end
  else
    begin
      ShowMessage('User Not Allowed To Load Diesel Prices!');
    end;
end;

procedure TfrmDieselDepots.btnSuspendedClick(Sender: TObject);
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      iDepotCode := 0;
      LoadDieselDepots;
    end;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      if cbxSuspended.Checked then
        begin
          ShowMessage('Depot successfully UnSuspended');
        end
      else
        begin
          ShowMessage('Depot successfully Suspended');
        end;
        iDepotCode := 0;
        LoadDieselDepots;
    end;

begin
  if iDepotCode > -1 then
    wcDieselDepots.RawInvoke('IstfmsdieselService.Put_SuspendDepot',[dgdbaDieselDepots.FieldAtColumn[0].AsInteger,(NOT cbxSuspended.Checked)],@OnSuccess,@OnError)
  else
    ShowMessage('Please Select a Depot');

end;

procedure TfrmDieselDepots.cbxSuspendedClick(Sender: TObject);
begin
  LoadDieselDepots;
end;

procedure TfrmDieselDepots.CloseDepot;
begin
  btnInsertDepot.Enabled := true;
  btnEditDepot.Enabled := true;
  btnSuspended.Enabled := true;

  WebPageControl1Sheet4.TabVisible := True;

  WebPageControl1Sheet1.TabVisible := False;
  WebPageControl1Sheet2.TabVisible := False;
  WebPageControl1Sheet3.TabVisible := False;

  cbxSuspended.Enabled := True;

  WebPageControl1.TabIndex := 3;

  iDepotCode := 0;
  LoadDieselDepots;

end;

procedure TfrmDieselDepots.LoadDepotPriceList;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadDepotPriceList;
    end;

  procedure OnResultNumbers(Response : TXDataClientResponse);
    begin
      edtDepotPriceList.Text := IntToStr(iDepotPriceListPC) + ' OF ' + IntToStr(iDepotPriceListMaxPC);
      edtDepotPriceEdit.Text := IntToStr(iDepotPriceListPC) + ' OF ' + IntToStr(iDepotPriceListMaxPC);

      wdsDepotPriceList.Close;
      wdsDepotPriceList.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsDepotPriceList.Open;


    end;

  procedure OnResultMaxPC(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadDepotPriceList;
        end
      else
        begin
          iDepotPriceListMaxPC := Integer(TJSObject(Response.Result)['value']);

          wcDepotPriceList.RawInvoke('IstfmsdieselService.Get_DepotPriceList_View',[iDepotCode,iDepotPriceListPC,0],@OnResultNumbers,@OnError);
        end;
    end;

begin
  wcDepotPriceList.RawInvoke('IstfmsdieselService.Get_DepotPriceList_MaxPC',[iDepotCode],@OnResultMaxPC,@OnError);
end;

procedure TfrmDieselDepots.LoadDieselDepots;
procedure OnResultError(Error: TXDataClientError);
    begin
      LoadDieselDepots;
    end;

  procedure OnResultNumbers(Response : TXDataClientResponse);
    begin
      edtDieselDepotsPC.Text := IntToStr(iDieselDepotPC) + ' OF ' + IntToStr(iDieselDepotMaxPC);

      wdsDieselDepots.Close;
      wdsDieselDepots.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsDieselDepots.Open;

      if iState = 2 then
        Begin
          wdsDieselDepots.Edit;
        End;
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadDieselDepots;
        end
      else
        begin
          iDieselDepotMaxPC := Integer(TJSObject(Response.Result)['value']);
          TempLabel.Caption := IntToStr(iDepotCode);
          wcDieselDepots.RawInvoke('IstfmsdieselService.Get_DieselDepots_View',[sSearchDepot,iDepotCode,iDieselDepotPC,cbxSuspended.Checked],@OnResultNumbers,@OnResultError);
        end;
    end;
begin
  wcDieselDepots.RawInvoke('IstfmsdieselService.Get_DieselDepot_MaxPC',[],@OnResultPC,@OnResultError);


end;

procedure TfrmDieselDepots.LoadLookups;
begin
end;

procedure TfrmDieselDepots.SaveDepot;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Diesel Depot Successfully saved');
      WebPageControl1.TabIndex := 3;

      btnInsertDepot.Enabled := true;
      btnEditDepot.Enabled := true;
      btnSuspended.Enabled := true;

      WebPageControl1Sheet4.TabVisible := True;

      WebPageControl1Sheet1.TabVisible := False;
      WebPageControl1Sheet2.TabVisible := False;
      WebPageControl1Sheet3.TabVisible := False;

      iDepotCode := 0;
      LoadDieselDepots;

      btnSaveDepotInfoPriceList.Enabled := true;
      btnSaveDepotInfo.Enabled := True;
      btnSaveDepotInfoThirdParty.Enabled := true;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      btnSaveDepotInfoThirdParty.Enabled := true;
      btnSaveDepotInfoPriceList.Enabled := true;
      btnSaveDepotInfo.Enabled := True;
      ShowMessage(Error.ErrorMessage);
    end;
begin

  if True then //user access   GetUserAccess(User,Supervisor)
    begin
      case iState of
        1:  Begin
              wcDieselDepots.RawInvoke('IstfmsdieselService.Put_DieselDepot_Insert',[GetJsonFromDataSet(wdsDieselDepots)],@OnSuccess,@OnError);
            End;
        2:  Begin
              console.log(GetJsonFromDataSet(wdsDieselDepots));
              wcDieselDepots.RawInvoke('IstfmsdieselService.Put_DieselDepot_Edit',[GetJsonFromDataSet(wdsDieselDepots)],@OnSuccess,@OnError);
            End;
      end;
    end
  else
    begin
      ShowMessage('User Does Not Have Access To Update Diesel Depot Setup!');
    end;



end;

procedure TfrmDieselDepots.dgDepotsCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  iDepotPriceListPC := 1;
  LoadDepotPriceList;

  iDepotCode := dgdbaDieselDepots.FieldAtColumn[0].AsInteger;
end;

procedure TfrmDieselDepots.dgDepotsSelectCell(Sender: TObject;
  AStartCell, AEndCell: TTMSFNCDataGridCellCoord);
begin
  If AStartCell.Row >= 1 then
    begin
      dgDepots.Cells[1,iOldRowDepot] := '';
      dgDepots.Cells[1,AStartCell.Row] := '->';
      iOldRowDepot := AStartCell.Row;
    end;
end;

procedure TfrmDieselDepots.dgDepotPriceListSetupCellClick(Sender: TObject; AColumn,
  ARow: Integer);
  var
    newform : TfrmDepotPriceSetup;


  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          dgdbaDepotPriceListEdit.SetActiveRecord(ARow);
          iAutoNo := dgdbaDepotPriceListEdit.FieldAtColumn[0].AsInteger;
          iDepotCodeSetup := iDepotCode;
        end;
    end;
  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadDepotPriceList;
    end;
  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          wcDepotPriceList.RawInvoke('IstfmsdieselService.Put_DepotPriceList_Delete',[iAutoNum]);
          LoadDepotPriceList;
        End
      else
        Exit;
    end;

begin
  dgdbaDepotPriceListEdit.SetActiveRecord(ARow);
  ActiveRow := ARow;
  iAutoNum := dgdbaDepotPriceListEdit.FieldAtColumn[1].AsInteger;



  if NOT dgdbaDepotPriceListEdit.FieldAtColumn[15].AsBoolean then
    begin

      btnConfirmPrice.Enabled := true;
      btnOpenPrice.Enabled := false;

      if AColumn = 16 then
        begin
          newform := TfrmDepotPriceSetup.CreateNew(@AfterCreate);
            newform.Popup := true;
            newform.PopupOpacity := 0.2;
            newform.Showmodal(@AfterShowModal);
          end;

      if AColumn = 17 then
        begin
          msgdlgDepotPriceList.ShowDialog('Do you want to delete this fuel price', WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
        end;

    end
  else
    begin
      if AColumn IN [16,17] then
        ShowMessage('Price is closed and can not be changed');
      btnConfirmPrice.Enabled := false;
      btnOpenPrice.Enabled := True;

    end;

end;

procedure TfrmDieselDepots.dgDepotPriceListSetupGetCellLayout(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
  var
  bConfirmed : boolean;
  dtToDate , dtFromDate : TDateTime;
  sFromDate , sToDate , sformatedDate : String;
  fs: TFormatSettings;
begin

  if dgdbaDepotPriceListEdit.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column IN [0,16,17] then
        Exit;

      dgdbaDepotPriceListEdit.SetActiveRecord(ACell.Row);

      sFromDate := dgdbaDepotPriceListEdit.FieldAtColumn[3].AsString;
      sToDate := dgdbaDepotPriceListEdit.FieldAtColumn[4].AsString;

      dtFromDate := RESTClient1.IsoToDateTime(sFromDate);
      dtToDate := RESTClient1.IsoToDateTime(sToDate)   ;//StrToDate(sformatedDate);

      if dgDepotPriceListSetup.Booleans[15,ACell.row] then
        begin
          if (dtFromDate <= Date) AND (dtToDate >= Date) then
             begin
              //ACell.Layout.Fill.Kind := gfkSolid;
              ACell.Layout.Fill.Color := gcLightGreen;
              ACell.Layout.Font.Color := gcBlack;
             end
          else
            begin
              //ACell.Layout.Fill.Kind := gfkSolid;
              ACell.Layout.Fill.Color := gcBlack;
              ACell.Layout.Font.Color := gcWhite;
            end;
        end
      else
        begin
          //ACell.Layout.Fill.Kind := gfkSolid;
          ACell.Layout.Fill.Color := gcRed;
          ACell.Layout.Font.Color := gcWhite;
        end;

    end;

end;

procedure TfrmDieselDepots.dgDepotPriceListSetupGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);

begin
  if ACell.IsBitmapCell and dgdbaDepotPriceListEdit.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 16 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];

      if ACell.Column = 17 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];
    end;

   
end;



procedure TfrmDieselDepots.dgDepotPriceListSetupSelectCell(Sender: TObject;
  AStartCell, AEndCell: TTMSFNCDataGridCellCoord);
begin
  If AStartCell.Row >= 1 then
    begin
      dgDepotPriceListSetup.Cells[0,iOldRowPriceList] := '';
      dgDepotPriceListSetup.Cells[0,AStartCell.Row] := '->';
      iOldRowPriceList := AStartCell.Row;
    end;
end;

procedure TfrmDieselDepots.GetUserAccess;
var
  sUser,
  json : String;
  javascriptobject: JSValue;

 // procedure OnResult(Response : TXDataClientResponse);
 //   begin
 //     json := string(Response.ResponseText);
 //     javascriptobject := TJSJSON.parse(json);
 //     UserAccess := TUser(javascriptobject);
 //   end;

begin
 // wcUserAccess.RawInvoke('IstfmsSystemService.GetUserAccess',[],@OnResult);
end;

procedure TfrmDieselDepots.btnEditDepotClick(Sender: TObject);
begin
  if iDepotCode = 0 then
    begin
      ShowMessage('Please select a depot.');
    end
  else
    begin
      WebPageControl1.TabIndex := 0;

      btnInsertDepot.Enabled := false;
      btnEditDepot.Enabled := false;
      btnSuspended.Enabled := false;

      WebPageControl1Sheet4.TabVisible := false;

      WebPageControl1Sheet1.TabVisible := True;
      WebPageControl1Sheet2.TabVisible := True;
      WebPageControl1Sheet3.TabVisible := True;

      cbxSuspended.Enabled := false;

      iState := 2;
      iAutoNum := -1;

      LoadDieselDepots;

      LoadDepotPriceList;
    end;


end;

procedure TfrmDieselDepots.WebButton10Click(Sender: TObject);
var
  newform : TfrmFuelTypeSearch;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iFuelTypeSearch > -1 then
            begin
              wdsDieselDepots.FieldByName('tfninternalproduct').AsInteger := iFuelTypeSearch;

              wdsDieselDepots.FieldByName('fueltypename').AsString := sFuelTypeNameSearch;
            end
          else
            begin
              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmFuelTypeSearch.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);

end;

procedure TfrmDieselDepots.btnOpenPriceClick(Sender: TObject);
procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Price Opened');
      LoadDepotPriceList;

    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      LoadDepotPriceList;

    end;
begin

  if True then //user access
    begin
      if iAutoNum > -1 then
        Begin
          if dgDepotPriceListSetup.Booleans[15,ActiveRow] = true  then
            begin
              TempLabel.Caption := IntToStr(iAutoNum) +  ' ' + IntToStr(iDepotCode);
              wcDepotPriceList.RawInvoke('IstfmsdieselService.Put_OpenPrice',[iAutoNum,iDepotCode,' User '],@OnSuccess,@OnError);
            end
          else
            begin
              ShowMessage('Price is already open');
            end;
        end
      else
        begin
          ShowMessage('Please select a fuel price');
        end;
    end
  else
    begin
      ShowMessage('User Not Allowed To Remove Diesel Prices!');
    end;


end;

procedure TfrmDieselDepots.WebButton13Click(Sender: TObject);
var
    newform : TfrmSearchMasterAccount;

    procedure AfterShowModal(AValue: TModalResult);
      begin
        with newform do
          begin
            if sCRNumber <> '' then
              begin
                wdsDieselDepots.FieldByName('CRECODE').AsString := sCRNumber;

                wdsDieselDepots.FieldByName('MasterAccount').AsString := sCRName;


              end
            else
              begin

                //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
              end;
          end;
      end;

begin
  newform := TfrmSearchMasterAccount.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton14Click(Sender: TObject);
var
  newform : TfrmSearchMasterAccount;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCRNumber <> '' then
            begin
              wdsDieselDepots.FieldByName('stsupplier').AsString := sCRNumber;

              wdsDieselDepots.FieldByName('SummaTechCRName').AsString := sCRName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchMasterAccount.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton15Click(Sender: TObject);
var
  newform : TfrmSearchMasterAccount;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCRNumber <> '' then
            begin
              wdsDieselDepots.FieldByName('fmssupplier').AsString := sCRNumber;

              wdsDieselDepots.FieldByName('FMSCRName').AsString := sCRName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchMasterAccount.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton16Click(Sender: TObject);
var
  newform : TfrmSearchTFNDepots; //change search

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iNumber > -1 then
            begin
              wdsDieselDepots.FieldByName('tfnproduct').AsInteger := iNumber;

              wdsDieselDepots.FieldByName('TFNProductName').AsString := sDepotName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchTFNDepots.CreateNew; //change search
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.btnSaveDepotInfoPriceListClick(Sender: TObject);
begin
  btnSaveDepotInfoPriceList.Enabled := False;
  SaveDepot;
end;

procedure TfrmDieselDepots.WebButton18Click(Sender: TObject);
begin
  CloseDepot;
end;

procedure TfrmDieselDepots.WebButton19Click(Sender: TObject);
begin
  CloseDepot;
end;

procedure TfrmDieselDepots.btnSaveDepotInfoThirdPartyClick(Sender: TObject);
begin
  btnSaveDepotInfoThirdParty.Enabled := false;
  SaveDepot;
end;

procedure TfrmDieselDepots.WebButton21Click(Sender: TObject);
var
  newform : TfrmFuelTypeSearch;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iFuelTypeSearch > -1 then
            begin
              wdsDieselDepots.FieldByName('summatechfueltype').AsInteger := iFuelTypeSearch;

              wdsDieselDepots.FieldByName('stFuelTypeName').AsString := sFuelTypeNameSearch;
            end
          else
            begin
              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmFuelTypeSearch.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton22Click(Sender: TObject);
var
  newform : TfrmSearchSTSupplier;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iAutoSTDepot > -1 then
            begin
              wdsDieselDepots.FieldByName('stdepotcode').AsInteger := iAutoSTDepot;

              wdsDieselDepots.FieldByName('stdName').AsString := sSTDepotName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchSTSupplier.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);


end;

procedure TfrmDieselDepots.WebButton23Click(Sender: TObject);
var
  newform : TfrmSearsFMSSupplier;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iAutoFMSDepot > -1 then
            begin
              wdsDieselDepots.FieldByName('fmsdepotcode').AsInteger := iAutoFMSDepot;

              wdsDieselDepots.FieldByName('fmsDepotName').AsString := sFMSDepotName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearsFMSSupplier.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton24Click(Sender: TObject);
var
  newform : TfrmFuelTypeSearch;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iFuelTypeSearch > -1 then
            begin
              wdsDieselDepots.FieldByName('fmsfueltype').AsInteger := iFuelTypeSearch;

              wdsDieselDepots.FieldByName('fmsFuelTypeName').AsString := sFuelTypeNameSearch;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmFuelTypeSearch.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton2Click(Sender: TObject);
var
  newform : TfrmSearchMasterAccount;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCRNumber <> '' then
            begin
              wdsDieselDepots.FieldByName('tfnsuppliercode').AsString := sCRNumber;

              wdsDieselDepots.FieldByName('TFNCRName').AsString := sCRName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchMasterAccount.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton31Click(Sender: TObject);
var
  newform : TfrmSearchMasterAccount;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCRNumber <> '' then
            begin
              wdsDieselDepots.FieldByName('shiptechaccount').AsString := sCRNumber;

              wdsDieselDepots.FieldByName('ShiptechCRName').AsString := sCRName;
            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchMasterAccount.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton32Click(Sender: TObject);
var
  newform : TfrmSearchShiptechDepot;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iShiptechDepotID > -1 then
            begin
              wdsDieselDepots.FieldByName('shiptechdepot').AsInteger := iShiptechDepotID;

              wdsDieselDepots.FieldByName('shiptechDepotName').AsString := sShiptechDepotName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchShiptechDepot.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);

end;

procedure TfrmDieselDepots.WebButton33Click(Sender: TObject);
var
  newform : TfrmFuelTypeSearch;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iFuelTypeSearch > -1 then
            begin
              wdsDieselDepots.FieldByName('shiptechfueltype').AsInteger := iFuelTypeSearch;

              wdsDieselDepots.FieldByName('ShipTechFuelTypeName').AsString := sFuelTypeNameSearch;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmFuelTypeSearch.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton34Click(Sender: TObject);
var
  newform : TfrmSearchMasterAccount;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCRNumber <> '' then
            begin
              wdsDieselDepots.FieldByName('fuelusupplier').AsString := sCRNumber;

              wdsDieselDepots.FieldByName('FuelUCRName').AsString := sCRName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchMasterAccount.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton35Click(Sender: TObject);
var
  newform : TfrmSearchFuelUDepots;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iautonoFuelU > -1 then
            begin
              wdsDieselDepots.FieldByName('fueludepotcode').AsInteger := iautonoFuelU;

              wdsDieselDepots.FieldByName('FuelUDepotName').AsString := sFuelUdepotname;
            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchFuelUDepots.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton36Click(Sender: TObject);
var
  newform : TfrmFuelTypeSearch;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iFuelTypeSearch > -1 then
            begin
              wdsDieselDepots.FieldByName('fuelufueltype').AsInteger := iFuelTypeSearch;

              wdsDieselDepots.FieldByName('FuelUFueltypeName').AsString := sFuelTypeNameSearch;
            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmFuelTypeSearch.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton37Click(Sender: TObject);
var
  newform : TfrmSearchMasterAccount;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCRNumber <> '' then
            begin
              wdsDieselDepots.FieldByName('xfuelssuppliers').AsString := sCRNumber;

              wdsDieselDepots.FieldByName('xFuelCRName').AsString := sCRName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchMasterAccount.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton38Click(Sender: TObject);
var
  newform : TfrmSearchXFuels;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iXFuelsDepotcode > -1 then
            begin
              wdsDieselDepots.FieldByName('xfuelsdepotcode').AsInteger := iXFuelsDepotcode;

              wdsDieselDepots.FieldByName('XFuelDepotName').AsString := sXFuelsDepotName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;
begin
  newform := TfrmSearchXFuels.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton39Click(Sender: TObject);
var
  newform : TfrmFuelTypeSearch;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iFuelTypeSearch > -1 then
            begin
              wdsDieselDepots.FieldByName('xfuelfueltype').AsInteger := iFuelTypeSearch;

              wdsDieselDepots.FieldByName('xfuelFueleName').AsString := sFuelTypeNameSearch;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmFuelTypeSearch.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmDieselDepots.WebButton44Click(Sender: TObject);
begin
  if Trim(edtDepotSearch.Text) = '' then
    sSearchDepot := '*'
  else
    sSearchDepot := Trim(edtDepotSearch.Text);

  LoadDieselDepots;
end;

procedure TfrmDieselDepots.btnSaveDepotInfoClick(Sender: TObject);
begin
  btnSaveDepotInfo.Enabled := false;
  SaveDepot;
end;

procedure TfrmDieselDepots.WebButton5Click(Sender: TObject);
begin
  CloseDepot;
end;

procedure TfrmDieselDepots.WebButton6Click(Sender: TObject);
begin
  close;
end;

procedure TfrmDieselDepots.WebButton7Click(Sender: TObject);
var
  newform : TfrmSearchTFNDepots;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iNumber > -1 then
            begin
              wdsDieselDepots.FieldByName('tfndepotcode').AsInteger := iNumber;

              wdsDieselDepots.FieldByName('TFNDepotName').AsString := sDepotName;

            end
          else
            begin

              //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
            end;
        end;
    end;

begin
  newform := TfrmSearchTFNDepots.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);

end;

procedure TfrmDieselDepots.WebButton8Click(Sender: TObject);
begin
  if wdsDepotPriceList.FieldByName('PRICECONFIRMED').AsBoolean = false then
    begin

    end
  else
    begin
      ShowMessage('Can''t change prices, Price already confirmed!');
    end;

end;

procedure TfrmDieselDepots.btnConfirmPriceClick(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Price Confirmed');
      LoadDepotPriceList;
      iAutoNum := -1;

    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      LoadDepotPriceList;
      iAutoNum := -1;
    end;
begin

  if true then  //user access
    begin
      if iAutoNum > -1 then
        Begin
          if dgDepotPriceListSetup.Booleans[15,ActiveRow] = false  then
            begin
              wcDepotPriceList.RawInvoke('IstfmsdieselService.Put_ConfirmPrice',[iAutoNum,iDepotCode,' User '],@OnSuccess,@OnError);
            end;
        end
      else
        begin
          ShowMessage('Please select a fuel price');
        end;
    end
  else
    begin
      ShowMessage('User Not Allowed To Update Diesel Prices!');
    end;

end;

procedure TfrmDieselDepots.WebCheckBox1Click(Sender: TObject);
begin


  if cbxSuspended.Checked then
    begin
      btnSuspended.Caption := 'Unsuspend Depot';
      btnSuspended.Color := clRed;
    end
  else
    begin
      btnSuspended.Caption := 'Suspend Depot';
      btnSuspended.Color := clAqua;
    end;
     iDepotCode := 0;

     LoadDieselDepots;

end;

procedure TfrmDieselDepots.WebDBCheckBox10Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('tfnonlinelink').AsBoolean := WebDBCheckBox10.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox11Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('tfnuseinvoice').AsBoolean := WebDBCheckBox11.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox12Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('stonlinelink').AsBoolean := WebDBCheckBox12.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox13Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('stautocreateorder').AsBoolean := WebDBCheckBox13.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox14Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('fmsonlinelink').AsBoolean := WebDBCheckBox14.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox15Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('shiptechlink').AsBoolean := WebDBCheckBox15.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox16Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('fueluonlinelink').AsBoolean := WebDBCheckBox16.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox17Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('xfuelsonlinelink').AsBoolean := WebDBCheckBox17.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox1Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('AUTOPRINT').AsBoolean :=  WebDBCheckBox1.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox2Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('CARDSYSTEM').AsBoolean := WebDBCheckBox2.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox3Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('CONTROLSTOCK').AsBoolean := WebDBCheckBox3.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox4Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('sendexternalsms').AsBoolean := WebDBCheckBox4.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox5Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('autocancelorders').AsBoolean :=  WebDBCheckBox5.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox6Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('fuelonlinesystem').AsBoolean := WebDBCheckBox6.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox7Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('fuelmanmanualorders').AsBoolean := WebDBCheckBox7.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox8Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('fuelmancardpayments').AsBoolean := WebDBCheckBox8.Checked;
end;

procedure TfrmDieselDepots.WebDBCheckBox9Click(Sender: TObject);
begin
  wdsDieselDepots.FieldByName('NONSAGEEXPORT').AsBoolean := WebDBCheckBox9.Checked;
end;

procedure TfrmDieselDepots.WebFormShow(Sender: TObject);
  procedure OnUserAccess(Response : TXDataClientResponse);
    begin


    end;
begin
  iDieselDepotPC := 1;
  iDepotPriceListPC := 1;
  sSearchDepot := '*';
  iDepotCode := 0;

  iOldRowPriceList := 1;
  iOldRowDepot := 1;

  WebPageControl1Sheet4.TabVisible := True;

  WebPageControl1Sheet1.TabVisible := False;
  WebPageControl1Sheet2.TabVisible := False;
  WebPageControl1Sheet3.TabVisible := False;

  WebPageControl1.TabIndex := 3;

  LoadDieselDepots;

  GetUserAccess;

end;

procedure TfrmDieselDepots.WebSpeedButton10Click(Sender: TObject);
begin
  if iDepotPriceListPC > 1 then
    Begin
      iDepotPriceListPC := iDepotPriceListPC - 1;
      LoadDepotPriceList;
    End;
end;

procedure TfrmDieselDepots.WebSpeedButton11Click(Sender: TObject);
begin
  if iDepotPriceListPC < iDepotPriceListMaxPC then
    Begin
      iDepotPriceListPC := iDepotPriceListPC + 1;
      LoadDepotPriceList;
    End;
end;

procedure TfrmDieselDepots.WebSpeedButton12Click(Sender: TObject);
begin
  iDepotPriceListPC := iDepotPriceListMaxPC;

  LoadDepotPriceList;
end;

procedure TfrmDieselDepots.WebSpeedButton1Click(Sender: TObject);
begin
  iDepotPriceListPC := 1;

  LoadDepotPriceList;
end;

procedure TfrmDieselDepots.WebSpeedButton2Click(Sender: TObject);
begin
  if iDepotPriceListPC > 1 then
    Begin
      iDepotPriceListPC := iDepotPriceListPC - 1;
      LoadDepotPriceList;
    End;
end;

procedure TfrmDieselDepots.WebSpeedButton3Click(Sender: TObject);
begin
  if iDepotPriceListPC < iDepotPriceListMaxPC then
    Begin
      iDepotPriceListPC := iDepotPriceListPC + 1;
      LoadDepotPriceList;
    End;
end;

procedure TfrmDieselDepots.WebSpeedButton4Click(Sender: TObject);
begin
  iDepotPriceListPC := iDepotPriceListMaxPC;

  LoadDepotPriceList;
end;

procedure TfrmDieselDepots.WebSpeedButton5Click(Sender: TObject);
begin
  iDieselDepotPC := 1;
  iDepotCode := 0;
  LoadDieselDepots;
end;

procedure TfrmDieselDepots.WebSpeedButton6Click(Sender: TObject);
begin
if iDieselDepotPC > 1 then
  begin
    iDieselDepotPC := iDieselDepotPC - 1;
    iDepotCode := 0;
    LoadDieselDepots;
  end;
end;

procedure TfrmDieselDepots.WebSpeedButton7Click(Sender: TObject);
begin
  if iDieselDepotPC < iDieselDepotMaxPC then
    Begin
      iDieselDepotPC := iDieselDepotPC + 1;
      iDepotCode := 0;
      LoadDieselDepots;
    End;
end;

procedure TfrmDieselDepots.WebSpeedButton8Click(Sender: TObject);
begin
  iDieselDepotPC := iDieselDepotMaxPC;
  iDepotCode := 0;
  LoadDieselDepots;
end;

procedure TfrmDieselDepots.WebSpeedButton9Click(Sender: TObject);
begin
  iDepotPriceListPC := 1;

  LoadDepotPriceList;
end;


procedure TfrmDieselDepots.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  TempLabel := TLabel.Create(Self);
  BitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  WebPageControl1Sheet1 := TTabSheet.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  WebDBEdit8 := TDBEdit.Create(Self);
  WebDBEdit10 := TDBEdit.Create(Self);
  WebDBEdit11 := TDBEdit.Create(Self);
  WebDBEdit12 := TDBEdit.Create(Self);
  WebDBMemo1 := TDBMemo.Create(Self);
  WebDBEdit13 := TDBEdit.Create(Self);
  WebDBEdit14 := TDBEdit.Create(Self);
  WebDBEdit15 := TDBEdit.Create(Self);
  WebDBEdit16 := TDBEdit.Create(Self);
  WebButton3 := TButton.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  WebDBCheckBox2 := TDBCheckBox.Create(Self);
  WebDBCheckBox3 := TDBCheckBox.Create(Self);
  WebDBCheckBox4 := TDBCheckBox.Create(Self);
  WebDBCheckBox5 := TDBCheckBox.Create(Self);
  WebDBEdit17 := TDBEdit.Create(Self);
  WebGroupBox1 := TGroupBox.Create(Self);
  WebDBCheckBox6 := TDBCheckBox.Create(Self);
  WebDBCheckBox7 := TDBCheckBox.Create(Self);
  WebDBCheckBox8 := TDBCheckBox.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  btnSaveDepotInfo := TButton.Create(Self);
  WebButton5 := TButton.Create(Self);
  WebButton13 := TButton.Create(Self);
  dbedtMasterAccount := TDBEdit.Create(Self);
  WebPageControl1Sheet2 := TTabSheet.Create(Self);
  WebPanel7 := TPanel.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgDepotPriceListSetup := TTMSFNCDataGrid.Create(Self);
  dgdbaDepotPriceListEdit := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  msgdlgDepotPriceList := TMessageDlg.Create(Self);
  WebPanel8 := TPanel.Create(Self);
  btnNewPrice := TButton.Create(Self);
  btnConfirmPrice := TButton.Create(Self);
  btnOpenPrice := TButton.Create(Self);
  WebPanel9 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  edtDepotPriceEdit := TEdit.Create(Self);
  btnSaveDepotInfoPriceList := TButton.Create(Self);
  WebButton18 := TButton.Create(Self);
  WebPageControl1Sheet3 := TTabSheet.Create(Self);
  WebPanel26 := TPanel.Create(Self);
  WebPanel10 := TPanel.Create(Self);
  PageControl := TPageControl.Create(Self);
  wpcSageAccounting := TTabSheet.Create(Self);
  WebPanel11 := TPanel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebDBEdit18 := TDBEdit.Create(Self);
  WebDBEdit19 := TDBEdit.Create(Self);
  WebDBEdit20 := TDBEdit.Create(Self);
  WebDBCheckBox9 := TDBCheckBox.Create(Self);
  WebButton12 := TButton.Create(Self);
  wpcBulkOrderInfo := TTabSheet.Create(Self);
  WebPanel12 := TPanel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebDBEdit21 := TDBEdit.Create(Self);
  WebDBEdit22 := TDBEdit.Create(Self);
  WebDBEdit23 := TDBEdit.Create(Self);
  WebDBEdit24 := TDBEdit.Create(Self);
  WebDBEdit25 := TDBEdit.Create(Self);
  WebDBEdit26 := TDBEdit.Create(Self);
  wpcTFNLinkInformation := TTabSheet.Create(Self);
  WebPanel13 := TPanel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebDBCheckBox10 := TDBCheckBox.Create(Self);
  WebDBCheckBox11 := TDBCheckBox.Create(Self);
  WebButton25 := TButton.Create(Self);
  dbedtTFNSupplier := TDBEdit.Create(Self);
  WebDBEdit27 := TDBEdit.Create(Self);
  WebDBEdit28 := TDBEdit.Create(Self);
  WebDBEdit29 := TDBEdit.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebButton7 := TButton.Create(Self);
  WebButton10 := TButton.Create(Self);
  WebButton16 := TButton.Create(Self);
  wpcSummatechLink := TTabSheet.Create(Self);
  WebPanel14 := TPanel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebButton26 := TButton.Create(Self);
  WebDBCheckBox12 := TDBCheckBox.Create(Self);
  WebDBCheckBox13 := TDBCheckBox.Create(Self);
  WebButton14 := TButton.Create(Self);
  WebDBEdit30 := TDBEdit.Create(Self);
  WebDBEdit9 := TDBEdit.Create(Self);
  WebButton21 := TButton.Create(Self);
  WebDBEdit32 := TDBEdit.Create(Self);
  WebButton22 := TButton.Create(Self);
  wpcFMSLink := TTabSheet.Create(Self);
  WebPanel15 := TPanel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  WebLabel29 := TLabel.Create(Self);
  WebLabel30 := TLabel.Create(Self);
  WebDBCheckBox14 := TDBCheckBox.Create(Self);
  WebDBEdit34 := TDBEdit.Create(Self);
  WebDBEdit35 := TDBEdit.Create(Self);
  WebButton30 := TButton.Create(Self);
  WebDBEdit31 := TDBEdit.Create(Self);
  WebButton15 := TButton.Create(Self);
  WebButton23 := TButton.Create(Self);
  WebButton24 := TButton.Create(Self);
  wpcShiptechLink := TTabSheet.Create(Self);
  WebPanel16 := TPanel.Create(Self);
  WebLabel31 := TLabel.Create(Self);
  WebLabel32 := TLabel.Create(Self);
  WebLabel33 := TLabel.Create(Self);
  WebDBCheckBox15 := TDBCheckBox.Create(Self);
  WebDBEdit37 := TDBEdit.Create(Self);
  WebDBEdit38 := TDBEdit.Create(Self);
  WebDBEdit39 := TDBEdit.Create(Self);
  WebButton31 := TButton.Create(Self);
  WebButton32 := TButton.Create(Self);
  WebButton33 := TButton.Create(Self);
  wpcFuelULink := TTabSheet.Create(Self);
  WebPanel17 := TPanel.Create(Self);
  WebLabel34 := TLabel.Create(Self);
  WebLabel35 := TLabel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebDBCheckBox16 := TDBCheckBox.Create(Self);
  WebDBEdit40 := TDBEdit.Create(Self);
  WebDBEdit41 := TDBEdit.Create(Self);
  WebDBEdit42 := TDBEdit.Create(Self);
  WebButton34 := TButton.Create(Self);
  WebButton35 := TButton.Create(Self);
  WebButton36 := TButton.Create(Self);
  WebButton40 := TButton.Create(Self);
  wpcXFuelsLink := TTabSheet.Create(Self);
  WebPanel24 := TPanel.Create(Self);
  WebLabel38 := TLabel.Create(Self);
  WebLabel39 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  WebDBCheckBox17 := TDBCheckBox.Create(Self);
  WebDBEdit43 := TDBEdit.Create(Self);
  WebDBEdit44 := TDBEdit.Create(Self);
  WebButton38 := TButton.Create(Self);
  WebButton37 := TButton.Create(Self);
  WebDBEdit45 := TDBEdit.Create(Self);
  WebButton39 := TButton.Create(Self);
  WebPanel25 := TPanel.Create(Self);
  WebButton19 := TButton.Create(Self);
  btnSaveDepotInfoThirdParty := TButton.Create(Self);
  WebPageControl1Sheet4 := TTabSheet.Create(Self);
  WebPanel18 := TPanel.Create(Self);
  WebPanel19 := TPanel.Create(Self);
  WebPanel21 := TPanel.Create(Self);
  WebLabel40 := TLabel.Create(Self);
  WebButton44 := TButton.Create(Self);
  edtDepotSearch := TEdit.Create(Self);
  dgDepots := TTMSFNCDataGrid.Create(Self);
  dgdbaDieselDepots := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel22 := TPanel.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  edtDieselDepotsPC := TEdit.Create(Self);
  WebPanel20 := TPanel.Create(Self);
  WebPanel23 := TPanel.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton12 := TSpeedButton.Create(Self);
  edtDepotPriceList := TEdit.Create(Self);
  TMSFNCDataGrid3 := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter1 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  dgdbaDepotPriceListView := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  btnInsertDepot := TButton.Create(Self);
  btnEditDepot := TButton.Create(Self);
  btnSuspended := TButton.Create(Self);
  cbxSuspended := TCheckBox.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebButton6 := TButton.Create(Self);
  wcDieselDepots := TXDataWebClient.Create(Self);
  wdsDieselDepots := TXDataWebDataSet.Create(Self);
  wdsDieselDepotsDEPOTCODE := TIntegerField.Create(Self);
  wdsDieselDepotsDEPOTNAME := TStringField.Create(Self);
  wdsDieselDepotsDEPOTTEL := TStringField.Create(Self);
  wdsDieselDepotsDEPOTFAX := TStringField.Create(Self);
  wdsDieselDepotsDEPOTEMAIL := TStringField.Create(Self);
  wdsDieselDepotsDEPOTCONTACTPERSONE := TStringField.Create(Self);
  wdsDieselDepotsSUSPENDED := TBooleanField.Create(Self);
  wdsDieselDepotsINVENTORYGL := TStringField.Create(Self);
  wdsDieselDepotsAUTOPRINT := TBooleanField.Create(Self);
  wdsDieselDepotsPRINTER := TStringField.Create(Self);
  wdsDieselDepotsCOSTGL := TStringField.Create(Self);
  wdsDieselDepotsSALESGL := TStringField.Create(Self);
  wdsDieselDepotsCONTROLSTOCK := TBooleanField.Create(Self);
  wdsDieselDepotsCRECODE := TStringField.Create(Self);
  wdsDieselDepotsCARDSYSTEM := TBooleanField.Create(Self);
  wdsDieselDepotsMERCHANTNO := TStringField.Create(Self);
  wdsDieselDepotsTOWN := TStringField.Create(Self);
  wdsDieselDepotsSAGEPROJECT := TStringField.Create(Self);
  wdsDieselDepotsNONSAGEEXPORT := TBooleanField.Create(Self);
  wdsDieselDepotsBOWSERCODE := TStringField.Create(Self);
  wdsDieselDepotsBULKORDERPREFIX := TStringField.Create(Self);
  wdsDieselDepotsDELVADDRESS1 := TStringField.Create(Self);
  wdsDieselDepotsDELVADDRESS2 := TStringField.Create(Self);
  wdsDieselDepotsDELVADDRESS3 := TStringField.Create(Self);
  wdsDieselDepotsDELVADDRESS4 := TStringField.Create(Self);
  wdsDieselDepotsDELVADDRESSCODE := TStringField.Create(Self);
  wdsDieselDepotstfnonlinelink := TBooleanField.Create(Self);
  wdsDieselDepotstfnsuppliercode := TStringField.Create(Self);
  wdsDieselDepotstfndepotcode := TIntegerField.Create(Self);
  wdsDieselDepotsfmsonlinelink := TBooleanField.Create(Self);
  wdsDieselDepotsfmssupplier := TStringField.Create(Self);
  wdsDieselDepotsstdepotcode := TIntegerField.Create(Self);
  wdsDieselDepotstfnproduct := TStringField.Create(Self);
  wdsDieselDepotstfnuseinvoice := TBooleanField.Create(Self);
  wdsDieselDepotsstonlinelink := TBooleanField.Create(Self);
  wdsDieselDepotsstsupplier := TStringField.Create(Self);
  wdsDieselDepotsfmsdepotcode := TIntegerField.Create(Self);
  wdsDieselDepotsstautocreateorder := TBooleanField.Create(Self);
  wdsDieselDepotsautocancelorders := TBooleanField.Create(Self);
  wdsDieselDepotsautocanceldays := TIntegerField.Create(Self);
  wdsDieselDepotsshiptechlink := TBooleanField.Create(Self);
  wdsDieselDepotsshiptechaccount := TStringField.Create(Self);
  wdsDieselDepotsshiptechdepot := TIntegerField.Create(Self);
  wdsDieselDepotssendexternalsms := TBooleanField.Create(Self);
  wdsDieselDepotswholesalelic := TStringField.Create(Self);
  wdsDieselDepotsfuelusupplier := TStringField.Create(Self);
  wdsDieselDepotsfueludepotcode := TIntegerField.Create(Self);
  wdsDieselDepotsfueluonlinelink := TBooleanField.Create(Self);
  wdsDieselDepotsfuelonlinesystem := TBooleanField.Create(Self);
  wdsDieselDepotsfuelmanmanualorders := TBooleanField.Create(Self);
  wdsDieselDepotsfuelmancardpayments := TBooleanField.Create(Self);
  wdsDieselDepotsxfuelsonlinelink := TBooleanField.Create(Self);
  wdsDieselDepotsxfuelssuppliers := TStringField.Create(Self);
  wdsDieselDepotsxfuelsdepotcode := TIntegerField.Create(Self);
  wdsDieselDepotsregion := TIntegerField.Create(Self);
  wdsDieselDepotsTFNDepotName := TStringField.Create(Self);
  wdsDieselDepotsMasterAccount := TStringField.Create(Self);
  wdsDieselDepotsTFNFuelTypeName := TStringField.Create(Self);
  wdsDieselDepotsTFNProductName := TStringField.Create(Self);
  wdsDieselDepotsSummaTechCRName := TStringField.Create(Self);
  wdsDieselDepotsstdName := TStringField.Create(Self);
  wdsDieselDepotsstFuelTypeName := TStringField.Create(Self);
  wdsDieselDepotsFMSCRName := TStringField.Create(Self);
  wdsDieselDepotsfmsDepotName := TStringField.Create(Self);
  wdsDieselDepotsfmsFuelTypeName := TStringField.Create(Self);
  wdsDieselDepotsshiptechDepotName := TStringField.Create(Self);
  wdsDieselDepotsShipTechFuelTypeName := TStringField.Create(Self);
  wdsDieselDepotsFuelUCRName := TStringField.Create(Self);
  wdsDieselDepotsFuelUDepotName := TStringField.Create(Self);
  wdsDieselDepotsFuelUFueltypeName := TStringField.Create(Self);
  wdsDieselDepotsxFuelCRName := TStringField.Create(Self);
  wdsDieselDepotsXFuelDepotName := TStringField.Create(Self);
  wdsDieselDepotsxfuelFueleName := TStringField.Create(Self);
  wdsDieselDepotsTFNCRName := TStringField.Create(Self);
  wdsDieselDepotsShiptechCRName := TStringField.Create(Self);
  wdsDieselDepotsfueltypename := TStringField.Create(Self);
  wdsDieselDepotstfninternalproduct := TIntegerField.Create(Self);
  wdsDieselDepotssummatechfueltype := TIntegerField.Create(Self);
  wdsDieselDepotsfmsfueltype := TIntegerField.Create(Self);
  wdsDieselDepotsshiptechfueltype := TIntegerField.Create(Self);
  wdsDieselDepotsfuelufueltype := TIntegerField.Create(Self);
  wdsDieselDepotsxfuelfueltype := TIntegerField.Create(Self);
  dsDieselDepots := TDataSource.Create(Self);
  wcDepotPriceList := TXDataWebClient.Create(Self);
  wdsDepotPriceList := TXDataWebDataSet.Create(Self);
  wdsDepotPriceListAUTONO := TIntegerField.Create(Self);
  wdsDepotPriceListDEPOTCODE := TIntegerField.Create(Self);
  wdsDepotPriceListCOSTPRICE := TFloatField.Create(Self);
  wdsDepotPriceListSTDPRICE := TFloatField.Create(Self);
  wdsDepotPriceListDEDSUBPRICE := TFloatField.Create(Self);
  wdsDepotPriceListSPECIALPRICE := TFloatField.Create(Self);
  wdsDepotPriceListPRICELOADBY := TStringField.Create(Self);
  wdsDepotPriceListPRICECONFIRMBY := TStringField.Create(Self);
  wdsDepotPriceListPRICECONFIRMED := TBooleanField.Create(Self);
  wdsDepotPriceListfueltype := TIntegerField.Create(Self);
  wdsDepotPriceListfueltypename := TStringField.Create(Self);
  wdsDepotPriceListFROMDATE := TStringField.Create(Self);
  wdsDepotPriceListTODATE := TStringField.Create(Self);
  wdsDepotPriceListPRICELOADDATE := TStringField.Create(Self);
  wdsDepotPriceListPRICECONFIRMDATE := TStringField.Create(Self);
  dsDepotPriceList := TDataSource.Create(Self);
  RESTClient1 := TRESTClient.Create(Self);
  wcTFNDepot := TXDataWebClient.Create(Self);
  wdsTFNDepots := TXDataWebDataSet.Create(Self);
  wdsTFNDepotsnumber := TIntegerField.Create(Self);
  wdsTFNDepotsname := TStringField.Create(Self);
  wdsTFNDepotsregion := TStringField.Create(Self);
  dsTFNDepots := TDataSource.Create(Self);
  wdsTFNProducts := TXDataWebDataSet.Create(Self);
  wdsTFNProductscode := TStringField.Create(Self);
  wdsTFNProductsname := TStringField.Create(Self);
  dsTFNProducts := TDataSource.Create(Self);
  wcTFNProduct := TXDataWebClient.Create(Self);
  wcProduct := TXDataWebClient.Create(Self);
  wdsProduct := TXDataWebDataSet.Create(Self);
  wdsProductfueltype := TIntegerField.Create(Self);
  wdsProductfueltypename := TStringField.Create(Self);
  dsProduct := TDataSource.Create(Self);
  wcUserAccess := TXDataWebClient.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  TempLabel.BeforeLoadDFMValues;
  BitmapContainer1.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  WebPageControl1Sheet1.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  WebDBEdit8.BeforeLoadDFMValues;
  WebDBEdit10.BeforeLoadDFMValues;
  WebDBEdit11.BeforeLoadDFMValues;
  WebDBEdit12.BeforeLoadDFMValues;
  WebDBMemo1.BeforeLoadDFMValues;
  WebDBEdit13.BeforeLoadDFMValues;
  WebDBEdit14.BeforeLoadDFMValues;
  WebDBEdit15.BeforeLoadDFMValues;
  WebDBEdit16.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  WebDBCheckBox2.BeforeLoadDFMValues;
  WebDBCheckBox3.BeforeLoadDFMValues;
  WebDBCheckBox4.BeforeLoadDFMValues;
  WebDBCheckBox5.BeforeLoadDFMValues;
  WebDBEdit17.BeforeLoadDFMValues;
  WebGroupBox1.BeforeLoadDFMValues;
  WebDBCheckBox6.BeforeLoadDFMValues;
  WebDBCheckBox7.BeforeLoadDFMValues;
  WebDBCheckBox8.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  btnSaveDepotInfo.BeforeLoadDFMValues;
  WebButton5.BeforeLoadDFMValues;
  WebButton13.BeforeLoadDFMValues;
  dbedtMasterAccount.BeforeLoadDFMValues;
  WebPageControl1Sheet2.BeforeLoadDFMValues;
  WebPanel7.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgDepotPriceListSetup.BeforeLoadDFMValues;
  dgdbaDepotPriceListEdit.BeforeLoadDFMValues;
  msgdlgDepotPriceList.BeforeLoadDFMValues;
  WebPanel8.BeforeLoadDFMValues;
  btnNewPrice.BeforeLoadDFMValues;
  btnConfirmPrice.BeforeLoadDFMValues;
  btnOpenPrice.BeforeLoadDFMValues;
  WebPanel9.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  edtDepotPriceEdit.BeforeLoadDFMValues;
  btnSaveDepotInfoPriceList.BeforeLoadDFMValues;
  WebButton18.BeforeLoadDFMValues;
  WebPageControl1Sheet3.BeforeLoadDFMValues;
  WebPanel26.BeforeLoadDFMValues;
  WebPanel10.BeforeLoadDFMValues;
  PageControl.BeforeLoadDFMValues;
  wpcSageAccounting.BeforeLoadDFMValues;
  WebPanel11.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebDBEdit18.BeforeLoadDFMValues;
  WebDBEdit19.BeforeLoadDFMValues;
  WebDBEdit20.BeforeLoadDFMValues;
  WebDBCheckBox9.BeforeLoadDFMValues;
  WebButton12.BeforeLoadDFMValues;
  wpcBulkOrderInfo.BeforeLoadDFMValues;
  WebPanel12.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebDBEdit21.BeforeLoadDFMValues;
  WebDBEdit22.BeforeLoadDFMValues;
  WebDBEdit23.BeforeLoadDFMValues;
  WebDBEdit24.BeforeLoadDFMValues;
  WebDBEdit25.BeforeLoadDFMValues;
  WebDBEdit26.BeforeLoadDFMValues;
  wpcTFNLinkInformation.BeforeLoadDFMValues;
  WebPanel13.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebDBCheckBox10.BeforeLoadDFMValues;
  WebDBCheckBox11.BeforeLoadDFMValues;
  WebButton25.BeforeLoadDFMValues;
  dbedtTFNSupplier.BeforeLoadDFMValues;
  WebDBEdit27.BeforeLoadDFMValues;
  WebDBEdit28.BeforeLoadDFMValues;
  WebDBEdit29.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebButton7.BeforeLoadDFMValues;
  WebButton10.BeforeLoadDFMValues;
  WebButton16.BeforeLoadDFMValues;
  wpcSummatechLink.BeforeLoadDFMValues;
  WebPanel14.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebButton26.BeforeLoadDFMValues;
  WebDBCheckBox12.BeforeLoadDFMValues;
  WebDBCheckBox13.BeforeLoadDFMValues;
  WebButton14.BeforeLoadDFMValues;
  WebDBEdit30.BeforeLoadDFMValues;
  WebDBEdit9.BeforeLoadDFMValues;
  WebButton21.BeforeLoadDFMValues;
  WebDBEdit32.BeforeLoadDFMValues;
  WebButton22.BeforeLoadDFMValues;
  wpcFMSLink.BeforeLoadDFMValues;
  WebPanel15.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebDBCheckBox14.BeforeLoadDFMValues;
  WebDBEdit34.BeforeLoadDFMValues;
  WebDBEdit35.BeforeLoadDFMValues;
  WebButton30.BeforeLoadDFMValues;
  WebDBEdit31.BeforeLoadDFMValues;
  WebButton15.BeforeLoadDFMValues;
  WebButton23.BeforeLoadDFMValues;
  WebButton24.BeforeLoadDFMValues;
  wpcShiptechLink.BeforeLoadDFMValues;
  WebPanel16.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  WebDBCheckBox15.BeforeLoadDFMValues;
  WebDBEdit37.BeforeLoadDFMValues;
  WebDBEdit38.BeforeLoadDFMValues;
  WebDBEdit39.BeforeLoadDFMValues;
  WebButton31.BeforeLoadDFMValues;
  WebButton32.BeforeLoadDFMValues;
  WebButton33.BeforeLoadDFMValues;
  wpcFuelULink.BeforeLoadDFMValues;
  WebPanel17.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel35.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebDBCheckBox16.BeforeLoadDFMValues;
  WebDBEdit40.BeforeLoadDFMValues;
  WebDBEdit41.BeforeLoadDFMValues;
  WebDBEdit42.BeforeLoadDFMValues;
  WebButton34.BeforeLoadDFMValues;
  WebButton35.BeforeLoadDFMValues;
  WebButton36.BeforeLoadDFMValues;
  WebButton40.BeforeLoadDFMValues;
  wpcXFuelsLink.BeforeLoadDFMValues;
  WebPanel24.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  WebLabel39.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  WebDBCheckBox17.BeforeLoadDFMValues;
  WebDBEdit43.BeforeLoadDFMValues;
  WebDBEdit44.BeforeLoadDFMValues;
  WebButton38.BeforeLoadDFMValues;
  WebButton37.BeforeLoadDFMValues;
  WebDBEdit45.BeforeLoadDFMValues;
  WebButton39.BeforeLoadDFMValues;
  WebPanel25.BeforeLoadDFMValues;
  WebButton19.BeforeLoadDFMValues;
  btnSaveDepotInfoThirdParty.BeforeLoadDFMValues;
  WebPageControl1Sheet4.BeforeLoadDFMValues;
  WebPanel18.BeforeLoadDFMValues;
  WebPanel19.BeforeLoadDFMValues;
  WebPanel21.BeforeLoadDFMValues;
  WebLabel40.BeforeLoadDFMValues;
  WebButton44.BeforeLoadDFMValues;
  edtDepotSearch.BeforeLoadDFMValues;
  dgDepots.BeforeLoadDFMValues;
  dgdbaDieselDepots.BeforeLoadDFMValues;
  WebPanel22.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  edtDieselDepotsPC.BeforeLoadDFMValues;
  WebPanel20.BeforeLoadDFMValues;
  WebPanel23.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton12.BeforeLoadDFMValues;
  edtDepotPriceList.BeforeLoadDFMValues;
  TMSFNCDataGrid3.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter1.BeforeLoadDFMValues;
  dgdbaDepotPriceListView.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  btnInsertDepot.BeforeLoadDFMValues;
  btnEditDepot.BeforeLoadDFMValues;
  btnSuspended.BeforeLoadDFMValues;
  cbxSuspended.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebButton6.BeforeLoadDFMValues;
  wcDieselDepots.BeforeLoadDFMValues;
  wdsDieselDepots.BeforeLoadDFMValues;
  wdsDieselDepotsDEPOTCODE.BeforeLoadDFMValues;
  wdsDieselDepotsDEPOTNAME.BeforeLoadDFMValues;
  wdsDieselDepotsDEPOTTEL.BeforeLoadDFMValues;
  wdsDieselDepotsDEPOTFAX.BeforeLoadDFMValues;
  wdsDieselDepotsDEPOTEMAIL.BeforeLoadDFMValues;
  wdsDieselDepotsDEPOTCONTACTPERSONE.BeforeLoadDFMValues;
  wdsDieselDepotsSUSPENDED.BeforeLoadDFMValues;
  wdsDieselDepotsINVENTORYGL.BeforeLoadDFMValues;
  wdsDieselDepotsAUTOPRINT.BeforeLoadDFMValues;
  wdsDieselDepotsPRINTER.BeforeLoadDFMValues;
  wdsDieselDepotsCOSTGL.BeforeLoadDFMValues;
  wdsDieselDepotsSALESGL.BeforeLoadDFMValues;
  wdsDieselDepotsCONTROLSTOCK.BeforeLoadDFMValues;
  wdsDieselDepotsCRECODE.BeforeLoadDFMValues;
  wdsDieselDepotsCARDSYSTEM.BeforeLoadDFMValues;
  wdsDieselDepotsMERCHANTNO.BeforeLoadDFMValues;
  wdsDieselDepotsTOWN.BeforeLoadDFMValues;
  wdsDieselDepotsSAGEPROJECT.BeforeLoadDFMValues;
  wdsDieselDepotsNONSAGEEXPORT.BeforeLoadDFMValues;
  wdsDieselDepotsBOWSERCODE.BeforeLoadDFMValues;
  wdsDieselDepotsBULKORDERPREFIX.BeforeLoadDFMValues;
  wdsDieselDepotsDELVADDRESS1.BeforeLoadDFMValues;
  wdsDieselDepotsDELVADDRESS2.BeforeLoadDFMValues;
  wdsDieselDepotsDELVADDRESS3.BeforeLoadDFMValues;
  wdsDieselDepotsDELVADDRESS4.BeforeLoadDFMValues;
  wdsDieselDepotsDELVADDRESSCODE.BeforeLoadDFMValues;
  wdsDieselDepotstfnonlinelink.BeforeLoadDFMValues;
  wdsDieselDepotstfnsuppliercode.BeforeLoadDFMValues;
  wdsDieselDepotstfndepotcode.BeforeLoadDFMValues;
  wdsDieselDepotsfmsonlinelink.BeforeLoadDFMValues;
  wdsDieselDepotsfmssupplier.BeforeLoadDFMValues;
  wdsDieselDepotsstdepotcode.BeforeLoadDFMValues;
  wdsDieselDepotstfnproduct.BeforeLoadDFMValues;
  wdsDieselDepotstfnuseinvoice.BeforeLoadDFMValues;
  wdsDieselDepotsstonlinelink.BeforeLoadDFMValues;
  wdsDieselDepotsstsupplier.BeforeLoadDFMValues;
  wdsDieselDepotsfmsdepotcode.BeforeLoadDFMValues;
  wdsDieselDepotsstautocreateorder.BeforeLoadDFMValues;
  wdsDieselDepotsautocancelorders.BeforeLoadDFMValues;
  wdsDieselDepotsautocanceldays.BeforeLoadDFMValues;
  wdsDieselDepotsshiptechlink.BeforeLoadDFMValues;
  wdsDieselDepotsshiptechaccount.BeforeLoadDFMValues;
  wdsDieselDepotsshiptechdepot.BeforeLoadDFMValues;
  wdsDieselDepotssendexternalsms.BeforeLoadDFMValues;
  wdsDieselDepotswholesalelic.BeforeLoadDFMValues;
  wdsDieselDepotsfuelusupplier.BeforeLoadDFMValues;
  wdsDieselDepotsfueludepotcode.BeforeLoadDFMValues;
  wdsDieselDepotsfueluonlinelink.BeforeLoadDFMValues;
  wdsDieselDepotsfuelonlinesystem.BeforeLoadDFMValues;
  wdsDieselDepotsfuelmanmanualorders.BeforeLoadDFMValues;
  wdsDieselDepotsfuelmancardpayments.BeforeLoadDFMValues;
  wdsDieselDepotsxfuelsonlinelink.BeforeLoadDFMValues;
  wdsDieselDepotsxfuelssuppliers.BeforeLoadDFMValues;
  wdsDieselDepotsxfuelsdepotcode.BeforeLoadDFMValues;
  wdsDieselDepotsregion.BeforeLoadDFMValues;
  wdsDieselDepotsTFNDepotName.BeforeLoadDFMValues;
  wdsDieselDepotsMasterAccount.BeforeLoadDFMValues;
  wdsDieselDepotsTFNFuelTypeName.BeforeLoadDFMValues;
  wdsDieselDepotsTFNProductName.BeforeLoadDFMValues;
  wdsDieselDepotsSummaTechCRName.BeforeLoadDFMValues;
  wdsDieselDepotsstdName.BeforeLoadDFMValues;
  wdsDieselDepotsstFuelTypeName.BeforeLoadDFMValues;
  wdsDieselDepotsFMSCRName.BeforeLoadDFMValues;
  wdsDieselDepotsfmsDepotName.BeforeLoadDFMValues;
  wdsDieselDepotsfmsFuelTypeName.BeforeLoadDFMValues;
  wdsDieselDepotsshiptechDepotName.BeforeLoadDFMValues;
  wdsDieselDepotsShipTechFuelTypeName.BeforeLoadDFMValues;
  wdsDieselDepotsFuelUCRName.BeforeLoadDFMValues;
  wdsDieselDepotsFuelUDepotName.BeforeLoadDFMValues;
  wdsDieselDepotsFuelUFueltypeName.BeforeLoadDFMValues;
  wdsDieselDepotsxFuelCRName.BeforeLoadDFMValues;
  wdsDieselDepotsXFuelDepotName.BeforeLoadDFMValues;
  wdsDieselDepotsxfuelFueleName.BeforeLoadDFMValues;
  wdsDieselDepotsTFNCRName.BeforeLoadDFMValues;
  wdsDieselDepotsShiptechCRName.BeforeLoadDFMValues;
  wdsDieselDepotsfueltypename.BeforeLoadDFMValues;
  wdsDieselDepotstfninternalproduct.BeforeLoadDFMValues;
  wdsDieselDepotssummatechfueltype.BeforeLoadDFMValues;
  wdsDieselDepotsfmsfueltype.BeforeLoadDFMValues;
  wdsDieselDepotsshiptechfueltype.BeforeLoadDFMValues;
  wdsDieselDepotsfuelufueltype.BeforeLoadDFMValues;
  wdsDieselDepotsxfuelfueltype.BeforeLoadDFMValues;
  dsDieselDepots.BeforeLoadDFMValues;
  wcDepotPriceList.BeforeLoadDFMValues;
  wdsDepotPriceList.BeforeLoadDFMValues;
  wdsDepotPriceListAUTONO.BeforeLoadDFMValues;
  wdsDepotPriceListDEPOTCODE.BeforeLoadDFMValues;
  wdsDepotPriceListCOSTPRICE.BeforeLoadDFMValues;
  wdsDepotPriceListSTDPRICE.BeforeLoadDFMValues;
  wdsDepotPriceListDEDSUBPRICE.BeforeLoadDFMValues;
  wdsDepotPriceListSPECIALPRICE.BeforeLoadDFMValues;
  wdsDepotPriceListPRICELOADBY.BeforeLoadDFMValues;
  wdsDepotPriceListPRICECONFIRMBY.BeforeLoadDFMValues;
  wdsDepotPriceListPRICECONFIRMED.BeforeLoadDFMValues;
  wdsDepotPriceListfueltype.BeforeLoadDFMValues;
  wdsDepotPriceListfueltypename.BeforeLoadDFMValues;
  wdsDepotPriceListFROMDATE.BeforeLoadDFMValues;
  wdsDepotPriceListTODATE.BeforeLoadDFMValues;
  wdsDepotPriceListPRICELOADDATE.BeforeLoadDFMValues;
  wdsDepotPriceListPRICECONFIRMDATE.BeforeLoadDFMValues;
  dsDepotPriceList.BeforeLoadDFMValues;
  RESTClient1.BeforeLoadDFMValues;
  wcTFNDepot.BeforeLoadDFMValues;
  wdsTFNDepots.BeforeLoadDFMValues;
  wdsTFNDepotsnumber.BeforeLoadDFMValues;
  wdsTFNDepotsname.BeforeLoadDFMValues;
  wdsTFNDepotsregion.BeforeLoadDFMValues;
  dsTFNDepots.BeforeLoadDFMValues;
  wdsTFNProducts.BeforeLoadDFMValues;
  wdsTFNProductscode.BeforeLoadDFMValues;
  wdsTFNProductsname.BeforeLoadDFMValues;
  dsTFNProducts.BeforeLoadDFMValues;
  wcTFNProduct.BeforeLoadDFMValues;
  wcProduct.BeforeLoadDFMValues;
  wdsProduct.BeforeLoadDFMValues;
  wdsProductfueltype.BeforeLoadDFMValues;
  wdsProductfueltypename.BeforeLoadDFMValues;
  dsProduct.BeforeLoadDFMValues;
  wcUserAccess.BeforeLoadDFMValues;
  try
    Name := 'frmDieselDepots';
    Width := 935;
    Height := 780;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 935;
    WebPanel1.Height := 780;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 935;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Diesel Depots';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    TempLabel.SetParentComponent(WebPanel2);
    TempLabel.Name := 'TempLabel';
    TempLabel.Left := 24;
    TempLabel.Top := 11;
    TempLabel.Width := 83;
    TempLabel.Height := 21;
    TempLabel.Caption := 'TempLabel';
    TempLabel.HeightPercent := 100.000000000000000000;
    TempLabel.WidthPercent := 100.000000000000000000;
    BitmapContainer1.SetParentComponent(WebPanel2);
    BitmapContainer1.Name := 'BitmapContainer1';
    BitmapContainer1.Left := 822;
    BitmapContainer1.Top := 11;
    BitmapContainer1.Width := 26;
    BitmapContainer1.Height := 26;
    BitmapContainer1.Visible := True;
    BitmapContainer1.Items.Clear;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('DieselDepots.BitmapContainer1.Items.Bitmap.svg');
      Name := 'delete.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('DieselDepots.BitmapContainer1.Items.Bitmap_1.svg');
      Name := 'edit.svg';
      Tag := 0;
    end;
    WebPageControl1.SetParentComponent(WebPanel1);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 0;
    WebPageControl1.Top := 120;
    WebPageControl1.Width := 935;
    WebPageControl1.Height := 600;
    WebPageControl1.Align := alClient;
    WebPageControl1.ChildOrder := 1;
    WebPageControl1.TabIndex := 0;
    WebPageControl1.TabOrder := 1;
    WebPageControl1Sheet1.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet1.Name := 'WebPageControl1Sheet1';
    WebPageControl1Sheet1.Left := 0;
    WebPageControl1Sheet1.Top := 20;
    WebPageControl1Sheet1.Width := 935;
    WebPageControl1Sheet1.Height := 580;
    WebPageControl1Sheet1.Caption := 'WebPageControl1Sheet1';
    WebPanel5.SetParentComponent(WebPageControl1Sheet1);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 0;
    WebPanel5.Top := 0;
    WebPanel5.Width := 935;
    WebPanel5.Height := 580;
    WebPanel5.Align := alClient;
    WebPanel5.TabOrder := 0;
    WebLabel2.SetParentComponent(WebPanel5);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 24;
    WebLabel2.Top := 11;
    WebLabel2.Width := 70;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Depot Name:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel5);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 480;
    WebLabel3.Top := 11;
    WebLabel3.Width := 80;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Depot Address:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel5);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 480;
    WebLabel4.Top := 139;
    WebLabel4.Width := 99;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Wholesale License:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel5);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 24;
    WebLabel5.Top := 60;
    WebLabel5.Width := 111;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Inventory Item Code:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.Visible := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel5);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 24;
    WebLabel6.Top := 108;
    WebLabel6.Width := 87;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Master Account:';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel5);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 24;
    WebLabel7.Top := 156;
    WebLabel7.Width := 84;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'Contact Person:';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel5);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 24;
    WebLabel8.Top := 204;
    WebLabel8.Width := 68;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'Tell Number:';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebPanel5);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 240;
    WebLabel9.Top := 204;
    WebLabel9.Width := 62;
    WebLabel9.Height := 15;
    WebLabel9.Caption := 'Fax number';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebPanel5);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 480;
    WebLabel1.Top := 204;
    WebLabel1.Width := 60;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Fuel Zones:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel5);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 24;
    WebLabel10.Top := 260;
    WebLabel10.Width := 37;
    WebLabel10.Height := 15;
    WebLabel10.Caption := 'E-Mail:';
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WebPanel5);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 24;
    WebLabel11.Top := 391;
    WebLabel11.Width := 76;
    WebLabel11.Height := 15;
    WebLabel11.Caption := 'Merchand No:';
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WebPanel5);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 24;
    WebLabel12.Top := 440;
    WebLabel12.Width := 32;
    WebLabel12.Height := 15;
    WebLabel12.Caption := 'Town:';
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(WebPanel5);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 288;
    WebLabel13.Top := 392;
    WebLabel13.Width := 35;
    WebLabel13.Height := 15;
    WebLabel13.Caption := 'Printer';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WebPanel5);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 287;
    WebLabel14.Top := 440;
    WebLabel14.Width := 76;
    WebLabel14.Height := 15;
    WebLabel14.Caption := 'Browser Code:';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel5);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 481;
    WebLabel15.Top := 376;
    WebLabel15.Width := 95;
    WebLabel15.Height := 15;
    WebLabel15.Caption := 'Auto Cancel days:';
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebButton1.SetParentComponent(WebPanel5);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 287;
    WebButton1.Top := 80;
    WebButton1.Width := 25;
    WebButton1.Height := 25;
    WebButton1.Caption := '...';
    WebButton1.ChildOrder := 9;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.Visible := False;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.SetParentComponent(WebPanel5);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 480;
    WebDBEdit1.Top := 32;
    WebDBEdit1.Width := 265;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 10;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'DELVADDRESS1';
    WebDBEdit1.DataSource := dsDieselDepots;
    WebDBEdit2.SetParentComponent(WebPanel5);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 480;
    WebDBEdit2.Top := 60;
    WebDBEdit2.Width := 265;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 11;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.Text := 'WebDBEdit2';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'DELVADDRESS2';
    WebDBEdit2.DataSource := dsDieselDepots;
    WebDBEdit3.SetParentComponent(WebPanel5);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 480;
    WebDBEdit3.Top := 88;
    WebDBEdit3.Width := 265;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 12;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'DELVADDRESS3';
    WebDBEdit3.DataSource := dsDieselDepots;
    WebDBEdit4.SetParentComponent(WebPanel5);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 480;
    WebDBEdit4.Top := 116;
    WebDBEdit4.Width := 121;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 13;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit4';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'DELVADDRESSCODE';
    WebDBEdit4.DataSource := dsDieselDepots;
    WebDBEdit5.SetParentComponent(WebPanel5);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 480;
    WebDBEdit5.Top := 160;
    WebDBEdit5.Width := 345;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 14;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit5';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'wholesalelic';
    WebDBEdit5.DataSource := dsDieselDepots;
    WebDBEdit6.SetParentComponent(WebPanel5);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 240;
    WebDBEdit6.Top := 225;
    WebDBEdit6.Width := 185;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 15;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.Text := 'WebDBEdit6';
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit6.DataField := 'DEPOTFAX';
    WebDBEdit6.DataSource := dsDieselDepots;
    WebDBEdit7.SetParentComponent(WebPanel5);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 24;
    WebDBEdit7.Top := 225;
    WebDBEdit7.Width := 161;
    WebDBEdit7.Height := 22;
    WebDBEdit7.ChildOrder := 16;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.Text := 'WebDBEdit7';
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit7.DataField := 'DEPOTTEL';
    WebDBEdit7.DataSource := dsDieselDepots;
    WebDBEdit8.SetParentComponent(WebPanel5);
    WebDBEdit8.Name := 'WebDBEdit8';
    WebDBEdit8.Left := 24;
    WebDBEdit8.Top := 177;
    WebDBEdit8.Width := 185;
    WebDBEdit8.Height := 22;
    WebDBEdit8.ChildOrder := 17;
    WebDBEdit8.HeightPercent := 100.000000000000000000;
    WebDBEdit8.Text := 'WebDBEdit8';
    WebDBEdit8.WidthPercent := 100.000000000000000000;
    WebDBEdit8.DataField := 'DEPOTCONTACTPERSONE';
    WebDBEdit8.DataSource := dsDieselDepots;
    WebDBEdit10.SetParentComponent(WebPanel5);
    WebDBEdit10.Name := 'WebDBEdit10';
    WebDBEdit10.Left := 24;
    WebDBEdit10.Top := 81;
    WebDBEdit10.Width := 257;
    WebDBEdit10.Height := 22;
    WebDBEdit10.ChildOrder := 19;
    WebDBEdit10.HeightPercent := 100.000000000000000000;
    WebDBEdit10.Text := 'WebDBEdit10';
    WebDBEdit10.Visible := False;
    WebDBEdit10.WidthPercent := 100.000000000000000000;
    WebDBEdit10.DataField := 'INVENTORYGL';
    WebDBEdit10.DataSource := dsDieselDepots;
    WebDBEdit11.SetParentComponent(WebPanel5);
    WebDBEdit11.Name := 'WebDBEdit11';
    WebDBEdit11.Left := 24;
    WebDBEdit11.Top := 32;
    WebDBEdit11.Width := 369;
    WebDBEdit11.Height := 22;
    WebDBEdit11.ChildOrder := 20;
    WebDBEdit11.HeightPercent := 100.000000000000000000;
    WebDBEdit11.Text := 'WebDBEdit11';
    WebDBEdit11.WidthPercent := 100.000000000000000000;
    WebDBEdit11.DataField := 'DEPOTNAME';
    WebDBEdit11.DataSource := dsDieselDepots;
    WebDBEdit12.SetParentComponent(WebPanel5);
    WebDBEdit12.Name := 'WebDBEdit12';
    WebDBEdit12.Left := 480;
    WebDBEdit12.Top := 225;
    WebDBEdit12.Width := 177;
    WebDBEdit12.Height := 22;
    WebDBEdit12.ChildOrder := 21;
    WebDBEdit12.HeightPercent := 100.000000000000000000;
    WebDBEdit12.Text := 'WebDBEdit12';
    WebDBEdit12.WidthPercent := 100.000000000000000000;
    WebDBEdit12.DataField := 'region';
    WebDBEdit12.DataSource := dsDieselDepots;
    WebDBMemo1.SetParentComponent(WebPanel5);
    WebDBMemo1.Name := 'WebDBMemo1';
    WebDBMemo1.Left := 24;
    WebDBMemo1.Top := 281;
    WebDBMemo1.Width := 217;
    WebDBMemo1.Height := 89;
    WebDBMemo1.HeightPercent := 100.000000000000000000;
    WebDBMemo1.Lines.BeginUpdate;
    try
      WebDBMemo1.Lines.Clear;
      WebDBMemo1.Lines.Add('WebDBMemo1');
    finally
      WebDBMemo1.Lines.EndUpdate;
    end;
    WebDBMemo1.SelLength := 0;
    WebDBMemo1.SelStart := 0;
    WebDBMemo1.WidthPercent := 100.000000000000000000;
    WebDBMemo1.DataField := 'DEPOTEMAIL';
    WebDBMemo1.DataSource := dsDieselDepots;
    WebDBEdit13.SetParentComponent(WebPanel5);
    WebDBEdit13.Name := 'WebDBEdit13';
    WebDBEdit13.Left := 24;
    WebDBEdit13.Top := 412;
    WebDBEdit13.Width := 217;
    WebDBEdit13.Height := 22;
    WebDBEdit13.ChildOrder := 24;
    WebDBEdit13.HeightPercent := 100.000000000000000000;
    WebDBEdit13.Text := 'WebDBEdit13';
    WebDBEdit13.WidthPercent := 100.000000000000000000;
    WebDBEdit13.DataField := 'MERCHANTNO';
    WebDBEdit13.DataSource := dsDieselDepots;
    WebDBEdit14.SetParentComponent(WebPanel5);
    WebDBEdit14.Name := 'WebDBEdit14';
    WebDBEdit14.Left := 24;
    WebDBEdit14.Top := 456;
    WebDBEdit14.Width := 217;
    WebDBEdit14.Height := 22;
    WebDBEdit14.ChildOrder := 25;
    WebDBEdit14.HeightPercent := 100.000000000000000000;
    WebDBEdit14.Text := 'WebDBEdit14';
    WebDBEdit14.WidthPercent := 100.000000000000000000;
    WebDBEdit14.DataField := 'TOWN';
    WebDBEdit14.DataSource := dsDieselDepots;
    WebDBEdit15.SetParentComponent(WebPanel5);
    WebDBEdit15.Name := 'WebDBEdit15';
    WebDBEdit15.Left := 287;
    WebDBEdit15.Top := 456;
    WebDBEdit15.Width := 227;
    WebDBEdit15.Height := 22;
    WebDBEdit15.ChildOrder := 26;
    WebDBEdit15.HeightPercent := 100.000000000000000000;
    WebDBEdit15.Text := 'WebDBEdit15';
    WebDBEdit15.WidthPercent := 100.000000000000000000;
    WebDBEdit15.DataField := 'BOWSERCODE';
    WebDBEdit15.DataSource := dsDieselDepots;
    WebDBEdit16.SetParentComponent(WebPanel5);
    WebDBEdit16.Name := 'WebDBEdit16';
    WebDBEdit16.Left := 287;
    WebDBEdit16.Top := 412;
    WebDBEdit16.Width := 227;
    WebDBEdit16.Height := 22;
    WebDBEdit16.ChildOrder := 27;
    WebDBEdit16.HeightPercent := 100.000000000000000000;
    WebDBEdit16.Text := 'WebDBEdit16';
    WebDBEdit16.WidthPercent := 100.000000000000000000;
    WebDBEdit16.DataField := 'PRINTER';
    WebDBEdit16.DataSource := dsDieselDepots;
    WebButton3.SetParentComponent(WebPanel5);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 520;
    WebButton3.Top := 412;
    WebButton3.Width := 25;
    WebButton3.Height := 25;
    WebButton3.Caption := '...';
    WebButton3.ChildOrder := 33;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.SetParentComponent(WebPanel5);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 288;
    WebDBCheckBox1.Top := 360;
    WebDBCheckBox1.Width := 113;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := 'Auto print';
    WebDBCheckBox1.ChildOrder := 34;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox1, Self, 'OnClick', 'WebDBCheckBox1Click');
    WebDBCheckBox1.DataField := 'AUTOPRINT';
    WebDBCheckBox1.DataSource := dsDieselDepots;
    WebDBCheckBox2.SetParentComponent(WebPanel5);
    WebDBCheckBox2.Name := 'WebDBCheckBox2';
    WebDBCheckBox2.Left := 480;
    WebDBCheckBox2.Top := 253;
    WebDBCheckBox2.Width := 113;
    WebDBCheckBox2.Height := 22;
    WebDBCheckBox2.Caption := 'Card System';
    WebDBCheckBox2.ChildOrder := 35;
    WebDBCheckBox2.HeightPercent := 100.000000000000000000;
    WebDBCheckBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox2, Self, 'OnClick', 'WebDBCheckBox2Click');
    WebDBCheckBox2.DataField := 'CARDSYSTEM';
    WebDBCheckBox2.DataSource := dsDieselDepots;
    WebDBCheckBox3.SetParentComponent(WebPanel5);
    WebDBCheckBox3.Name := 'WebDBCheckBox3';
    WebDBCheckBox3.Left := 480;
    WebDBCheckBox3.Top := 281;
    WebDBCheckBox3.Width := 113;
    WebDBCheckBox3.Height := 22;
    WebDBCheckBox3.Caption := 'Stock Control';
    WebDBCheckBox3.ChildOrder := 36;
    WebDBCheckBox3.HeightPercent := 100.000000000000000000;
    WebDBCheckBox3.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox3, Self, 'OnClick', 'WebDBCheckBox3Click');
    WebDBCheckBox3.DataField := 'CONTROLSTOCK';
    WebDBCheckBox3.DataSource := dsDieselDepots;
    WebDBCheckBox4.SetParentComponent(WebPanel5);
    WebDBCheckBox4.Name := 'WebDBCheckBox4';
    WebDBCheckBox4.Left := 480;
    WebDBCheckBox4.Top := 309;
    WebDBCheckBox4.Width := 121;
    WebDBCheckBox4.Height := 22;
    WebDBCheckBox4.Caption := 'Send External SMS';
    WebDBCheckBox4.ChildOrder := 37;
    WebDBCheckBox4.HeightPercent := 100.000000000000000000;
    WebDBCheckBox4.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox4, Self, 'OnClick', 'WebDBCheckBox4Click');
    WebDBCheckBox4.DataField := 'sendexternalsms';
    WebDBCheckBox4.DataSource := dsDieselDepots;
    WebDBCheckBox5.SetParentComponent(WebPanel5);
    WebDBCheckBox5.Name := 'WebDBCheckBox5';
    WebDBCheckBox5.Left := 480;
    WebDBCheckBox5.Top := 337;
    WebDBCheckBox5.Width := 113;
    WebDBCheckBox5.Height := 22;
    WebDBCheckBox5.Caption := 'Auto Cancel Orders';
    WebDBCheckBox5.ChildOrder := 38;
    WebDBCheckBox5.HeightPercent := 100.000000000000000000;
    WebDBCheckBox5.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox5, Self, 'OnClick', 'WebDBCheckBox5Click');
    WebDBCheckBox5.DataField := 'autocancelorders';
    WebDBCheckBox5.DataSource := dsDieselDepots;
    WebDBEdit17.SetParentComponent(WebPanel5);
    WebDBEdit17.Name := 'WebDBEdit17';
    WebDBEdit17.Left := 582;
    WebDBEdit17.Top := 373;
    WebDBEdit17.Width := 35;
    WebDBEdit17.Height := 22;
    WebDBEdit17.ChildOrder := 40;
    WebDBEdit17.HeightPercent := 100.000000000000000000;
    WebDBEdit17.WidthPercent := 100.000000000000000000;
    WebDBEdit17.DataField := 'autocanceldays';
    WebDBEdit17.DataSource := dsDieselDepots;
    WebGroupBox1.SetParentComponent(WebPanel5);
    WebGroupBox1.Name := 'WebGroupBox1';
    WebGroupBox1.Left := 663;
    WebGroupBox1.Top := 253;
    WebGroupBox1.Width := 209;
    WebGroupBox1.Height := 116;
    WebGroupBox1.BorderColor := clSilver;
    WebGroupBox1.Caption := 'Fuel Man System';
    WebGroupBox1.ChildOrder := 41;
    WebDBCheckBox6.SetParentComponent(WebGroupBox1);
    WebDBCheckBox6.Name := 'WebDBCheckBox6';
    WebDBCheckBox6.Left := 40;
    WebDBCheckBox6.Top := 24;
    WebDBCheckBox6.Width := 113;
    WebDBCheckBox6.Height := 22;
    WebDBCheckBox6.Caption := 'Online System';
    WebDBCheckBox6.HeightPercent := 100.000000000000000000;
    WebDBCheckBox6.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox6, Self, 'OnClick', 'WebDBCheckBox6Click');
    WebDBCheckBox6.DataField := 'fuelonlinesystem';
    WebDBCheckBox6.DataSource := dsDieselDepots;
    WebDBCheckBox7.SetParentComponent(WebGroupBox1);
    WebDBCheckBox7.Name := 'WebDBCheckBox7';
    WebDBCheckBox7.Left := 40;
    WebDBCheckBox7.Top := 52;
    WebDBCheckBox7.Width := 145;
    WebDBCheckBox7.Height := 22;
    WebDBCheckBox7.Caption := 'Allow Manual Orders';
    WebDBCheckBox7.ChildOrder := 1;
    WebDBCheckBox7.HeightPercent := 100.000000000000000000;
    WebDBCheckBox7.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox7, Self, 'OnClick', 'WebDBCheckBox7Click');
    WebDBCheckBox7.DataField := 'fuelmanmanualorders';
    WebDBCheckBox7.DataSource := dsDieselDepots;
    WebDBCheckBox8.SetParentComponent(WebGroupBox1);
    WebDBCheckBox8.Name := 'WebDBCheckBox8';
    WebDBCheckBox8.Left := 40;
    WebDBCheckBox8.Top := 80;
    WebDBCheckBox8.Width := 113;
    WebDBCheckBox8.Height := 22;
    WebDBCheckBox8.Caption := 'Allow Card Payments';
    WebDBCheckBox8.ChildOrder := 2;
    WebDBCheckBox8.HeightPercent := 100.000000000000000000;
    WebDBCheckBox8.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox8, Self, 'OnClick', 'WebDBCheckBox8Click');
    WebDBCheckBox8.DataField := 'fuelmancardpayments';
    WebDBCheckBox8.DataSource := dsDieselDepots;
    WebPanel6.SetParentComponent(WebPanel5);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 520;
    WebPanel6.Width := 935;
    WebPanel6.Height := 60;
    WebPanel6.Align := alBottom;
    WebPanel6.ChildOrder := 42;
    WebPanel6.Color := clSilver;
    WebPanel6.TabOrder := 25;
    btnSaveDepotInfo.SetParentComponent(WebPanel6);
    btnSaveDepotInfo.Name := 'btnSaveDepotInfo';
    btnSaveDepotInfo.Left := 15;
    btnSaveDepotInfo.Top := 16;
    btnSaveDepotInfo.Width := 96;
    btnSaveDepotInfo.Height := 25;
    btnSaveDepotInfo.Caption := 'Save';
    btnSaveDepotInfo.Color := clGreenyellow;
    btnSaveDepotInfo.HeightPercent := 100.000000000000000000;
    btnSaveDepotInfo.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveDepotInfo, Self, 'OnClick', 'btnSaveDepotInfoClick');
    WebButton5.SetParentComponent(WebPanel6);
    WebButton5.Name := 'WebButton5';
    WebButton5.Left := 136;
    WebButton5.Top := 16;
    WebButton5.Width := 96;
    WebButton5.Height := 25;
    WebButton5.Caption := 'Cancel';
    WebButton5.Color := clRed;
    WebButton5.ChildOrder := 1;
    WebButton5.HeightPercent := 100.000000000000000000;
    WebButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton5, Self, 'OnClick', 'WebButton5Click');
    WebButton13.SetParentComponent(WebPanel5);
    WebButton13.Name := 'WebButton13';
    WebButton13.Left := 258;
    WebButton13.Top := 130;
    WebButton13.Width := 23;
    WebButton13.Height := 25;
    WebButton13.Caption := '...';
    WebButton13.ChildOrder := 43;
    WebButton13.HeightPercent := 100.000000000000000000;
    WebButton13.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton13, Self, 'OnClick', 'WebButton13Click');
    dbedtMasterAccount.SetParentComponent(WebPanel5);
    dbedtMasterAccount.Name := 'dbedtMasterAccount';
    dbedtMasterAccount.Left := 24;
    dbedtMasterAccount.Top := 128;
    dbedtMasterAccount.Width := 217;
    dbedtMasterAccount.Height := 22;
    dbedtMasterAccount.ChildOrder := 42;
    dbedtMasterAccount.HeightPercent := 100.000000000000000000;
    dbedtMasterAccount.Text := 'dbedtMasterAccount';
    dbedtMasterAccount.WidthPercent := 100.000000000000000000;
    dbedtMasterAccount.DataField := 'MasterAccount';
    dbedtMasterAccount.DataSource := dsDieselDepots;
    WebPageControl1Sheet2.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet2.Name := 'WebPageControl1Sheet2';
    WebPageControl1Sheet2.Left := 0;
    WebPageControl1Sheet2.Top := 20;
    WebPageControl1Sheet2.Width := 935;
    WebPageControl1Sheet2.Height := 580;
    WebPageControl1Sheet2.Align := alClient;
    WebPageControl1Sheet2.Caption := 'WebPageControl1Sheet2';
    WebPageControl1Sheet2.ChildOrder := 1;
    WebPanel7.SetParentComponent(WebPageControl1Sheet2);
    WebPanel7.Name := 'WebPanel7';
    WebPanel7.Left := 0;
    WebPanel7.Top := 0;
    WebPanel7.Width := 935;
    WebPanel7.Height := 580;
    WebPanel7.Align := alClient;
    WebPanel7.TabOrder := 0;
    TMSFNCDataGrid1.SetParentComponent(WebPanel7);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 54;
    TMSFNCDataGrid1.Width := 935;
    TMSFNCDataGrid1.Height := 466;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 0;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgdbaDieselDepots;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 0;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('DieselDepots.WebPanel7.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    TMSFNCDataGrid1.RowCount := 1;
    dgDepotPriceListSetup.SetParentComponent(TMSFNCDataGrid1);
    dgDepotPriceListSetup.Name := 'dgDepotPriceListSetup';
    dgDepotPriceListSetup.Left := 0;
    dgDepotPriceListSetup.Top := 0;
    dgDepotPriceListSetup.Width := 935;
    dgDepotPriceListSetup.Height := 466;
    dgDepotPriceListSetup.Align := alClient;
    dgDepotPriceListSetup.ParentDoubleBuffered := False;
    dgDepotPriceListSetup.DoubleBuffered := True;
    dgDepotPriceListSetup.TabOrder := 0;
    dgDepotPriceListSetup.ShowAcceleratorChar := False;
    dgDepotPriceListSetup.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgDepotPriceListSetup.Header.VisualGrouping.Layout.Font.Height := -12;
    dgDepotPriceListSetup.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.Header.VisualGrouping.Layout.Font.Style := [];
    dgDepotPriceListSetup.Adapter := dgdbaDepotPriceListEdit;
    dgDepotPriceListSetup.BitmapContainer := BitmapContainer1;
    dgDepotPriceListSetup.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.BandLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.BandLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.FixedLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.FixedLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.FocusedLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.FocusedLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.GroupLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.GroupLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.NormalLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.NormalLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.SelectedLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.SelectedLayout.Font.Style := [];
    dgDepotPriceListSetup.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgDepotPriceListSetup.CellAppearance.SummaryLayout.Font.Height := -12;
    dgDepotPriceListSetup.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.CellAppearance.SummaryLayout.Font.Style := [];
    dgDepotPriceListSetup.ColumnCount := 18;
    dgDepotPriceListSetup.Columns.Clear;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 25.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'AUTONO';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'DEPOTCODE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'F.Date';
      Name := 'FROMDATE';
      Settings := [gcsEditorItems];
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'T.Date';
      Name := 'TODATE';
      Settings := [gcsEditorItems];
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'C.Price';
      Name := 'COSTPRICE';
      Settings := [gcsEditorItems];
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'STD.Price';
      Name := 'STDPRICE';
      Settings := [gcsEditorItems];
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DS.Price';
      Name := 'DEDSUBPRICE';
      Settings := [gcsEditorItems];
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'S.Price';
      Name := 'SPECIALPRICE';
      Settings := [gcsEditorItems];
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICELOADDATE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICELOADBY';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICECONFIRMDATE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICECONFIRMBY';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'fueltype';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Fuel Type';
      Name := 'fueltypename';
      Settings := [gcsEditorItems];
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICECONFIRMED';
      Settings := [gcsEditorItems];
      Width := 25.000000000000000000;
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      ReadOnly := True;
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType,gcsEditorItems,gcsReadOnly];
    end;
    with dgDepotPriceListSetup.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType,gcsEditorItems];
    end;
    dgDepotPriceListSetup.Designer := False;
    dgDepotPriceListSetup.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgDepotPriceListSetup.FilterAppearance.Font.Color := clWindowText;
    dgDepotPriceListSetup.FilterAppearance.Font.Height := -12;
    dgDepotPriceListSetup.FilterAppearance.Font.Name := 'Segoe UI';
    dgDepotPriceListSetup.FilterAppearance.Font.Style := [];
    dgDepotPriceListSetup.Icons.ExpandIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.ExpandIcon.svg');
    dgDepotPriceListSetup.Icons.CollapseIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.CollapseIcon.svg');
    dgDepotPriceListSetup.Icons.FilterIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.FilterIcon.svg');
    dgDepotPriceListSetup.Icons.FilterActiveIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.FilterActiveIcon.svg');
    dgDepotPriceListSetup.Icons.FilterClearIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.FilterClearIcon.svg');
    dgDepotPriceListSetup.Icons.FilterTypeIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.FilterTypeIcon.svg');
    dgDepotPriceListSetup.Icons.SortAscendingIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.SortAscendingIcon.svg');
    dgDepotPriceListSetup.Icons.SortDescendingIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.SortDescendingIcon.svg');
    dgDepotPriceListSetup.Icons.CloseIcon.LoadFromFile('DieselDepots.TMSFNCDataGrid1.dgDepotPriceListSetup.Icons.CloseIcon.svg');
    SetEvent(dgDepotPriceListSetup, Self, 'OnCellClick', 'dgDepotPriceListSetupCellClick');
    SetEvent(dgDepotPriceListSetup, Self, 'OnGetCellLayout', 'dgDepotPriceListSetupGetCellLayout');
    SetEvent(dgDepotPriceListSetup, Self, 'OnGetCellProperties', 'dgDepotPriceListSetupGetCellProperties');
    SetEvent(dgDepotPriceListSetup, Self, 'OnSelectCell', 'dgDepotPriceListSetupSelectCell');
    dgDepotPriceListSetup.RowCount := 1;
    dgdbaDepotPriceListEdit.SetParentComponent(dgDepotPriceListSetup);
    dgdbaDepotPriceListEdit.Name := 'dgdbaDepotPriceListEdit';
    dgdbaDepotPriceListEdit.Left := 591;
    dgdbaDepotPriceListEdit.Top := 109;
    dgdbaDepotPriceListEdit.Width := 26;
    dgdbaDepotPriceListEdit.Height := 26;
    dgdbaDepotPriceListEdit.Visible := True;
    dgdbaDepotPriceListEdit.Columns.Clear;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'AUTONO';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'DEPOTCODE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'FROMDATE';
      Header := 'F.Date';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'TODATE';
      Header := 'T.Date';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'COSTPRICE';
      Header := 'C.Price';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'STDPRICE';
      Header := 'STD.Price';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'DEDSUBPRICE';
      Header := 'DS.Price';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'SPECIALPRICE';
      Header := 'S.Price';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'PRICELOADDATE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'PRICELOADBY';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMDATE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMBY';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'fueltype';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'fueltypename';
      Header := 'Fuel Type';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMED';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListEdit.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dgdbaDepotPriceListEdit.DataSource := dsDepotPriceList;
    msgdlgDepotPriceList.SetParentComponent(dgDepotPriceListSetup);
    msgdlgDepotPriceList.Name := 'msgdlgDepotPriceList';
    msgdlgDepotPriceList.Left := 664;
    msgdlgDepotPriceList.Top := 112;
    msgdlgDepotPriceList.Width := 24;
    msgdlgDepotPriceList.Height := 24;
    msgdlgDepotPriceList.Buttons := [];
    msgdlgDepotPriceList.Opacity := 0.200000000000000000;
    WebPanel8.SetParentComponent(WebPanel7);
    WebPanel8.Name := 'WebPanel8';
    WebPanel8.Left := 0;
    WebPanel8.Top := 0;
    WebPanel8.Width := 935;
    WebPanel8.Height := 54;
    WebPanel8.Align := alTop;
    WebPanel8.ChildOrder := 1;
    WebPanel8.TabOrder := 1;
    btnNewPrice.SetParentComponent(WebPanel8);
    btnNewPrice.Name := 'btnNewPrice';
    btnNewPrice.Left := 15;
    btnNewPrice.Top := 16;
    btnNewPrice.Width := 96;
    btnNewPrice.Height := 25;
    btnNewPrice.Caption := 'New Price';
    btnNewPrice.HeightPercent := 100.000000000000000000;
    btnNewPrice.WidthPercent := 100.000000000000000000;
    SetEvent(btnNewPrice, Self, 'OnClick', 'btnNewPriceClick');
    btnConfirmPrice.SetParentComponent(WebPanel8);
    btnConfirmPrice.Name := 'btnConfirmPrice';
    btnConfirmPrice.Left := 117;
    btnConfirmPrice.Top := 17;
    btnConfirmPrice.Width := 96;
    btnConfirmPrice.Height := 25;
    btnConfirmPrice.Caption := 'Confirm Price';
    btnConfirmPrice.ChildOrder := 2;
    btnConfirmPrice.HeightPercent := 100.000000000000000000;
    btnConfirmPrice.WidthPercent := 100.000000000000000000;
    SetEvent(btnConfirmPrice, Self, 'OnClick', 'btnConfirmPriceClick');
    btnOpenPrice.SetParentComponent(WebPanel8);
    btnOpenPrice.Name := 'btnOpenPrice';
    btnOpenPrice.Left := 219;
    btnOpenPrice.Top := 16;
    btnOpenPrice.Width := 96;
    btnOpenPrice.Height := 25;
    btnOpenPrice.Caption := 'Open Price';
    btnOpenPrice.ChildOrder := 4;
    btnOpenPrice.HeightPercent := 100.000000000000000000;
    btnOpenPrice.WidthPercent := 100.000000000000000000;
    SetEvent(btnOpenPrice, Self, 'OnClick', 'btnOpenPriceClick');
    WebPanel9.SetParentComponent(WebPanel7);
    WebPanel9.Name := 'WebPanel9';
    WebPanel9.Left := 0;
    WebPanel9.Top := 520;
    WebPanel9.Width := 935;
    WebPanel9.Height := 60;
    WebPanel9.Align := alBottom;
    WebPanel9.ChildOrder := 2;
    WebPanel9.Color := clSilver;
    WebPanel9.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(WebPanel9);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 353;
    WebSpeedButton1.Top := 16;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel9);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 376;
    WebSpeedButton2.Top := 16;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel9);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 464;
    WebSpeedButton3.Top := 16;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel9);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 487;
    WebSpeedButton4.Top := 16;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    edtDepotPriceEdit.SetParentComponent(WebPanel9);
    edtDepotPriceEdit.Name := 'edtDepotPriceEdit';
    edtDepotPriceEdit.Left := 399;
    edtDepotPriceEdit.Top := 16;
    edtDepotPriceEdit.Width := 66;
    edtDepotPriceEdit.Height := 22;
    edtDepotPriceEdit.ChildOrder := 4;
    edtDepotPriceEdit.HeightPercent := 100.000000000000000000;
    edtDepotPriceEdit.WidthPercent := 100.000000000000000000;
    btnSaveDepotInfoPriceList.SetParentComponent(WebPanel9);
    btnSaveDepotInfoPriceList.Name := 'btnSaveDepotInfoPriceList';
    btnSaveDepotInfoPriceList.Left := 24;
    btnSaveDepotInfoPriceList.Top := 24;
    btnSaveDepotInfoPriceList.Width := 96;
    btnSaveDepotInfoPriceList.Height := 25;
    btnSaveDepotInfoPriceList.Caption := 'Save';
    btnSaveDepotInfoPriceList.Color := clGreenyellow;
    btnSaveDepotInfoPriceList.ChildOrder := 5;
    btnSaveDepotInfoPriceList.HeightPercent := 100.000000000000000000;
    btnSaveDepotInfoPriceList.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveDepotInfoPriceList, Self, 'OnClick', 'btnSaveDepotInfoPriceListClick');
    WebButton18.SetParentComponent(WebPanel9);
    WebButton18.Name := 'WebButton18';
    WebButton18.Left := 145;
    WebButton18.Top := 24;
    WebButton18.Width := 96;
    WebButton18.Height := 25;
    WebButton18.Caption := 'Close';
    WebButton18.Color := clRed;
    WebButton18.ChildOrder := 6;
    WebButton18.HeightPercent := 100.000000000000000000;
    WebButton18.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton18, Self, 'OnClick', 'WebButton18Click');
    WebPageControl1Sheet3.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet3.Name := 'WebPageControl1Sheet3';
    WebPageControl1Sheet3.Left := 0;
    WebPageControl1Sheet3.Top := 20;
    WebPageControl1Sheet3.Width := 935;
    WebPageControl1Sheet3.Height := 580;
    WebPageControl1Sheet3.Caption := 'WebPageControl1Sheet3';
    WebPageControl1Sheet3.ChildOrder := 2;
    WebPanel26.SetParentComponent(WebPageControl1Sheet3);
    WebPanel26.Name := 'WebPanel26';
    WebPanel26.Left := 0;
    WebPanel26.Top := 0;
    WebPanel26.Width := 935;
    WebPanel26.Height := 580;
    WebPanel26.Align := alClient;
    WebPanel26.ChildOrder := 1;
    WebPanel26.TabOrder := 0;
    WebPanel10.SetParentComponent(WebPanel26);
    WebPanel10.Name := 'WebPanel10';
    WebPanel10.Left := 0;
    WebPanel10.Top := 0;
    WebPanel10.Width := 935;
    WebPanel10.Height := 580;
    WebPanel10.Align := alClient;
    WebPanel10.TabOrder := 0;
    PageControl.SetParentComponent(WebPanel10);
    PageControl.Name := 'PageControl';
    PageControl.Left := 0;
    PageControl.Top := 0;
    PageControl.Width := 935;
    PageControl.Height := 520;
    PageControl.Align := alClient;
    PageControl.TabIndex := 0;
    PageControl.TabOrder := 0;
    wpcSageAccounting.SetParentComponent(PageControl);
    wpcSageAccounting.Name := 'wpcSageAccounting';
    wpcSageAccounting.Left := 0;
    wpcSageAccounting.Top := 20;
    wpcSageAccounting.Width := 935;
    wpcSageAccounting.Height := 500;
    wpcSageAccounting.Caption := 'Sage Accounting';
    WebPanel11.SetParentComponent(wpcSageAccounting);
    WebPanel11.Name := 'WebPanel11';
    WebPanel11.Left := 0;
    WebPanel11.Top := 0;
    WebPanel11.Width := 935;
    WebPanel11.Height := 500;
    WebPanel11.Align := alClient;
    WebPanel11.TabOrder := 0;
    WebLabel16.SetParentComponent(WebPanel11);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 56;
    WebLabel16.Top := 32;
    WebLabel16.Width := 80;
    WebLabel16.Height := 15;
    WebLabel16.Caption := 'Inventory Item:';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel17.SetParentComponent(WebPanel11);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 56;
    WebLabel17.Top := 99;
    WebLabel17.Width := 86;
    WebLabel17.Height := 15;
    WebLabel17.Caption := 'GL Exp Account:';
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebLabel18.SetParentComponent(WebPanel11);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 56;
    WebLabel18.Top := 163;
    WebLabel18.Width := 71;
    WebLabel18.Height := 15;
    WebLabel18.Caption := 'Project Code:';
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebDBEdit18.SetParentComponent(WebPanel11);
    WebDBEdit18.Name := 'WebDBEdit18';
    WebDBEdit18.Left := 56;
    WebDBEdit18.Top := 54;
    WebDBEdit18.Width := 300;
    WebDBEdit18.Height := 22;
    WebDBEdit18.ChildOrder := 3;
    WebDBEdit18.HeightPercent := 100.000000000000000000;
    WebDBEdit18.Text := 'WebDBEdit18';
    WebDBEdit18.WidthPercent := 100.000000000000000000;
    WebDBEdit18.DataField := 'INVENTORYGL';
    WebDBEdit18.DataSource := dsDieselDepots;
    WebDBEdit19.SetParentComponent(WebPanel11);
    WebDBEdit19.Name := 'WebDBEdit19';
    WebDBEdit19.Left := 56;
    WebDBEdit19.Top := 120;
    WebDBEdit19.Width := 201;
    WebDBEdit19.Height := 22;
    WebDBEdit19.ChildOrder := 1;
    WebDBEdit19.HeightPercent := 100.000000000000000000;
    WebDBEdit19.Text := 'WebDBEdit19';
    WebDBEdit19.WidthPercent := 100.000000000000000000;
    WebDBEdit19.DataField := 'COSTGL';
    WebDBEdit19.DataSource := dsDieselDepots;
    WebDBEdit20.SetParentComponent(WebPanel11);
    WebDBEdit20.Name := 'WebDBEdit20';
    WebDBEdit20.Left := 56;
    WebDBEdit20.Top := 185;
    WebDBEdit20.Width := 157;
    WebDBEdit20.Height := 22;
    WebDBEdit20.ChildOrder := 2;
    WebDBEdit20.HeightPercent := 100.000000000000000000;
    WebDBEdit20.Text := 'WebDBEdit20';
    WebDBEdit20.WidthPercent := 100.000000000000000000;
    WebDBEdit20.DataField := 'SAGEPROJECT';
    WebDBEdit20.DataSource := dsDieselDepots;
    WebDBCheckBox9.SetParentComponent(WebPanel11);
    WebDBCheckBox9.Name := 'WebDBCheckBox9';
    WebDBCheckBox9.Left := 271;
    WebDBCheckBox9.Top := 182;
    WebDBCheckBox9.Width := 130;
    WebDBCheckBox9.Height := 22;
    WebDBCheckBox9.Caption := 'Special Export';
    WebDBCheckBox9.ChildOrder := 3;
    WebDBCheckBox9.HeightPercent := 100.000000000000000000;
    WebDBCheckBox9.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox9, Self, 'OnClick', 'WebDBCheckBox9Click');
    WebDBCheckBox9.DataField := 'NONSAGEEXPORT';
    WebDBCheckBox9.DataSource := dsDieselDepots;
    WebButton12.SetParentComponent(WebPanel11);
    WebButton12.Name := 'WebButton12';
    WebButton12.Left := 362;
    WebButton12.Top := 52;
    WebButton12.Width := 25;
    WebButton12.Height := 25;
    WebButton12.Caption := '...';
    WebButton12.ChildOrder := 4;
    WebButton12.HeightPercent := 100.000000000000000000;
    WebButton12.WidthPercent := 100.000000000000000000;
    wpcBulkOrderInfo.SetParentComponent(PageControl);
    wpcBulkOrderInfo.Name := 'wpcBulkOrderInfo';
    wpcBulkOrderInfo.Left := 0;
    wpcBulkOrderInfo.Top := 20;
    wpcBulkOrderInfo.Width := 935;
    wpcBulkOrderInfo.Height := 500;
    wpcBulkOrderInfo.Caption := 'Bulk Order Info';
    wpcBulkOrderInfo.ChildOrder := 1;
    WebPanel12.SetParentComponent(wpcBulkOrderInfo);
    WebPanel12.Name := 'WebPanel12';
    WebPanel12.Left := 0;
    WebPanel12.Top := 0;
    WebPanel12.Width := 935;
    WebPanel12.Height := 500;
    WebPanel12.Align := alClient;
    WebPanel12.TabOrder := 0;
    WebLabel19.SetParentComponent(WebPanel12);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 36;
    WebLabel19.Top := 19;
    WebLabel19.Width := 91;
    WebLabel19.Height := 15;
    WebLabel19.Caption := 'Bulk Order Prefix:';
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebLabel20.SetParentComponent(WebPanel12);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 36;
    WebLabel20.Top := 89;
    WebLabel20.Width := 148;
    WebLabel20.Height := 15;
    WebLabel20.Caption := 'Bulk Order delivery Address:';
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebDBEdit21.SetParentComponent(WebPanel12);
    WebDBEdit21.Name := 'WebDBEdit21';
    WebDBEdit21.Left := 36;
    WebDBEdit21.Top := 40;
    WebDBEdit21.Width := 149;
    WebDBEdit21.Height := 22;
    WebDBEdit21.ChildOrder := 2;
    WebDBEdit21.HeightPercent := 100.000000000000000000;
    WebDBEdit21.Text := 'WebDBEdit21';
    WebDBEdit21.WidthPercent := 100.000000000000000000;
    WebDBEdit21.DataField := 'BULKORDERPREFIX';
    WebDBEdit21.DataSource := dsDieselDepots;
    WebDBEdit22.SetParentComponent(WebPanel12);
    WebDBEdit22.Name := 'WebDBEdit22';
    WebDBEdit22.Left := 36;
    WebDBEdit22.Top := 110;
    WebDBEdit22.Width := 357;
    WebDBEdit22.Height := 22;
    WebDBEdit22.ChildOrder := 1;
    WebDBEdit22.HeightPercent := 100.000000000000000000;
    WebDBEdit22.Text := 'WebDBEdit22';
    WebDBEdit22.WidthPercent := 100.000000000000000000;
    WebDBEdit22.DataField := 'DELVADDRESS1';
    WebDBEdit22.DataSource := dsDieselDepots;
    WebDBEdit23.SetParentComponent(WebPanel12);
    WebDBEdit23.Name := 'WebDBEdit23';
    WebDBEdit23.Left := 36;
    WebDBEdit23.Top := 138;
    WebDBEdit23.Width := 357;
    WebDBEdit23.Height := 22;
    WebDBEdit23.ChildOrder := 2;
    WebDBEdit23.HeightPercent := 100.000000000000000000;
    WebDBEdit23.Text := 'WebDBEdit23';
    WebDBEdit23.WidthPercent := 100.000000000000000000;
    WebDBEdit23.DataField := 'DELVADDRESS2';
    WebDBEdit23.DataSource := dsDieselDepots;
    WebDBEdit24.SetParentComponent(WebPanel12);
    WebDBEdit24.Name := 'WebDBEdit24';
    WebDBEdit24.Left := 36;
    WebDBEdit24.Top := 166;
    WebDBEdit24.Width := 357;
    WebDBEdit24.Height := 22;
    WebDBEdit24.ChildOrder := 3;
    WebDBEdit24.HeightPercent := 100.000000000000000000;
    WebDBEdit24.Text := 'WebDBEdit24';
    WebDBEdit24.WidthPercent := 100.000000000000000000;
    WebDBEdit24.DataField := 'DELVADDRESS3';
    WebDBEdit24.DataSource := dsDieselDepots;
    WebDBEdit25.SetParentComponent(WebPanel12);
    WebDBEdit25.Name := 'WebDBEdit25';
    WebDBEdit25.Left := 36;
    WebDBEdit25.Top := 194;
    WebDBEdit25.Width := 357;
    WebDBEdit25.Height := 25;
    WebDBEdit25.ChildOrder := 4;
    WebDBEdit25.HeightPercent := 100.000000000000000000;
    WebDBEdit25.Text := 'WebDBEdit25';
    WebDBEdit25.WidthPercent := 100.000000000000000000;
    WebDBEdit25.DataField := 'DELVADDRESS4';
    WebDBEdit25.DataSource := dsDieselDepots;
    WebDBEdit26.SetParentComponent(WebPanel12);
    WebDBEdit26.Name := 'WebDBEdit26';
    WebDBEdit26.Left := 36;
    WebDBEdit26.Top := 225;
    WebDBEdit26.Width := 149;
    WebDBEdit26.Height := 22;
    WebDBEdit26.ChildOrder := 5;
    WebDBEdit26.HeightPercent := 100.000000000000000000;
    WebDBEdit26.Text := 'WebDBEdit26';
    WebDBEdit26.WidthPercent := 100.000000000000000000;
    WebDBEdit26.DataField := 'DELVADDRESSCODE';
    WebDBEdit26.DataSource := dsDieselDepots;
    wpcTFNLinkInformation.SetParentComponent(PageControl);
    wpcTFNLinkInformation.Name := 'wpcTFNLinkInformation';
    wpcTFNLinkInformation.Left := 0;
    wpcTFNLinkInformation.Top := 20;
    wpcTFNLinkInformation.Width := 935;
    wpcTFNLinkInformation.Height := 500;
    wpcTFNLinkInformation.Caption := 'TFN Link Information';
    wpcTFNLinkInformation.ChildOrder := 2;
    WebPanel13.SetParentComponent(wpcTFNLinkInformation);
    WebPanel13.Name := 'WebPanel13';
    WebPanel13.Left := 0;
    WebPanel13.Top := 0;
    WebPanel13.Width := 935;
    WebPanel13.Height := 500;
    WebPanel13.Align := alClient;
    WebPanel13.ChildOrder := 10;
    WebPanel13.TabOrder := 0;
    WebLabel21.SetParentComponent(WebPanel13);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 66;
    WebLabel21.Top := 59;
    WebLabel21.Width := 119;
    WebLabel21.Height := 15;
    WebLabel21.Caption := 'TFN Supplier Account:';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel22.SetParentComponent(WebPanel13);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 66;
    WebLabel22.Top := 114;
    WebLabel22.Width := 85;
    WebLabel22.Height := 15;
    WebLabel22.Caption := 'TFN Depot Link:';
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebLabel23.SetParentComponent(WebPanel13);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 66;
    WebLabel23.Top := 166;
    WebLabel23.Width := 98;
    WebLabel23.Height := 15;
    WebLabel23.Caption := 'TFN Product Type:';
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebLabel24.SetParentComponent(WebPanel13);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 66;
    WebLabel24.Top := 213;
    WebLabel24.Width := 73;
    WebLabel24.Height := 15;
    WebLabel24.Caption := 'Product Type:';
    WebLabel24.HeightPercent := 100.000000000000000000;
    WebLabel24.WidthPercent := 100.000000000000000000;
    WebDBCheckBox10.SetParentComponent(WebPanel13);
    WebDBCheckBox10.Name := 'WebDBCheckBox10';
    WebDBCheckBox10.Left := 64;
    WebDBCheckBox10.Top := 33;
    WebDBCheckBox10.Width := 149;
    WebDBCheckBox10.Height := 22;
    WebDBCheckBox10.Caption := 'TFN Online Connection';
    WebDBCheckBox10.ChildOrder := 8;
    WebDBCheckBox10.HeightPercent := 100.000000000000000000;
    WebDBCheckBox10.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox10, Self, 'OnClick', 'WebDBCheckBox10Click');
    WebDBCheckBox10.DataField := 'tfnonlinelink';
    WebDBCheckBox10.DataSource := dsDieselDepots;
    WebDBCheckBox11.SetParentComponent(WebPanel13);
    WebDBCheckBox11.Name := 'WebDBCheckBox11';
    WebDBCheckBox11.Left := 240;
    WebDBCheckBox11.Top := 33;
    WebDBCheckBox11.Width := 127;
    WebDBCheckBox11.Height := 22;
    WebDBCheckBox11.Caption := 'Use TFN Invoice';
    WebDBCheckBox11.ChildOrder := 9;
    WebDBCheckBox11.HeightPercent := 100.000000000000000000;
    WebDBCheckBox11.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox11, Self, 'OnClick', 'WebDBCheckBox11Click');
    WebDBCheckBox11.DataField := 'tfnuseinvoice';
    WebDBCheckBox11.DataSource := dsDieselDepots;
    WebButton25.SetParentComponent(WebPanel13);
    WebButton25.Name := 'WebButton25';
    WebButton25.Left := 192;
    WebButton25.Top := 368;
    WebButton25.Width := 225;
    WebButton25.Height := 62;
    WebButton25.Caption := 'WebButton25';
    WebButton25.ChildOrder := 14;
    WebButton25.HeightPercent := 100.000000000000000000;
    WebButton25.WidthPercent := 100.000000000000000000;
    dbedtTFNSupplier.SetParentComponent(WebPanel13);
    dbedtTFNSupplier.Name := 'dbedtTFNSupplier';
    dbedtTFNSupplier.Left := 64;
    dbedtTFNSupplier.Top := 80;
    dbedtTFNSupplier.Width := 300;
    dbedtTFNSupplier.Height := 22;
    dbedtTFNSupplier.ChildOrder := 11;
    dbedtTFNSupplier.HeightPercent := 100.000000000000000000;
    dbedtTFNSupplier.Text := 'dbedtTFNSupplier';
    dbedtTFNSupplier.WidthPercent := 100.000000000000000000;
    dbedtTFNSupplier.DataField := 'TFNCRName';
    dbedtTFNSupplier.DataSource := dsDieselDepots;
    WebDBEdit27.SetParentComponent(WebPanel13);
    WebDBEdit27.Name := 'WebDBEdit27';
    WebDBEdit27.Left := 64;
    WebDBEdit27.Top := 143;
    WebDBEdit27.Width := 300;
    WebDBEdit27.Height := 22;
    WebDBEdit27.ChildOrder := 12;
    WebDBEdit27.HeightPercent := 100.000000000000000000;
    WebDBEdit27.Text := 'WebDBEdit27';
    WebDBEdit27.WidthPercent := 100.000000000000000000;
    WebDBEdit27.DataField := 'TFNDepotName';
    WebDBEdit27.DataSource := dsDieselDepots;
    WebDBEdit28.SetParentComponent(WebPanel13);
    WebDBEdit28.Name := 'WebDBEdit28';
    WebDBEdit28.Left := 64;
    WebDBEdit28.Top := 192;
    WebDBEdit28.Width := 300;
    WebDBEdit28.Height := 22;
    WebDBEdit28.ChildOrder := 13;
    WebDBEdit28.HeightPercent := 100.000000000000000000;
    WebDBEdit28.Text := 'WebDBEdit28';
    WebDBEdit28.WidthPercent := 100.000000000000000000;
    WebDBEdit28.DataField := 'TFNProductName';
    WebDBEdit28.DataSource := dsDieselDepots;
    WebDBEdit29.SetParentComponent(WebPanel13);
    WebDBEdit29.Name := 'WebDBEdit29';
    WebDBEdit29.Left := 67;
    WebDBEdit29.Top := 237;
    WebDBEdit29.Width := 300;
    WebDBEdit29.Height := 22;
    WebDBEdit29.ChildOrder := 14;
    WebDBEdit29.HeightPercent := 100.000000000000000000;
    WebDBEdit29.Text := 'WebDBEdit29';
    WebDBEdit29.WidthPercent := 100.000000000000000000;
    WebDBEdit29.DataField := 'fueltypename';
    WebDBEdit29.DataSource := dsDieselDepots;
    WebButton2.SetParentComponent(WebPanel13);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 370;
    WebButton2.Top := 79;
    WebButton2.Width := 30;
    WebButton2.Height := 25;
    WebButton2.Caption := '...';
    WebButton2.ChildOrder := 15;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebButton7.SetParentComponent(WebPanel13);
    WebButton7.Name := 'WebButton7';
    WebButton7.Left := 370;
    WebButton7.Top := 142;
    WebButton7.Width := 30;
    WebButton7.Height := 25;
    WebButton7.Caption := '...';
    WebButton7.ChildOrder := 16;
    WebButton7.HeightPercent := 100.000000000000000000;
    WebButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton7, Self, 'OnClick', 'WebButton7Click');
    WebButton10.SetParentComponent(WebPanel13);
    WebButton10.Name := 'WebButton10';
    WebButton10.Left := 370;
    WebButton10.Top := 237;
    WebButton10.Width := 30;
    WebButton10.Height := 25;
    WebButton10.Caption := '...';
    WebButton10.ChildOrder := 18;
    WebButton10.HeightPercent := 100.000000000000000000;
    WebButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton10, Self, 'OnClick', 'WebButton10Click');
    WebButton16.SetParentComponent(WebPanel13);
    WebButton16.Name := 'WebButton16';
    WebButton16.Left := 370;
    WebButton16.Top := 190;
    WebButton16.Width := 30;
    WebButton16.Height := 25;
    WebButton16.Caption := '...';
    WebButton16.ChildOrder := 19;
    WebButton16.HeightPercent := 100.000000000000000000;
    WebButton16.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton16, Self, 'OnClick', 'WebButton16Click');
    wpcSummatechLink.SetParentComponent(PageControl);
    wpcSummatechLink.Name := 'wpcSummatechLink';
    wpcSummatechLink.Left := 0;
    wpcSummatechLink.Top := 20;
    wpcSummatechLink.Width := 935;
    wpcSummatechLink.Height := 500;
    wpcSummatechLink.Caption := 'Summatech Link';
    wpcSummatechLink.ChildOrder := 3;
    WebPanel14.SetParentComponent(wpcSummatechLink);
    WebPanel14.Name := 'WebPanel14';
    WebPanel14.Left := 0;
    WebPanel14.Top := 0;
    WebPanel14.Width := 935;
    WebPanel14.Height := 491;
    WebPanel14.TabOrder := 0;
    WebLabel25.SetParentComponent(WebPanel14);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 56;
    WebLabel25.Top := 93;
    WebLabel25.Width := 119;
    WebLabel25.Height := 15;
    WebLabel25.Caption := 'Supplier Link Account:';
    WebLabel25.HeightPercent := 100.000000000000000000;
    WebLabel25.WidthPercent := 100.000000000000000000;
    WebLabel26.SetParentComponent(WebPanel14);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 56;
    WebLabel26.Top := 173;
    WebLabel26.Width := 106;
    WebLabel26.Height := 15;
    WebLabel26.Caption := 'Supplier Depot Link:';
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel27.SetParentComponent(WebPanel14);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 615;
    WebLabel27.Top := 93;
    WebLabel27.Width := 73;
    WebLabel27.Height := 15;
    WebLabel27.Caption := 'Product Type:';
    WebLabel27.HeightPercent := 100.000000000000000000;
    WebLabel27.WidthPercent := 100.000000000000000000;
    WebButton26.SetParentComponent(WebPanel14);
    WebButton26.Name := 'WebButton26';
    WebButton26.Left := 106;
    WebButton26.Top := 313;
    WebButton26.Width := 200;
    WebButton26.Height := 73;
    WebButton26.Caption := 'WebButton26';
    WebButton26.ChildOrder := 3;
    WebButton26.HeightPercent := 100.000000000000000000;
    WebButton26.WidthPercent := 100.000000000000000000;
    WebDBCheckBox12.SetParentComponent(WebPanel14);
    WebDBCheckBox12.Name := 'WebDBCheckBox12';
    WebDBCheckBox12.Left := 51;
    WebDBCheckBox12.Top := 40;
    WebDBCheckBox12.Width := 162;
    WebDBCheckBox12.Height := 22;
    WebDBCheckBox12.Caption := 'Summatech Online link';
    WebDBCheckBox12.ChildOrder := 1;
    WebDBCheckBox12.HeightPercent := 100.000000000000000000;
    WebDBCheckBox12.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox12, Self, 'OnClick', 'WebDBCheckBox12Click');
    WebDBCheckBox12.DataField := 'stonlinelink';
    WebDBCheckBox12.DataSource := dsDieselDepots;
    WebDBCheckBox13.SetParentComponent(WebPanel14);
    WebDBCheckBox13.Name := 'WebDBCheckBox13';
    WebDBCheckBox13.Left := 240;
    WebDBCheckBox13.Top := 40;
    WebDBCheckBox13.Width := 127;
    WebDBCheckBox13.Height := 22;
    WebDBCheckBox13.Caption := 'Auto Create Order';
    WebDBCheckBox13.ChildOrder := 2;
    WebDBCheckBox13.HeightPercent := 100.000000000000000000;
    WebDBCheckBox13.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox13, Self, 'OnClick', 'WebDBCheckBox13Click');
    WebDBCheckBox13.DataField := 'stautocreateorder';
    WebDBCheckBox13.DataSource := dsDieselDepots;
    WebButton14.SetParentComponent(WebPanel14);
    WebButton14.Name := 'WebButton14';
    WebButton14.Left := 361;
    WebButton14.Top := 119;
    WebButton14.Width := 30;
    WebButton14.Height := 25;
    WebButton14.Caption := '...';
    WebButton14.ChildOrder := 9;
    WebButton14.HeightPercent := 100.000000000000000000;
    WebButton14.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton14, Self, 'OnClick', 'WebButton14Click');
    WebDBEdit30.SetParentComponent(WebPanel14);
    WebDBEdit30.Name := 'WebDBEdit30';
    WebDBEdit30.Left := 56;
    WebDBEdit30.Top := 120;
    WebDBEdit30.Width := 300;
    WebDBEdit30.Height := 22;
    WebDBEdit30.ChildOrder := 10;
    WebDBEdit30.HeightPercent := 100.000000000000000000;
    WebDBEdit30.Text := 'WebDBEdit30';
    WebDBEdit30.WidthPercent := 100.000000000000000000;
    WebDBEdit30.DataField := 'SummaTechCRName';
    WebDBEdit30.DataSource := dsDieselDepots;
    WebDBEdit9.SetParentComponent(WebPanel14);
    WebDBEdit9.Name := 'WebDBEdit9';
    WebDBEdit9.Left := 496;
    WebDBEdit9.Top := 120;
    WebDBEdit9.Width := 300;
    WebDBEdit9.Height := 22;
    WebDBEdit9.ChildOrder := 11;
    WebDBEdit9.HeightPercent := 100.000000000000000000;
    WebDBEdit9.Text := 'WebDBEdit9';
    WebDBEdit9.WidthPercent := 100.000000000000000000;
    WebDBEdit9.DataField := 'stFuelTypeName';
    WebDBEdit9.DataSource := dsDieselDepots;
    WebButton21.SetParentComponent(WebPanel14);
    WebButton21.Name := 'WebButton21';
    WebButton21.Left := 802;
    WebButton21.Top := 118;
    WebButton21.Width := 30;
    WebButton21.Height := 25;
    WebButton21.Caption := '...';
    WebButton21.ChildOrder := 12;
    WebButton21.HeightPercent := 100.000000000000000000;
    WebButton21.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton21, Self, 'OnClick', 'WebButton21Click');
    WebDBEdit32.SetParentComponent(WebPanel14);
    WebDBEdit32.Name := 'WebDBEdit32';
    WebDBEdit32.Left := 56;
    WebDBEdit32.Top := 208;
    WebDBEdit32.Width := 300;
    WebDBEdit32.Height := 22;
    WebDBEdit32.ChildOrder := 13;
    WebDBEdit32.HeightPercent := 100.000000000000000000;
    WebDBEdit32.Text := 'WebDBEdit32';
    WebDBEdit32.WidthPercent := 100.000000000000000000;
    WebDBEdit32.DataField := 'stdName';
    WebDBEdit32.DataSource := dsDieselDepots;
    WebButton22.SetParentComponent(WebPanel14);
    WebButton22.Name := 'WebButton22';
    WebButton22.Left := 362;
    WebButton22.Top := 207;
    WebButton22.Width := 30;
    WebButton22.Height := 25;
    WebButton22.Caption := '...';
    WebButton22.ChildOrder := 14;
    WebButton22.HeightPercent := 100.000000000000000000;
    WebButton22.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton22, Self, 'OnClick', 'WebButton22Click');
    wpcFMSLink.SetParentComponent(PageControl);
    wpcFMSLink.Name := 'wpcFMSLink';
    wpcFMSLink.Left := 0;
    wpcFMSLink.Top := 20;
    wpcFMSLink.Width := 935;
    wpcFMSLink.Height := 500;
    wpcFMSLink.Caption := 'FMS Link';
    wpcFMSLink.ChildOrder := 4;
    WebPanel15.SetParentComponent(wpcFMSLink);
    WebPanel15.Name := 'WebPanel15';
    WebPanel15.Left := 0;
    WebPanel15.Top := 0;
    WebPanel15.Width := 935;
    WebPanel15.Height := 500;
    WebPanel15.Align := alClient;
    WebPanel15.TabOrder := 0;
    WebLabel28.SetParentComponent(WebPanel15);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 74;
    WebLabel28.Top := 89;
    WebLabel28.Width := 119;
    WebLabel28.Height := 15;
    WebLabel28.Caption := 'Supplier Link Account:';
    WebLabel28.HeightPercent := 100.000000000000000000;
    WebLabel28.WidthPercent := 100.000000000000000000;
    WebLabel29.SetParentComponent(WebPanel15);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 74;
    WebLabel29.Top := 158;
    WebLabel29.Width := 106;
    WebLabel29.Height := 15;
    WebLabel29.Caption := 'Supplier Depot Link:';
    WebLabel29.HeightPercent := 100.000000000000000000;
    WebLabel29.WidthPercent := 100.000000000000000000;
    WebLabel30.SetParentComponent(WebPanel15);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 521;
    WebLabel30.Top := 91;
    WebLabel30.Width := 73;
    WebLabel30.Height := 15;
    WebLabel30.Caption := 'Product Type:';
    WebLabel30.HeightPercent := 100.000000000000000000;
    WebLabel30.WidthPercent := 100.000000000000000000;
    WebDBCheckBox14.SetParentComponent(WebPanel15);
    WebDBCheckBox14.Name := 'WebDBCheckBox14';
    WebDBCheckBox14.Left := 72;
    WebDBCheckBox14.Top := 40;
    WebDBCheckBox14.Width := 141;
    WebDBCheckBox14.Height := 22;
    WebDBCheckBox14.Caption := 'FMS Online Link';
    WebDBCheckBox14.ChildOrder := 3;
    WebDBCheckBox14.HeightPercent := 100.000000000000000000;
    WebDBCheckBox14.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox14, Self, 'OnClick', 'WebDBCheckBox14Click');
    WebDBCheckBox14.DataField := 'fmsonlinelink';
    WebDBCheckBox14.DataSource := dsDieselDepots;
    WebDBEdit34.SetParentComponent(WebPanel15);
    WebDBEdit34.Name := 'WebDBEdit34';
    WebDBEdit34.Left := 70;
    WebDBEdit34.Top := 184;
    WebDBEdit34.Width := 300;
    WebDBEdit34.Height := 22;
    WebDBEdit34.ChildOrder := 1;
    WebDBEdit34.HeightPercent := 100.000000000000000000;
    WebDBEdit34.Text := 'WebDBEdit34';
    WebDBEdit34.WidthPercent := 100.000000000000000000;
    WebDBEdit34.DataField := 'fmsDepotName';
    WebDBEdit34.DataSource := dsDieselDepots;
    WebDBEdit35.SetParentComponent(WebPanel15);
    WebDBEdit35.Name := 'WebDBEdit35';
    WebDBEdit35.Left := 518;
    WebDBEdit35.Top := 114;
    WebDBEdit35.Width := 300;
    WebDBEdit35.Height := 22;
    WebDBEdit35.ChildOrder := 2;
    WebDBEdit35.HeightPercent := 100.000000000000000000;
    WebDBEdit35.Text := 'WebDBEdit35';
    WebDBEdit35.WidthPercent := 100.000000000000000000;
    WebDBEdit35.DataField := 'fmsFuelTypeName';
    WebDBEdit35.DataSource := dsDieselDepots;
    WebButton30.SetParentComponent(WebPanel15);
    WebButton30.Name := 'WebButton30';
    WebButton30.Left := 36;
    WebButton30.Top := 353;
    WebButton30.Width := 218;
    WebButton30.Height := 60;
    WebButton30.Caption := 'WebButton30';
    WebButton30.ChildOrder := 4;
    WebButton30.HeightPercent := 100.000000000000000000;
    WebButton30.WidthPercent := 100.000000000000000000;
    WebDBEdit31.SetParentComponent(WebPanel15);
    WebDBEdit31.Name := 'WebDBEdit31';
    WebDBEdit31.Left := 70;
    WebDBEdit31.Top := 114;
    WebDBEdit31.Width := 300;
    WebDBEdit31.Height := 22;
    WebDBEdit31.ChildOrder := 8;
    WebDBEdit31.HeightPercent := 100.000000000000000000;
    WebDBEdit31.Text := 'WebDBEdit31';
    WebDBEdit31.WidthPercent := 100.000000000000000000;
    WebDBEdit31.DataField := 'FMSCRName';
    WebDBEdit31.DataSource := dsDieselDepots;
    WebButton15.SetParentComponent(WebPanel15);
    WebButton15.Name := 'WebButton15';
    WebButton15.Left := 376;
    WebButton15.Top := 113;
    WebButton15.Width := 30;
    WebButton15.Height := 25;
    WebButton15.Caption := '...';
    WebButton15.ChildOrder := 9;
    WebButton15.HeightPercent := 100.000000000000000000;
    WebButton15.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton15, Self, 'OnClick', 'WebButton15Click');
    WebButton23.SetParentComponent(WebPanel15);
    WebButton23.Name := 'WebButton23';
    WebButton23.Left := 376;
    WebButton23.Top := 182;
    WebButton23.Width := 30;
    WebButton23.Height := 25;
    WebButton23.Caption := '...';
    WebButton23.ChildOrder := 10;
    WebButton23.HeightPercent := 100.000000000000000000;
    WebButton23.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton23, Self, 'OnClick', 'WebButton23Click');
    WebButton24.SetParentComponent(WebPanel15);
    WebButton24.Name := 'WebButton24';
    WebButton24.Left := 824;
    WebButton24.Top := 112;
    WebButton24.Width := 30;
    WebButton24.Height := 25;
    WebButton24.Caption := '...';
    WebButton24.ChildOrder := 10;
    WebButton24.HeightPercent := 100.000000000000000000;
    WebButton24.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton24, Self, 'OnClick', 'WebButton24Click');
    wpcShiptechLink.SetParentComponent(PageControl);
    wpcShiptechLink.Name := 'wpcShiptechLink';
    wpcShiptechLink.Left := 0;
    wpcShiptechLink.Top := 20;
    wpcShiptechLink.Width := 935;
    wpcShiptechLink.Height := 500;
    wpcShiptechLink.Caption := 'Shiptech Link';
    wpcShiptechLink.ChildOrder := 5;
    WebPanel16.SetParentComponent(wpcShiptechLink);
    WebPanel16.Name := 'WebPanel16';
    WebPanel16.Left := 0;
    WebPanel16.Top := 0;
    WebPanel16.Width := 935;
    WebPanel16.Height := 500;
    WebPanel16.Align := alClient;
    WebPanel16.TabOrder := 0;
    WebLabel31.SetParentComponent(WebPanel16);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 51;
    WebLabel31.Top := 99;
    WebLabel31.Width := 119;
    WebLabel31.Height := 15;
    WebLabel31.Caption := 'Supplier Link Account:';
    WebLabel31.HeightPercent := 100.000000000000000000;
    WebLabel31.WidthPercent := 100.000000000000000000;
    WebLabel32.SetParentComponent(WebPanel16);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 51;
    WebLabel32.Top := 184;
    WebLabel32.Width := 106;
    WebLabel32.Height := 15;
    WebLabel32.Caption := 'Supplier Depot Link:';
    WebLabel32.HeightPercent := 100.000000000000000000;
    WebLabel32.WidthPercent := 100.000000000000000000;
    WebLabel33.SetParentComponent(WebPanel16);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 455;
    WebLabel33.Top := 99;
    WebLabel33.Width := 98;
    WebLabel33.Height := 15;
    WebLabel33.Caption := 'TFN Product Type:';
    WebLabel33.HeightPercent := 100.000000000000000000;
    WebLabel33.WidthPercent := 100.000000000000000000;
    WebDBCheckBox15.SetParentComponent(WebPanel16);
    WebDBCheckBox15.Name := 'WebDBCheckBox15';
    WebDBCheckBox15.Left := 38;
    WebDBCheckBox15.Top := 33;
    WebDBCheckBox15.Width := 146;
    WebDBCheckBox15.Height := 22;
    WebDBCheckBox15.Caption := 'Shiptech Online Link';
    WebDBCheckBox15.ChildOrder := 3;
    WebDBCheckBox15.HeightPercent := 100.000000000000000000;
    WebDBCheckBox15.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox15, Self, 'OnClick', 'WebDBCheckBox15Click');
    WebDBCheckBox15.DataField := 'shiptechlink';
    WebDBCheckBox15.DataSource := dsDieselDepots;
    WebDBEdit37.SetParentComponent(WebPanel16);
    WebDBEdit37.Name := 'WebDBEdit37';
    WebDBEdit37.Left := 51;
    WebDBEdit37.Top := 120;
    WebDBEdit37.Width := 300;
    WebDBEdit37.Height := 22;
    WebDBEdit37.ChildOrder := 1;
    WebDBEdit37.HeightPercent := 100.000000000000000000;
    WebDBEdit37.Text := 'WebDBEdit37';
    WebDBEdit37.WidthPercent := 100.000000000000000000;
    WebDBEdit37.DataField := 'ShiptechCRName';
    WebDBEdit37.DataSource := dsDieselDepots;
    WebDBEdit38.SetParentComponent(WebPanel16);
    WebDBEdit38.Name := 'WebDBEdit38';
    WebDBEdit38.Left := 51;
    WebDBEdit38.Top := 205;
    WebDBEdit38.Width := 300;
    WebDBEdit38.Height := 22;
    WebDBEdit38.ChildOrder := 2;
    WebDBEdit38.HeightPercent := 100.000000000000000000;
    WebDBEdit38.Text := 'WebDBEdit38';
    WebDBEdit38.WidthPercent := 100.000000000000000000;
    WebDBEdit38.DataField := 'shiptechDepotName';
    WebDBEdit38.DataSource := dsDieselDepots;
    WebDBEdit39.SetParentComponent(WebPanel16);
    WebDBEdit39.Name := 'WebDBEdit39';
    WebDBEdit39.Left := 455;
    WebDBEdit39.Top := 120;
    WebDBEdit39.Width := 306;
    WebDBEdit39.Height := 22;
    WebDBEdit39.ChildOrder := 3;
    WebDBEdit39.HeightPercent := 100.000000000000000000;
    WebDBEdit39.Text := 'WebDBEdit39';
    WebDBEdit39.WidthPercent := 100.000000000000000000;
    WebDBEdit39.DataField := 'ShipTechFuelTypeName';
    WebDBEdit39.DataSource := dsDieselDepots;
    WebButton31.SetParentComponent(WebPanel16);
    WebButton31.Name := 'WebButton31';
    WebButton31.Left := 357;
    WebButton31.Top := 118;
    WebButton31.Width := 30;
    WebButton31.Height := 25;
    WebButton31.Caption := '...';
    WebButton31.ChildOrder := 7;
    WebButton31.HeightPercent := 100.000000000000000000;
    WebButton31.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton31, Self, 'OnClick', 'WebButton31Click');
    WebButton32.SetParentComponent(WebPanel16);
    WebButton32.Name := 'WebButton32';
    WebButton32.Left := 357;
    WebButton32.Top := 206;
    WebButton32.Width := 30;
    WebButton32.Height := 25;
    WebButton32.Caption := '...';
    WebButton32.ChildOrder := 8;
    WebButton32.HeightPercent := 100.000000000000000000;
    WebButton32.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton32, Self, 'OnClick', 'WebButton32Click');
    WebButton33.SetParentComponent(WebPanel16);
    WebButton33.Name := 'WebButton33';
    WebButton33.Left := 767;
    WebButton33.Top := 119;
    WebButton33.Width := 30;
    WebButton33.Height := 25;
    WebButton33.Caption := '...';
    WebButton33.ChildOrder := 9;
    WebButton33.HeightPercent := 100.000000000000000000;
    WebButton33.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton33, Self, 'OnClick', 'WebButton33Click');
    wpcFuelULink.SetParentComponent(PageControl);
    wpcFuelULink.Name := 'wpcFuelULink';
    wpcFuelULink.Left := 0;
    wpcFuelULink.Top := 20;
    wpcFuelULink.Width := 935;
    wpcFuelULink.Height := 500;
    wpcFuelULink.Caption := 'FuelU Link';
    wpcFuelULink.ChildOrder := 6;
    WebPanel17.SetParentComponent(wpcFuelULink);
    WebPanel17.Name := 'WebPanel17';
    WebPanel17.Left := 0;
    WebPanel17.Top := 0;
    WebPanel17.Width := 935;
    WebPanel17.Height := 500;
    WebPanel17.Align := alClient;
    WebPanel17.TabOrder := 0;
    WebLabel34.SetParentComponent(WebPanel17);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 87;
    WebLabel34.Top := 78;
    WebLabel34.Width := 117;
    WebLabel34.Height := 15;
    WebLabel34.Caption := 'Supplier Link account:';
    WebLabel34.HeightPercent := 100.000000000000000000;
    WebLabel34.WidthPercent := 100.000000000000000000;
    WebLabel35.SetParentComponent(WebPanel17);
    WebLabel35.Name := 'WebLabel35';
    WebLabel35.Left := 496;
    WebLabel35.Top := 91;
    WebLabel35.Width := 98;
    WebLabel35.Height := 15;
    WebLabel35.Caption := 'TFN Product Type:';
    WebLabel35.HeightPercent := 100.000000000000000000;
    WebLabel35.WidthPercent := 100.000000000000000000;
    WebLabel36.SetParentComponent(WebPanel17);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 80;
    WebLabel36.Top := 171;
    WebLabel36.Width := 106;
    WebLabel36.Height := 15;
    WebLabel36.Caption := 'Supplier Depot Link:';
    WebLabel36.HeightPercent := 100.000000000000000000;
    WebLabel36.WidthPercent := 100.000000000000000000;
    WebDBCheckBox16.SetParentComponent(WebPanel17);
    WebDBCheckBox16.Name := 'WebDBCheckBox16';
    WebDBCheckBox16.Left := 80;
    WebDBCheckBox16.Top := 25;
    WebDBCheckBox16.Width := 113;
    WebDBCheckBox16.Height := 22;
    WebDBCheckBox16.Caption := 'FuelU Link';
    WebDBCheckBox16.ChildOrder := 3;
    WebDBCheckBox16.HeightPercent := 100.000000000000000000;
    WebDBCheckBox16.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox16, Self, 'OnClick', 'WebDBCheckBox16Click');
    WebDBCheckBox16.DataField := 'fueluonlinelink';
    WebDBCheckBox16.DataSource := dsDieselDepots;
    WebDBEdit40.SetParentComponent(WebPanel17);
    WebDBEdit40.Name := 'WebDBEdit40';
    WebDBEdit40.Left := 80;
    WebDBEdit40.Top := 104;
    WebDBEdit40.Width := 300;
    WebDBEdit40.Height := 22;
    WebDBEdit40.ChildOrder := 1;
    WebDBEdit40.HeightPercent := 100.000000000000000000;
    WebDBEdit40.Text := 'WebDBEdit40';
    WebDBEdit40.WidthPercent := 100.000000000000000000;
    WebDBEdit40.DataField := 'FuelUCRName';
    WebDBEdit40.DataSource := dsDieselDepots;
    WebDBEdit41.SetParentComponent(WebPanel17);
    WebDBEdit41.Name := 'WebDBEdit41';
    WebDBEdit41.Left := 80;
    WebDBEdit41.Top := 192;
    WebDBEdit41.Width := 300;
    WebDBEdit41.Height := 22;
    WebDBEdit41.ChildOrder := 2;
    WebDBEdit41.HeightPercent := 100.000000000000000000;
    WebDBEdit41.Text := 'WebDBEdit41';
    WebDBEdit41.WidthPercent := 100.000000000000000000;
    WebDBEdit41.DataField := 'FuelUDepotName';
    WebDBEdit41.DataSource := dsDieselDepots;
    WebDBEdit42.SetParentComponent(WebPanel17);
    WebDBEdit42.Name := 'WebDBEdit42';
    WebDBEdit42.Left := 496;
    WebDBEdit42.Top := 112;
    WebDBEdit42.Width := 300;
    WebDBEdit42.Height := 22;
    WebDBEdit42.ChildOrder := 3;
    WebDBEdit42.HeightPercent := 100.000000000000000000;
    WebDBEdit42.Text := 'WebDBEdit42';
    WebDBEdit42.WidthPercent := 100.000000000000000000;
    WebDBEdit42.DataField := 'FuelUFueltypeName';
    WebDBEdit42.DataSource := dsDieselDepots;
    WebButton34.SetParentComponent(WebPanel17);
    WebButton34.Name := 'WebButton34';
    WebButton34.Left := 386;
    WebButton34.Top := 102;
    WebButton34.Width := 30;
    WebButton34.Height := 25;
    WebButton34.Caption := '...';
    WebButton34.ChildOrder := 7;
    WebButton34.HeightPercent := 100.000000000000000000;
    WebButton34.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton34, Self, 'OnClick', 'WebButton34Click');
    WebButton35.SetParentComponent(WebPanel17);
    WebButton35.Name := 'WebButton35';
    WebButton35.Left := 386;
    WebButton35.Top := 190;
    WebButton35.Width := 30;
    WebButton35.Height := 25;
    WebButton35.Caption := '...';
    WebButton35.ChildOrder := 8;
    WebButton35.HeightPercent := 100.000000000000000000;
    WebButton35.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton35, Self, 'OnClick', 'WebButton35Click');
    WebButton36.SetParentComponent(WebPanel17);
    WebButton36.Name := 'WebButton36';
    WebButton36.Left := 803;
    WebButton36.Top := 110;
    WebButton36.Width := 30;
    WebButton36.Height := 25;
    WebButton36.Caption := '...';
    WebButton36.ChildOrder := 9;
    WebButton36.HeightPercent := 100.000000000000000000;
    WebButton36.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton36, Self, 'OnClick', 'WebButton36Click');
    WebButton40.SetParentComponent(WebPanel17);
    WebButton40.Name := 'WebButton40';
    WebButton40.Left := 97;
    WebButton40.Top := 261;
    WebButton40.Width := 96;
    WebButton40.Height := 25;
    WebButton40.Caption := 'WebButton40';
    WebButton40.ChildOrder := 10;
    WebButton40.HeightPercent := 100.000000000000000000;
    WebButton40.WidthPercent := 100.000000000000000000;
    wpcXFuelsLink.SetParentComponent(PageControl);
    wpcXFuelsLink.Name := 'wpcXFuelsLink';
    wpcXFuelsLink.Left := 0;
    wpcXFuelsLink.Top := 20;
    wpcXFuelsLink.Width := 935;
    wpcXFuelsLink.Height := 500;
    wpcXFuelsLink.Caption := 'X-Fuels Link';
    wpcXFuelsLink.ChildOrder := 7;
    WebPanel24.SetParentComponent(wpcXFuelsLink);
    WebPanel24.Name := 'WebPanel24';
    WebPanel24.Left := 0;
    WebPanel24.Top := 0;
    WebPanel24.Width := 935;
    WebPanel24.Height := 500;
    WebPanel24.Align := alClient;
    WebPanel24.TabOrder := 0;
    WebLabel38.SetParentComponent(WebPanel24);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 51;
    WebLabel38.Top := 78;
    WebLabel38.Width := 119;
    WebLabel38.Height := 15;
    WebLabel38.Caption := 'Supplier Link Account:';
    WebLabel38.HeightPercent := 100.000000000000000000;
    WebLabel38.WidthPercent := 100.000000000000000000;
    WebLabel39.SetParentComponent(WebPanel24);
    WebLabel39.Name := 'WebLabel39';
    WebLabel39.Left := 51;
    WebLabel39.Top := 152;
    WebLabel39.Width := 106;
    WebLabel39.Height := 15;
    WebLabel39.Caption := 'Supplier Depot Link:';
    WebLabel39.HeightPercent := 100.000000000000000000;
    WebLabel39.WidthPercent := 100.000000000000000000;
    WebLabel37.SetParentComponent(WebPanel24);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 501;
    WebLabel37.Top := 75;
    WebLabel37.Width := 73;
    WebLabel37.Height := 15;
    WebLabel37.Caption := 'Product Type:';
    WebLabel37.HeightPercent := 100.000000000000000000;
    WebLabel37.WidthPercent := 100.000000000000000000;
    WebDBCheckBox17.SetParentComponent(WebPanel24);
    WebDBCheckBox17.Name := 'WebDBCheckBox17';
    WebDBCheckBox17.Left := 51;
    WebDBCheckBox17.Top := 33;
    WebDBCheckBox17.Width := 113;
    WebDBCheckBox17.Height := 22;
    WebDBCheckBox17.Caption := 'X-Fuel Link';
    WebDBCheckBox17.ChildOrder := 1;
    WebDBCheckBox17.HeightPercent := 100.000000000000000000;
    WebDBCheckBox17.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox17, Self, 'OnClick', 'WebDBCheckBox17Click');
    WebDBCheckBox17.DataField := 'xfuelsonlinelink';
    WebDBCheckBox17.DataSource := dsDieselDepots;
    WebDBEdit43.SetParentComponent(WebPanel24);
    WebDBEdit43.Name := 'WebDBEdit43';
    WebDBEdit43.Left := 49;
    WebDBEdit43.Top := 104;
    WebDBEdit43.Width := 300;
    WebDBEdit43.Height := 22;
    WebDBEdit43.ChildOrder := 1;
    WebDBEdit43.HeightPercent := 100.000000000000000000;
    WebDBEdit43.Text := 'WebDBEdit43';
    WebDBEdit43.WidthPercent := 100.000000000000000000;
    WebDBEdit43.DataField := 'xFuelCRName';
    WebDBEdit43.DataSource := dsDieselDepots;
    WebDBEdit44.SetParentComponent(WebPanel24);
    WebDBEdit44.Name := 'WebDBEdit44';
    WebDBEdit44.Left := 49;
    WebDBEdit44.Top := 177;
    WebDBEdit44.Width := 300;
    WebDBEdit44.Height := 22;
    WebDBEdit44.ChildOrder := 2;
    WebDBEdit44.HeightPercent := 100.000000000000000000;
    WebDBEdit44.Text := 'WebDBEdit44';
    WebDBEdit44.WidthPercent := 100.000000000000000000;
    WebDBEdit44.DataField := 'XFuelDepotName';
    WebDBEdit44.DataSource := dsDieselDepots;
    WebButton38.SetParentComponent(WebPanel24);
    WebButton38.Name := 'WebButton38';
    WebButton38.Left := 354;
    WebButton38.Top := 175;
    WebButton38.Width := 30;
    WebButton38.Height := 25;
    WebButton38.Caption := '...';
    WebButton38.ChildOrder := 8;
    WebButton38.HeightPercent := 100.000000000000000000;
    WebButton38.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton38, Self, 'OnClick', 'WebButton38Click');
    WebButton37.SetParentComponent(WebPanel24);
    WebButton37.Name := 'WebButton37';
    WebButton37.Left := 354;
    WebButton37.Top := 102;
    WebButton37.Width := 30;
    WebButton37.Height := 25;
    WebButton37.Caption := '...';
    WebButton37.ChildOrder := 7;
    WebButton37.HeightPercent := 100.000000000000000000;
    WebButton37.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton37, Self, 'OnClick', 'WebButton37Click');
    WebDBEdit45.SetParentComponent(WebPanel24);
    WebDBEdit45.Name := 'WebDBEdit45';
    WebDBEdit45.Left := 496;
    WebDBEdit45.Top := 96;
    WebDBEdit45.Width := 300;
    WebDBEdit45.Height := 22;
    WebDBEdit45.ChildOrder := 3;
    WebDBEdit45.HeightPercent := 100.000000000000000000;
    WebDBEdit45.Text := 'WebDBEdit45';
    WebDBEdit45.WidthPercent := 100.000000000000000000;
    WebDBEdit45.DataField := 'xfuelFueleName';
    WebDBEdit45.DataSource := dsDieselDepots;
    WebButton39.SetParentComponent(WebPanel24);
    WebButton39.Name := 'WebButton39';
    WebButton39.Left := 802;
    WebButton39.Top := 94;
    WebButton39.Width := 30;
    WebButton39.Height := 25;
    WebButton39.Caption := '...';
    WebButton39.ChildOrder := 9;
    WebButton39.HeightPercent := 100.000000000000000000;
    WebButton39.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton39, Self, 'OnClick', 'WebButton39Click');
    WebPanel25.SetParentComponent(WebPanel10);
    WebPanel25.Name := 'WebPanel25';
    WebPanel25.Left := 0;
    WebPanel25.Top := 520;
    WebPanel25.Width := 935;
    WebPanel25.Height := 60;
    WebPanel25.Align := alBottom;
    WebPanel25.ChildOrder := 1;
    WebPanel25.Color := clSilver;
    WebPanel25.TabOrder := 1;
    WebButton19.SetParentComponent(WebPanel25);
    WebButton19.Name := 'WebButton19';
    WebButton19.Left := 145;
    WebButton19.Top := 16;
    WebButton19.Width := 96;
    WebButton19.Height := 25;
    WebButton19.Caption := 'Close';
    WebButton19.Color := clRed;
    WebButton19.ChildOrder := 6;
    WebButton19.HeightPercent := 100.000000000000000000;
    WebButton19.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton19, Self, 'OnClick', 'WebButton19Click');
    btnSaveDepotInfoThirdParty.SetParentComponent(WebPanel25);
    btnSaveDepotInfoThirdParty.Name := 'btnSaveDepotInfoThirdParty';
    btnSaveDepotInfoThirdParty.Left := 24;
    btnSaveDepotInfoThirdParty.Top := 16;
    btnSaveDepotInfoThirdParty.Width := 96;
    btnSaveDepotInfoThirdParty.Height := 25;
    btnSaveDepotInfoThirdParty.Caption := 'Save';
    btnSaveDepotInfoThirdParty.Color := clGreenyellow;
    btnSaveDepotInfoThirdParty.ChildOrder := 5;
    btnSaveDepotInfoThirdParty.HeightPercent := 100.000000000000000000;
    btnSaveDepotInfoThirdParty.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveDepotInfoThirdParty, Self, 'OnClick', 'btnSaveDepotInfoThirdPartyClick');
    WebPageControl1Sheet4.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet4.Name := 'WebPageControl1Sheet4';
    WebPageControl1Sheet4.Left := 0;
    WebPageControl1Sheet4.Top := 20;
    WebPageControl1Sheet4.Width := 935;
    WebPageControl1Sheet4.Height := 580;
    WebPageControl1Sheet4.Caption := 'WebPageControl1Sheet4';
    WebPageControl1Sheet4.ChildOrder := 3;
    WebPanel18.SetParentComponent(WebPageControl1Sheet4);
    WebPanel18.Name := 'WebPanel18';
    WebPanel18.Left := 0;
    WebPanel18.Top := 0;
    WebPanel18.Width := 935;
    WebPanel18.Height := 580;
    WebPanel18.Align := alClient;
    WebPanel18.TabOrder := 0;
    WebPanel19.SetParentComponent(WebPanel18);
    WebPanel19.Name := 'WebPanel19';
    WebPanel19.Left := 0;
    WebPanel19.Top := 0;
    WebPanel19.Width := 449;
    WebPanel19.Height := 580;
    WebPanel19.Align := alLeft;
    WebPanel19.TabOrder := 0;
    WebPanel21.SetParentComponent(WebPanel19);
    WebPanel21.Name := 'WebPanel21';
    WebPanel21.Left := 0;
    WebPanel21.Top := 0;
    WebPanel21.Width := 449;
    WebPanel21.Height := 60;
    WebPanel21.Align := alTop;
    WebPanel21.Color := clSilver;
    WebPanel21.TabOrder := 0;
    WebLabel40.SetParentComponent(WebPanel21);
    WebLabel40.Name := 'WebLabel40';
    WebLabel40.Left := 15;
    WebLabel40.Top := 11;
    WebLabel40.Width := 108;
    WebLabel40.Height := 15;
    WebLabel40.Caption := 'Search Depot Name:';
    WebLabel40.HeightPercent := 100.000000000000000000;
    WebLabel40.WidthPercent := 100.000000000000000000;
    WebButton44.SetParentComponent(WebPanel21);
    WebButton44.Name := 'WebButton44';
    WebButton44.Left := 321;
    WebButton44.Top := 29;
    WebButton44.Width := 96;
    WebButton44.Height := 25;
    WebButton44.Caption := 'Search';
    WebButton44.ChildOrder := 2;
    WebButton44.HeightPercent := 100.000000000000000000;
    WebButton44.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton44, Self, 'OnClick', 'WebButton44Click');
    edtDepotSearch.SetParentComponent(WebPanel21);
    edtDepotSearch.Name := 'edtDepotSearch';
    edtDepotSearch.Left := 15;
    edtDepotSearch.Top := 32;
    edtDepotSearch.Width := 284;
    edtDepotSearch.Height := 22;
    edtDepotSearch.ChildOrder := 2;
    edtDepotSearch.HeightPercent := 100.000000000000000000;
    edtDepotSearch.WidthPercent := 100.000000000000000000;
    dgDepots.SetParentComponent(WebPanel19);
    dgDepots.Name := 'dgDepots';
    dgDepots.Left := 0;
    dgDepots.Top := 60;
    dgDepots.Width := 449;
    dgDepots.Height := 460;
    dgDepots.Align := alClient;
    dgDepots.ParentDoubleBuffered := False;
    dgDepots.DoubleBuffered := True;
    dgDepots.TabOrder := 1;
    dgDepots.ShowAcceleratorChar := False;
    dgDepots.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgDepots.Header.VisualGrouping.Layout.Font.Height := -12;
    dgDepots.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgDepots.Header.VisualGrouping.Layout.Font.Style := [];
    dgDepots.Adapter := dgdbaDieselDepots;
    dgDepots.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgDepots.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgDepots.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgDepots.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgDepots.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.BandLayout.Font.Height := -12;
    dgDepots.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.BandLayout.Font.Style := [];
    dgDepots.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.FixedLayout.Font.Height := -12;
    dgDepots.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.FixedLayout.Font.Style := [];
    dgDepots.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgDepots.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgDepots.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.FocusedLayout.Font.Height := -12;
    dgDepots.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.FocusedLayout.Font.Style := [];
    dgDepots.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.GroupLayout.Font.Height := -12;
    dgDepots.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.GroupLayout.Font.Style := [];
    dgDepots.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.NormalLayout.Font.Height := -12;
    dgDepots.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.NormalLayout.Font.Style := [];
    dgDepots.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.SelectedLayout.Font.Height := -12;
    dgDepots.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.SelectedLayout.Font.Style := [];
    dgDepots.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgDepots.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgDepots.CellAppearance.SummaryLayout.Font.Height := -12;
    dgDepots.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgDepots.CellAppearance.SummaryLayout.Font.Style := [];
    dgDepots.ColumnCount := 65;
    dgDepots.Columns.Clear;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := '.';
      Settings := [gcsEditorItems];
      Width := 25.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Name := 'DepotName';
      Settings := [gcsEditorItems];
      Width := 225.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Tel';
      Name := 'DEPOTTEL';
      Settings := [gcsEditorItems];
      Width := 150.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgDepots.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    dgDepots.Designer := False;
    dgDepots.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgDepots.FilterAppearance.Font.Color := clWindowText;
    dgDepots.FilterAppearance.Font.Height := -12;
    dgDepots.FilterAppearance.Font.Name := 'Segoe UI';
    dgDepots.FilterAppearance.Font.Style := [];
    dgDepots.Icons.ExpandIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.ExpandIcon.svg');
    dgDepots.Icons.CollapseIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.CollapseIcon.svg');
    dgDepots.Icons.FilterIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.FilterIcon.svg');
    dgDepots.Icons.FilterActiveIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.FilterActiveIcon.svg');
    dgDepots.Icons.FilterClearIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.FilterClearIcon.svg');
    dgDepots.Icons.FilterTypeIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.FilterTypeIcon.svg');
    dgDepots.Icons.SortAscendingIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.SortAscendingIcon.svg');
    dgDepots.Icons.SortDescendingIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.SortDescendingIcon.svg');
    dgDepots.Icons.CloseIcon.LoadFromFile('DieselDepots.WebPanel19.dgDepots.Icons.CloseIcon.svg');
    SetEvent(dgDepots, Self, 'OnCellClick', 'dgDepotsCellClick');
    SetEvent(dgDepots, Self, 'OnSelectCell', 'dgDepotsSelectCell');
    dgDepots.RowCount := 1;
    dgdbaDieselDepots.SetParentComponent(dgDepots);
    dgdbaDieselDepots.Name := 'dgdbaDieselDepots';
    dgdbaDieselDepots.Left := 190;
    dgdbaDieselDepots.Top := 41;
    dgdbaDieselDepots.Width := 26;
    dgdbaDieselDepots.Height := 26;
    dgdbaDieselDepots.Visible := True;
    dgdbaDieselDepots.Columns.Clear;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DEPOTCODE';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DEPOTNAME';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DEPOTTEL';
      Header := 'Tel';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DEPOTFAX';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DEPOTEMAIL';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DEPOTCONTACTPERSONE';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'SUSPENDED';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'INVENTORYGL';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'AUTOPRINT';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'PRINTER';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'COSTGL';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'SALESGL';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'CONTROLSTOCK';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'CRECODE';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'CARDSYSTEM';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'MERCHANTNO';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'TOWN';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'SAGEPROJECT';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'NONSAGEEXPORT';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'BOWSERCODE';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'BULKORDERPREFIX';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DELVADDRESS1';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DELVADDRESS2';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DELVADDRESS3';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DELVADDRESS4';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'DELVADDRESSCODE';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'tfnonlinelink';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'tfnsuppliercode';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'tfndepotcode';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fmsonlinelink';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fmssupplier';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fmsdepotcode';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'stautocreateorder';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'autocancelorders';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'autocanceldays';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'shiptechlink';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'shiptechaccount';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'shiptechdepot';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'sendexternalsms';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'wholesalelic';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fuelusupplier';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fueludepotcode';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fueluonlinelink';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fuelonlinesystem';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fuelmanmanualorders';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fuelmancardpayments';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'xfuelsonlinelink';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'xfuelssuppliers';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'xfuelsdepotcode';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'tfninternalproduct';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'tfninternalproduct';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'summatechfueltype';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fmsfueltype';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'shiptechfueltype';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fmsfueltype';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'shiptechfueltype';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'fuelufueltype';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'xfuelfueltype';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'stdepotcode';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'tfnproduct';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'region';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'tfnuseinvoice';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'stonlinelink';
      AutoCreated := False;
    end;
    with dgdbaDieselDepots.Columns.Add do
    begin
      FieldName := 'stsupplier';
      AutoCreated := False;
    end;
    dgdbaDieselDepots.DataSource := dsDieselDepots;
    WebPanel22.SetParentComponent(WebPanel19);
    WebPanel22.Name := 'WebPanel22';
    WebPanel22.Left := 0;
    WebPanel22.Top := 520;
    WebPanel22.Width := 449;
    WebPanel22.Height := 60;
    WebPanel22.Align := alBottom;
    WebPanel22.ChildOrder := 2;
    WebPanel22.Color := clSilver;
    WebPanel22.TabOrder := 2;
    WebSpeedButton5.SetParentComponent(WebPanel22);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 24;
    WebSpeedButton5.Top := 16;
    WebSpeedButton5.Width := 24;
    WebSpeedButton5.Height := 24;
    WebSpeedButton5.Caption := '<<';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 0;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebSpeedButton6.SetParentComponent(WebPanel22);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 56;
    WebSpeedButton6.Top := 16;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := '<';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 1;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton7.SetParentComponent(WebPanel22);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 167;
    WebSpeedButton7.Top := 16;
    WebSpeedButton7.Width := 24;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := '>';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 2;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton8.SetParentComponent(WebPanel22);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 197;
    WebSpeedButton8.Top := 16;
    WebSpeedButton8.Width := 24;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := '>>';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 3;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    edtDieselDepotsPC.SetParentComponent(WebPanel22);
    edtDieselDepotsPC.Name := 'edtDieselDepotsPC';
    edtDieselDepotsPC.Left := 87;
    edtDieselDepotsPC.Top := 16;
    edtDieselDepotsPC.Width := 70;
    edtDieselDepotsPC.Height := 22;
    edtDieselDepotsPC.ChildOrder := 4;
    edtDieselDepotsPC.HeightPercent := 100.000000000000000000;
    edtDieselDepotsPC.WidthPercent := 100.000000000000000000;
    WebPanel20.SetParentComponent(WebPanel18);
    WebPanel20.Name := 'WebPanel20';
    WebPanel20.Left := 449;
    WebPanel20.Top := 0;
    WebPanel20.Width := 486;
    WebPanel20.Height := 580;
    WebPanel20.Align := alLeft;
    WebPanel20.Caption := 'WebPanel20';
    WebPanel20.ChildOrder := 1;
    WebPanel20.TabOrder := 1;
    WebPanel23.SetParentComponent(WebPanel20);
    WebPanel23.Name := 'WebPanel23';
    WebPanel23.Left := 0;
    WebPanel23.Top := 520;
    WebPanel23.Width := 486;
    WebPanel23.Height := 60;
    WebPanel23.Align := alBottom;
    WebPanel23.ChildOrder := 1;
    WebPanel23.Color := clSilver;
    WebPanel23.TabOrder := 0;
    WebSpeedButton9.SetParentComponent(WebPanel23);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 16;
    WebSpeedButton9.Top := 16;
    WebSpeedButton9.Width := 24;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := '<<';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 0;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebSpeedButton10.SetParentComponent(WebPanel23);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 49;
    WebSpeedButton10.Top := 16;
    WebSpeedButton10.Width := 24;
    WebSpeedButton10.Height := 24;
    WebSpeedButton10.Caption := '<';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.TabOrder := 1;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebSpeedButton11.SetParentComponent(WebPanel23);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 174;
    WebSpeedButton11.Top := 16;
    WebSpeedButton11.Width := 24;
    WebSpeedButton11.Height := 24;
    WebSpeedButton11.Caption := '>';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.TabOrder := 2;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebSpeedButton12.SetParentComponent(WebPanel23);
    WebSpeedButton12.Name := 'WebSpeedButton12';
    WebSpeedButton12.Left := 204;
    WebSpeedButton12.Top := 16;
    WebSpeedButton12.Width := 24;
    WebSpeedButton12.Height := 24;
    WebSpeedButton12.Caption := '>>';
    WebSpeedButton12.Color := clNone;
    WebSpeedButton12.HeightPercent := 100.000000000000000000;
    WebSpeedButton12.TabOrder := 3;
    WebSpeedButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton12, Self, 'OnClick', 'WebSpeedButton12Click');
    edtDepotPriceList.SetParentComponent(WebPanel23);
    edtDepotPriceList.Name := 'edtDepotPriceList';
    edtDepotPriceList.Left := 79;
    edtDepotPriceList.Top := 16;
    edtDepotPriceList.Width := 89;
    edtDepotPriceList.Height := 22;
    edtDepotPriceList.ChildOrder := 4;
    edtDepotPriceList.HeightPercent := 100.000000000000000000;
    edtDepotPriceList.WidthPercent := 100.000000000000000000;
    TMSFNCDataGrid3.SetParentComponent(WebPanel20);
    TMSFNCDataGrid3.Name := 'TMSFNCDataGrid3';
    TMSFNCDataGrid3.Left := 0;
    TMSFNCDataGrid3.Top := 0;
    TMSFNCDataGrid3.Width := 486;
    TMSFNCDataGrid3.Height := 520;
    TMSFNCDataGrid3.Align := alClient;
    TMSFNCDataGrid3.ParentDoubleBuffered := False;
    TMSFNCDataGrid3.DoubleBuffered := True;
    TMSFNCDataGrid3.TabOrder := 1;
    TMSFNCDataGrid3.ShowAcceleratorChar := False;
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid3.Adapter := dgdbaDepotPriceListView;
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid3.ColumnCount := 15;
    TMSFNCDataGrid3.Columns.Clear;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Fuel Type';
      Name := 'fueltypename';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'AUTONO';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'DEPOTCODE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Date';
      Name := 'FROMDATE';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'TODATE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'DEDSUBPRICE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'SPECIALPRICE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICELOADDATE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICELOADBY';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICECONFIRMDATE';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICECONFIRMBY';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'PRICECONFIRMED';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Cost Price';
      Name := 'COSTPRICE';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'STD Price';
      Name := 'STDPRICE';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid3.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Name := 'fueltype';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    TMSFNCDataGrid3.Designer := False;
    TMSFNCDataGrid3.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid3.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid3.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid3.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid3.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid3.Icons.ExpandIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.ExpandIcon.svg');
    TMSFNCDataGrid3.Icons.CollapseIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.CollapseIcon.svg');
    TMSFNCDataGrid3.Icons.FilterIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.FilterIcon.svg');
    TMSFNCDataGrid3.Icons.FilterActiveIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid3.Icons.FilterClearIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid3.Icons.FilterTypeIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid3.Icons.SortAscendingIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid3.Icons.SortDescendingIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid3.Icons.CloseIcon.LoadFromFile('DieselDepots.WebPanel20.TMSFNCDataGrid3.Icons.CloseIcon.svg');
    SetEvent(TMSFNCDataGrid3, Self, 'OnCellClick', 'dgDepotPriceListSetupCellClick');
    TMSFNCDataGrid3.RowCount := 1;
    TMSFNCDataGridDatabaseAdapter1.SetParentComponent(TMSFNCDataGrid3);
    TMSFNCDataGridDatabaseAdapter1.Name := 'TMSFNCDataGridDatabaseAdapter1';
    TMSFNCDataGridDatabaseAdapter1.Left := 591;
    TMSFNCDataGridDatabaseAdapter1.Top := 109;
    TMSFNCDataGridDatabaseAdapter1.Width := 26;
    TMSFNCDataGridDatabaseAdapter1.Height := 26;
    TMSFNCDataGridDatabaseAdapter1.Visible := True;
    TMSFNCDataGridDatabaseAdapter1.Columns.Clear;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'AUTONO';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'DEPOTCODE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'FROMDATE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'TODATE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'COSTPRICE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'STDPRICE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'DEDSUBPRICE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'SPECIALPRICE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'PRICELOADDATE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'PRICELOADBY';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMDATE';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMBY';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'fueltype';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'fueltypename';
      AutoCreated := False;
    end;
    TMSFNCDataGridDatabaseAdapter1.DataSource := dsDepotPriceList;
    dgdbaDepotPriceListView.SetParentComponent(TMSFNCDataGrid3);
    dgdbaDepotPriceListView.Name := 'dgdbaDepotPriceListView';
    dgdbaDepotPriceListView.Left := 212;
    dgdbaDepotPriceListView.Top := 103;
    dgdbaDepotPriceListView.Width := 26;
    dgdbaDepotPriceListView.Height := 26;
    dgdbaDepotPriceListView.Visible := True;
    dgdbaDepotPriceListView.Columns.Clear;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'fueltypename';
      Header := 'Fuel Type';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'AUTONO';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'DEPOTCODE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'FROMDATE';
      Header := 'Date';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'TODATE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'DEDSUBPRICE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'SPECIALPRICE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'PRICELOADDATE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'PRICELOADBY';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMDATE';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMBY';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMED';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'COSTPRICE';
      Header := 'Cost Price';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'STDPRICE';
      Header := 'STD Price';
      AutoCreated := False;
    end;
    with dgdbaDepotPriceListView.Columns.Add do
    begin
      FieldName := 'fueltype';
      AutoCreated := False;
    end;
    dgdbaDepotPriceListView.DataSource := dsDepotPriceList;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 60;
    WebPanel3.Width := 935;
    WebPanel3.Height := 60;
    WebPanel3.Align := alTop;
    WebPanel3.ChildOrder := 2;
    WebPanel3.TabOrder := 2;
    btnInsertDepot.SetParentComponent(WebPanel3);
    btnInsertDepot.Name := 'btnInsertDepot';
    btnInsertDepot.Left := 3;
    btnInsertDepot.Top := 16;
    btnInsertDepot.Width := 108;
    btnInsertDepot.Height := 25;
    btnInsertDepot.Caption := 'Insert New depot';
    btnInsertDepot.Color := clAqua;
    btnInsertDepot.ChildOrder := 1;
    btnInsertDepot.HeightPercent := 100.000000000000000000;
    btnInsertDepot.WidthPercent := 100.000000000000000000;
    SetEvent(btnInsertDepot, Self, 'OnClick', 'btnInsertDepotClick');
    btnEditDepot.SetParentComponent(WebPanel3);
    btnEditDepot.Name := 'btnEditDepot';
    btnEditDepot.Left := 117;
    btnEditDepot.Top := 16;
    btnEditDepot.Width := 110;
    btnEditDepot.Height := 25;
    btnEditDepot.Caption := 'Change Depot Info';
    btnEditDepot.Color := clAqua;
    btnEditDepot.ChildOrder := 2;
    btnEditDepot.HeightPercent := 100.000000000000000000;
    btnEditDepot.WidthPercent := 100.000000000000000000;
    SetEvent(btnEditDepot, Self, 'OnClick', 'btnEditDepotClick');
    btnSuspended.SetParentComponent(WebPanel3);
    btnSuspended.Name := 'btnSuspended';
    btnSuspended.Left := 233;
    btnSuspended.Top := 16;
    btnSuspended.Width := 105;
    btnSuspended.Height := 25;
    btnSuspended.Caption := 'Suspend depot';
    btnSuspended.Color := clAqua;
    btnSuspended.ChildOrder := 3;
    btnSuspended.HeightPercent := 100.000000000000000000;
    btnSuspended.WidthPercent := 100.000000000000000000;
    SetEvent(btnSuspended, Self, 'OnClick', 'btnSuspendedClick');
    cbxSuspended.SetParentComponent(WebPanel3);
    cbxSuspended.Name := 'cbxSuspended';
    cbxSuspended.Left := 360;
    cbxSuspended.Top := 16;
    cbxSuspended.Width := 113;
    cbxSuspended.Height := 22;
    cbxSuspended.Caption := 'Show Suspended';
    cbxSuspended.ChildOrder := 3;
    cbxSuspended.HeightPercent := 100.000000000000000000;
    cbxSuspended.WidthPercent := 100.000000000000000000;
    SetEvent(cbxSuspended, Self, 'OnClick', 'WebCheckBox1Click');
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 720;
    WebPanel4.Width := 935;
    WebPanel4.Height := 60;
    WebPanel4.Align := alBottom;
    WebPanel4.ChildOrder := 3;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 3;
    WebButton6.SetParentComponent(WebPanel4);
    WebButton6.Name := 'WebButton6';
    WebButton6.Left := 15;
    WebButton6.Top := 16;
    WebButton6.Width := 96;
    WebButton6.Height := 25;
    WebButton6.Caption := 'Close';
    WebButton6.Color := clRed;
    WebButton6.HeightPercent := 100.000000000000000000;
    WebButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton6, Self, 'OnClick', 'WebButton6Click');
    wcDieselDepots.SetParentComponent(Self);
    wcDieselDepots.Name := 'wcDieselDepots';
    wcDieselDepots.Connection := dmData.dbConnect;
    wcDieselDepots.Left := 88;
    wcDieselDepots.Top := 72;
    wdsDieselDepots.SetParentComponent(Self);
    wdsDieselDepots.Name := 'wdsDieselDepots';
    wdsDieselDepots.Connection := dmData.dbConnect;
    wdsDieselDepots.Left := 144;
    wdsDieselDepots.Top := 64;
    wdsDieselDepotsDEPOTCODE.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDEPOTCODE.Name := 'wdsDieselDepotsDEPOTCODE';
    wdsDieselDepotsDEPOTCODE.FieldName := 'DEPOTCODE';
    wdsDieselDepotsDEPOTNAME.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDEPOTNAME.Name := 'wdsDieselDepotsDEPOTNAME';
    wdsDieselDepotsDEPOTNAME.FieldName := 'DEPOTNAME';
    wdsDieselDepotsDEPOTTEL.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDEPOTTEL.Name := 'wdsDieselDepotsDEPOTTEL';
    wdsDieselDepotsDEPOTTEL.FieldName := 'DEPOTTEL';
    wdsDieselDepotsDEPOTFAX.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDEPOTFAX.Name := 'wdsDieselDepotsDEPOTFAX';
    wdsDieselDepotsDEPOTFAX.FieldName := 'DEPOTFAX';
    wdsDieselDepotsDEPOTEMAIL.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDEPOTEMAIL.Name := 'wdsDieselDepotsDEPOTEMAIL';
    wdsDieselDepotsDEPOTEMAIL.FieldName := 'DEPOTEMAIL';
    wdsDieselDepotsDEPOTCONTACTPERSONE.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDEPOTCONTACTPERSONE.Name := 'wdsDieselDepotsDEPOTCONTACTPERSONE';
    wdsDieselDepotsDEPOTCONTACTPERSONE.FieldName := 'DEPOTCONTACTPERSONE';
    wdsDieselDepotsSUSPENDED.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsSUSPENDED.Name := 'wdsDieselDepotsSUSPENDED';
    wdsDieselDepotsSUSPENDED.FieldName := 'SUSPENDED';
    wdsDieselDepotsINVENTORYGL.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsINVENTORYGL.Name := 'wdsDieselDepotsINVENTORYGL';
    wdsDieselDepotsINVENTORYGL.FieldName := 'INVENTORYGL';
    wdsDieselDepotsAUTOPRINT.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsAUTOPRINT.Name := 'wdsDieselDepotsAUTOPRINT';
    wdsDieselDepotsAUTOPRINT.FieldName := 'AUTOPRINT';
    wdsDieselDepotsPRINTER.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsPRINTER.Name := 'wdsDieselDepotsPRINTER';
    wdsDieselDepotsPRINTER.FieldName := 'PRINTER';
    wdsDieselDepotsCOSTGL.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsCOSTGL.Name := 'wdsDieselDepotsCOSTGL';
    wdsDieselDepotsCOSTGL.FieldName := 'COSTGL';
    wdsDieselDepotsSALESGL.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsSALESGL.Name := 'wdsDieselDepotsSALESGL';
    wdsDieselDepotsSALESGL.FieldName := 'SALESGL';
    wdsDieselDepotsCONTROLSTOCK.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsCONTROLSTOCK.Name := 'wdsDieselDepotsCONTROLSTOCK';
    wdsDieselDepotsCONTROLSTOCK.FieldName := 'CONTROLSTOCK';
    wdsDieselDepotsCRECODE.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsCRECODE.Name := 'wdsDieselDepotsCRECODE';
    wdsDieselDepotsCRECODE.FieldName := 'CRECODE';
    wdsDieselDepotsCARDSYSTEM.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsCARDSYSTEM.Name := 'wdsDieselDepotsCARDSYSTEM';
    wdsDieselDepotsCARDSYSTEM.FieldName := 'CARDSYSTEM';
    wdsDieselDepotsMERCHANTNO.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsMERCHANTNO.Name := 'wdsDieselDepotsMERCHANTNO';
    wdsDieselDepotsMERCHANTNO.FieldName := 'MERCHANTNO';
    wdsDieselDepotsTOWN.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsTOWN.Name := 'wdsDieselDepotsTOWN';
    wdsDieselDepotsTOWN.FieldName := 'TOWN';
    wdsDieselDepotsSAGEPROJECT.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsSAGEPROJECT.Name := 'wdsDieselDepotsSAGEPROJECT';
    wdsDieselDepotsSAGEPROJECT.FieldName := 'SAGEPROJECT';
    wdsDieselDepotsNONSAGEEXPORT.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsNONSAGEEXPORT.Name := 'wdsDieselDepotsNONSAGEEXPORT';
    wdsDieselDepotsNONSAGEEXPORT.FieldName := 'NONSAGEEXPORT';
    wdsDieselDepotsBOWSERCODE.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsBOWSERCODE.Name := 'wdsDieselDepotsBOWSERCODE';
    wdsDieselDepotsBOWSERCODE.FieldName := 'BOWSERCODE';
    wdsDieselDepotsBULKORDERPREFIX.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsBULKORDERPREFIX.Name := 'wdsDieselDepotsBULKORDERPREFIX';
    wdsDieselDepotsBULKORDERPREFIX.FieldName := 'BULKORDERPREFIX';
    wdsDieselDepotsDELVADDRESS1.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDELVADDRESS1.Name := 'wdsDieselDepotsDELVADDRESS1';
    wdsDieselDepotsDELVADDRESS1.FieldName := 'DELVADDRESS1';
    wdsDieselDepotsDELVADDRESS2.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDELVADDRESS2.Name := 'wdsDieselDepotsDELVADDRESS2';
    wdsDieselDepotsDELVADDRESS2.FieldName := 'DELVADDRESS2';
    wdsDieselDepotsDELVADDRESS3.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDELVADDRESS3.Name := 'wdsDieselDepotsDELVADDRESS3';
    wdsDieselDepotsDELVADDRESS3.FieldName := 'DELVADDRESS3';
    wdsDieselDepotsDELVADDRESS4.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDELVADDRESS4.Name := 'wdsDieselDepotsDELVADDRESS4';
    wdsDieselDepotsDELVADDRESS4.FieldName := 'DELVADDRESS4';
    wdsDieselDepotsDELVADDRESSCODE.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsDELVADDRESSCODE.Name := 'wdsDieselDepotsDELVADDRESSCODE';
    wdsDieselDepotsDELVADDRESSCODE.FieldName := 'DELVADDRESSCODE';
    wdsDieselDepotstfnonlinelink.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotstfnonlinelink.Name := 'wdsDieselDepotstfnonlinelink';
    wdsDieselDepotstfnonlinelink.FieldName := 'tfnonlinelink';
    wdsDieselDepotstfnsuppliercode.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotstfnsuppliercode.Name := 'wdsDieselDepotstfnsuppliercode';
    wdsDieselDepotstfnsuppliercode.FieldName := 'tfnsuppliercode';
    wdsDieselDepotstfndepotcode.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotstfndepotcode.Name := 'wdsDieselDepotstfndepotcode';
    wdsDieselDepotstfndepotcode.FieldName := 'tfndepotcode';
    wdsDieselDepotsfmsonlinelink.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfmsonlinelink.Name := 'wdsDieselDepotsfmsonlinelink';
    wdsDieselDepotsfmsonlinelink.FieldName := 'fmsonlinelink';
    wdsDieselDepotsfmssupplier.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfmssupplier.Name := 'wdsDieselDepotsfmssupplier';
    wdsDieselDepotsfmssupplier.FieldName := 'fmssupplier';
    wdsDieselDepotsstdepotcode.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsstdepotcode.Name := 'wdsDieselDepotsstdepotcode';
    wdsDieselDepotsstdepotcode.FieldName := 'stdepotcode';
    wdsDieselDepotstfnproduct.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotstfnproduct.Name := 'wdsDieselDepotstfnproduct';
    wdsDieselDepotstfnproduct.FieldName := 'tfnproduct';
    wdsDieselDepotstfnuseinvoice.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotstfnuseinvoice.Name := 'wdsDieselDepotstfnuseinvoice';
    wdsDieselDepotstfnuseinvoice.FieldName := 'tfnuseinvoice';
    wdsDieselDepotsstonlinelink.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsstonlinelink.Name := 'wdsDieselDepotsstonlinelink';
    wdsDieselDepotsstonlinelink.FieldName := 'stonlinelink';
    wdsDieselDepotsstsupplier.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsstsupplier.Name := 'wdsDieselDepotsstsupplier';
    wdsDieselDepotsstsupplier.FieldName := 'stsupplier';
    wdsDieselDepotsfmsdepotcode.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfmsdepotcode.Name := 'wdsDieselDepotsfmsdepotcode';
    wdsDieselDepotsfmsdepotcode.FieldName := 'fmsdepotcode';
    wdsDieselDepotsstautocreateorder.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsstautocreateorder.Name := 'wdsDieselDepotsstautocreateorder';
    wdsDieselDepotsstautocreateorder.FieldName := 'stautocreateorder';
    wdsDieselDepotsautocancelorders.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsautocancelorders.Name := 'wdsDieselDepotsautocancelorders';
    wdsDieselDepotsautocancelorders.FieldName := 'autocancelorders';
    wdsDieselDepotsautocanceldays.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsautocanceldays.Name := 'wdsDieselDepotsautocanceldays';
    wdsDieselDepotsautocanceldays.FieldName := 'autocanceldays';
    wdsDieselDepotsshiptechlink.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsshiptechlink.Name := 'wdsDieselDepotsshiptechlink';
    wdsDieselDepotsshiptechlink.FieldName := 'shiptechlink';
    wdsDieselDepotsshiptechaccount.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsshiptechaccount.Name := 'wdsDieselDepotsshiptechaccount';
    wdsDieselDepotsshiptechaccount.FieldName := 'shiptechaccount';
    wdsDieselDepotsshiptechdepot.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsshiptechdepot.Name := 'wdsDieselDepotsshiptechdepot';
    wdsDieselDepotsshiptechdepot.FieldName := 'shiptechdepot';
    wdsDieselDepotssendexternalsms.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotssendexternalsms.Name := 'wdsDieselDepotssendexternalsms';
    wdsDieselDepotssendexternalsms.FieldName := 'sendexternalsms';
    wdsDieselDepotswholesalelic.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotswholesalelic.Name := 'wdsDieselDepotswholesalelic';
    wdsDieselDepotswholesalelic.FieldName := 'wholesalelic';
    wdsDieselDepotsfuelusupplier.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfuelusupplier.Name := 'wdsDieselDepotsfuelusupplier';
    wdsDieselDepotsfuelusupplier.FieldName := 'fuelusupplier';
    wdsDieselDepotsfueludepotcode.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfueludepotcode.Name := 'wdsDieselDepotsfueludepotcode';
    wdsDieselDepotsfueludepotcode.FieldName := 'fueludepotcode';
    wdsDieselDepotsfueluonlinelink.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfueluonlinelink.Name := 'wdsDieselDepotsfueluonlinelink';
    wdsDieselDepotsfueluonlinelink.FieldName := 'fueluonlinelink';
    wdsDieselDepotsfuelonlinesystem.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfuelonlinesystem.Name := 'wdsDieselDepotsfuelonlinesystem';
    wdsDieselDepotsfuelonlinesystem.FieldName := 'fuelonlinesystem';
    wdsDieselDepotsfuelmanmanualorders.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfuelmanmanualorders.Name := 'wdsDieselDepotsfuelmanmanualorders';
    wdsDieselDepotsfuelmanmanualorders.FieldName := 'fuelmanmanualorders';
    wdsDieselDepotsfuelmancardpayments.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfuelmancardpayments.Name := 'wdsDieselDepotsfuelmancardpayments';
    wdsDieselDepotsfuelmancardpayments.FieldName := 'fuelmancardpayments';
    wdsDieselDepotsxfuelsonlinelink.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsxfuelsonlinelink.Name := 'wdsDieselDepotsxfuelsonlinelink';
    wdsDieselDepotsxfuelsonlinelink.FieldName := 'xfuelsonlinelink';
    wdsDieselDepotsxfuelssuppliers.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsxfuelssuppliers.Name := 'wdsDieselDepotsxfuelssuppliers';
    wdsDieselDepotsxfuelssuppliers.FieldName := 'xfuelssuppliers';
    wdsDieselDepotsxfuelsdepotcode.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsxfuelsdepotcode.Name := 'wdsDieselDepotsxfuelsdepotcode';
    wdsDieselDepotsxfuelsdepotcode.FieldName := 'xfuelsdepotcode';
    wdsDieselDepotsregion.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsregion.Name := 'wdsDieselDepotsregion';
    wdsDieselDepotsregion.FieldName := 'region';
    wdsDieselDepotsTFNDepotName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsTFNDepotName.Name := 'wdsDieselDepotsTFNDepotName';
    wdsDieselDepotsTFNDepotName.FieldName := 'TFNDepotName';
    wdsDieselDepotsMasterAccount.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsMasterAccount.Name := 'wdsDieselDepotsMasterAccount';
    wdsDieselDepotsMasterAccount.FieldName := 'MasterAccount';
    wdsDieselDepotsTFNFuelTypeName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsTFNFuelTypeName.Name := 'wdsDieselDepotsTFNFuelTypeName';
    wdsDieselDepotsTFNFuelTypeName.FieldName := 'TFNFuelTypeName';
    wdsDieselDepotsTFNProductName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsTFNProductName.Name := 'wdsDieselDepotsTFNProductName';
    wdsDieselDepotsTFNProductName.FieldName := 'TFNProductName';
    wdsDieselDepotsSummaTechCRName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsSummaTechCRName.Name := 'wdsDieselDepotsSummaTechCRName';
    wdsDieselDepotsSummaTechCRName.FieldName := 'SummaTechCRName';
    wdsDieselDepotsstdName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsstdName.Name := 'wdsDieselDepotsstdName';
    wdsDieselDepotsstdName.FieldName := 'stdName';
    wdsDieselDepotsstFuelTypeName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsstFuelTypeName.Name := 'wdsDieselDepotsstFuelTypeName';
    wdsDieselDepotsstFuelTypeName.FieldName := 'stFuelTypeName';
    wdsDieselDepotsFMSCRName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsFMSCRName.Name := 'wdsDieselDepotsFMSCRName';
    wdsDieselDepotsFMSCRName.FieldName := 'FMSCRName';
    wdsDieselDepotsfmsDepotName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfmsDepotName.Name := 'wdsDieselDepotsfmsDepotName';
    wdsDieselDepotsfmsDepotName.FieldName := 'fmsDepotName';
    wdsDieselDepotsfmsFuelTypeName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfmsFuelTypeName.Name := 'wdsDieselDepotsfmsFuelTypeName';
    wdsDieselDepotsfmsFuelTypeName.FieldName := 'fmsFuelTypeName';
    wdsDieselDepotsshiptechDepotName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsshiptechDepotName.Name := 'wdsDieselDepotsshiptechDepotName';
    wdsDieselDepotsshiptechDepotName.FieldName := 'shiptechDepotName';
    wdsDieselDepotsShipTechFuelTypeName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsShipTechFuelTypeName.Name := 'wdsDieselDepotsShipTechFuelTypeName';
    wdsDieselDepotsShipTechFuelTypeName.FieldName := 'ShipTechFuelTypeName';
    wdsDieselDepotsFuelUCRName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsFuelUCRName.Name := 'wdsDieselDepotsFuelUCRName';
    wdsDieselDepotsFuelUCRName.FieldName := 'FuelUCRName';
    wdsDieselDepotsFuelUDepotName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsFuelUDepotName.Name := 'wdsDieselDepotsFuelUDepotName';
    wdsDieselDepotsFuelUDepotName.FieldName := 'FuelUDepotName';
    wdsDieselDepotsFuelUFueltypeName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsFuelUFueltypeName.Name := 'wdsDieselDepotsFuelUFueltypeName';
    wdsDieselDepotsFuelUFueltypeName.FieldName := 'FuelUFueltypeName';
    wdsDieselDepotsxFuelCRName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsxFuelCRName.Name := 'wdsDieselDepotsxFuelCRName';
    wdsDieselDepotsxFuelCRName.FieldName := 'xFuelCRName';
    wdsDieselDepotsXFuelDepotName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsXFuelDepotName.Name := 'wdsDieselDepotsXFuelDepotName';
    wdsDieselDepotsXFuelDepotName.FieldName := 'XFuelDepotName';
    wdsDieselDepotsxfuelFueleName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsxfuelFueleName.Name := 'wdsDieselDepotsxfuelFueleName';
    wdsDieselDepotsxfuelFueleName.FieldName := 'xfuelFueleName';
    wdsDieselDepotsTFNCRName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsTFNCRName.Name := 'wdsDieselDepotsTFNCRName';
    wdsDieselDepotsTFNCRName.FieldName := 'TFNCRName';
    wdsDieselDepotsShiptechCRName.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsShiptechCRName.Name := 'wdsDieselDepotsShiptechCRName';
    wdsDieselDepotsShiptechCRName.FieldName := 'ShiptechCRName';
    wdsDieselDepotsfueltypename.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfueltypename.Name := 'wdsDieselDepotsfueltypename';
    wdsDieselDepotsfueltypename.FieldName := 'fueltypename';
    wdsDieselDepotstfninternalproduct.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotstfninternalproduct.Name := 'wdsDieselDepotstfninternalproduct';
    wdsDieselDepotstfninternalproduct.FieldName := 'tfninternalproduct';
    wdsDieselDepotssummatechfueltype.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotssummatechfueltype.Name := 'wdsDieselDepotssummatechfueltype';
    wdsDieselDepotssummatechfueltype.FieldName := 'summatechfueltype';
    wdsDieselDepotsfmsfueltype.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfmsfueltype.Name := 'wdsDieselDepotsfmsfueltype';
    wdsDieselDepotsfmsfueltype.FieldName := 'fmsfueltype';
    wdsDieselDepotsshiptechfueltype.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsshiptechfueltype.Name := 'wdsDieselDepotsshiptechfueltype';
    wdsDieselDepotsshiptechfueltype.FieldName := 'shiptechfueltype';
    wdsDieselDepotsfuelufueltype.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsfuelufueltype.Name := 'wdsDieselDepotsfuelufueltype';
    wdsDieselDepotsfuelufueltype.FieldName := 'fuelufueltype';
    wdsDieselDepotsxfuelfueltype.SetParentComponent(wdsDieselDepots);
    wdsDieselDepotsxfuelfueltype.Name := 'wdsDieselDepotsxfuelfueltype';
    wdsDieselDepotsxfuelfueltype.FieldName := 'xfuelfueltype';
    dsDieselDepots.SetParentComponent(Self);
    dsDieselDepots.Name := 'dsDieselDepots';
    dsDieselDepots.DataSet := wdsDieselDepots;
    dsDieselDepots.Left := 240;
    dsDieselDepots.Top := 64;
    wcDepotPriceList.SetParentComponent(Self);
    wcDepotPriceList.Name := 'wcDepotPriceList';
    wcDepotPriceList.Connection := dmData.dbConnect;
    wcDepotPriceList.Left := 577;
    wcDepotPriceList.Top := 68;
    wdsDepotPriceList.SetParentComponent(Self);
    wdsDepotPriceList.Name := 'wdsDepotPriceList';
    wdsDepotPriceList.Connection := dmData.dbConnect;
    wdsDepotPriceList.Left := 641;
    wdsDepotPriceList.Top := 68;
    wdsDepotPriceListAUTONO.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListAUTONO.Name := 'wdsDepotPriceListAUTONO';
    wdsDepotPriceListAUTONO.FieldName := 'AUTONO';
    wdsDepotPriceListDEPOTCODE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListDEPOTCODE.Name := 'wdsDepotPriceListDEPOTCODE';
    wdsDepotPriceListDEPOTCODE.FieldName := 'DEPOTCODE';
    wdsDepotPriceListCOSTPRICE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListCOSTPRICE.Name := 'wdsDepotPriceListCOSTPRICE';
    wdsDepotPriceListCOSTPRICE.FieldName := 'COSTPRICE';
    wdsDepotPriceListSTDPRICE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListSTDPRICE.Name := 'wdsDepotPriceListSTDPRICE';
    wdsDepotPriceListSTDPRICE.FieldName := 'STDPRICE';
    wdsDepotPriceListDEDSUBPRICE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListDEDSUBPRICE.Name := 'wdsDepotPriceListDEDSUBPRICE';
    wdsDepotPriceListDEDSUBPRICE.FieldName := 'DEDSUBPRICE';
    wdsDepotPriceListSPECIALPRICE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListSPECIALPRICE.Name := 'wdsDepotPriceListSPECIALPRICE';
    wdsDepotPriceListSPECIALPRICE.FieldName := 'SPECIALPRICE';
    wdsDepotPriceListPRICELOADBY.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICELOADBY.Name := 'wdsDepotPriceListPRICELOADBY';
    wdsDepotPriceListPRICELOADBY.FieldName := 'PRICELOADBY';
    wdsDepotPriceListPRICECONFIRMBY.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICECONFIRMBY.Name := 'wdsDepotPriceListPRICECONFIRMBY';
    wdsDepotPriceListPRICECONFIRMBY.FieldName := 'PRICECONFIRMBY';
    wdsDepotPriceListPRICECONFIRMED.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICECONFIRMED.Name := 'wdsDepotPriceListPRICECONFIRMED';
    wdsDepotPriceListPRICECONFIRMED.FieldName := 'PRICECONFIRMED';
    wdsDepotPriceListfueltype.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListfueltype.Name := 'wdsDepotPriceListfueltype';
    wdsDepotPriceListfueltype.FieldName := 'fueltype';
    wdsDepotPriceListfueltypename.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListfueltypename.Name := 'wdsDepotPriceListfueltypename';
    wdsDepotPriceListfueltypename.FieldName := 'fueltypename';
    wdsDepotPriceListFROMDATE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListFROMDATE.Name := 'wdsDepotPriceListFROMDATE';
    wdsDepotPriceListFROMDATE.FieldName := 'FROMDATE';
    wdsDepotPriceListTODATE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListTODATE.Name := 'wdsDepotPriceListTODATE';
    wdsDepotPriceListTODATE.FieldName := 'TODATE';
    wdsDepotPriceListPRICELOADDATE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICELOADDATE.Name := 'wdsDepotPriceListPRICELOADDATE';
    wdsDepotPriceListPRICELOADDATE.FieldName := 'PRICELOADDATE';
    wdsDepotPriceListPRICELOADDATE.Size := 0;
    wdsDepotPriceListPRICECONFIRMDATE.SetParentComponent(wdsDepotPriceList);
    wdsDepotPriceListPRICECONFIRMDATE.Name := 'wdsDepotPriceListPRICECONFIRMDATE';
    wdsDepotPriceListPRICECONFIRMDATE.FieldName := 'PRICECONFIRMDATE';
    dsDepotPriceList.SetParentComponent(Self);
    dsDepotPriceList.Name := 'dsDepotPriceList';
    dsDepotPriceList.DataSet := wdsDepotPriceList;
    dsDepotPriceList.Left := 705;
    dsDepotPriceList.Top := 84;
    RESTClient1.SetParentComponent(Self);
    RESTClient1.Name := 'RESTClient1';
    RESTClient1.LoginHeight := 0;
    RESTClient1.LoginWidth := 0;
    RESTClient1.Left := 816;
    RESTClient1.Top := 74;
    wcTFNDepot.SetParentComponent(Self);
    wcTFNDepot.Name := 'wcTFNDepot';
    wcTFNDepot.Connection := dmData.dbConnect;
    wcTFNDepot.Left := 56;
    wcTFNDepot.Top := 292;
    wdsTFNDepots.SetParentComponent(Self);
    wdsTFNDepots.Name := 'wdsTFNDepots';
    wdsTFNDepots.Connection := dmData.dbConnect;
    wdsTFNDepots.Left := 120;
    wdsTFNDepots.Top := 292;
    wdsTFNDepotsnumber.SetParentComponent(wdsTFNDepots);
    wdsTFNDepotsnumber.Name := 'wdsTFNDepotsnumber';
    wdsTFNDepotsnumber.FieldName := 'number';
    wdsTFNDepotsname.SetParentComponent(wdsTFNDepots);
    wdsTFNDepotsname.Name := 'wdsTFNDepotsname';
    wdsTFNDepotsname.FieldName := 'name';
    wdsTFNDepotsregion.SetParentComponent(wdsTFNDepots);
    wdsTFNDepotsregion.Name := 'wdsTFNDepotsregion';
    wdsTFNDepotsregion.FieldName := 'region';
    dsTFNDepots.SetParentComponent(Self);
    dsTFNDepots.Name := 'dsTFNDepots';
    dsTFNDepots.DataSet := wdsTFNDepots;
    dsTFNDepots.Left := 176;
    dsTFNDepots.Top := 292;
    wdsTFNProducts.SetParentComponent(Self);
    wdsTFNProducts.Name := 'wdsTFNProducts';
    wdsTFNProducts.Connection := dmData.dbConnect;
    wdsTFNProducts.Left := 128;
    wdsTFNProducts.Top := 347;
    wdsTFNProductscode.SetParentComponent(wdsTFNProducts);
    wdsTFNProductscode.Name := 'wdsTFNProductscode';
    wdsTFNProductscode.FieldName := 'code';
    wdsTFNProductsname.SetParentComponent(wdsTFNProducts);
    wdsTFNProductsname.Name := 'wdsTFNProductsname';
    wdsTFNProductsname.FieldName := 'name';
    dsTFNProducts.SetParentComponent(Self);
    dsTFNProducts.Name := 'dsTFNProducts';
    dsTFNProducts.DataSet := wdsTFNProducts;
    dsTFNProducts.Left := 192;
    dsTFNProducts.Top := 347;
    wcTFNProduct.SetParentComponent(Self);
    wcTFNProduct.Name := 'wcTFNProduct';
    wcTFNProduct.Connection := dmData.dbConnect;
    wcTFNProduct.Left := 64;
    wcTFNProduct.Top := 347;
    wcProduct.SetParentComponent(Self);
    wcProduct.Name := 'wcProduct';
    wcProduct.Connection := dmData.dbConnect;
    wcProduct.Left := 48;
    wcProduct.Top := 403;
    wdsProduct.SetParentComponent(Self);
    wdsProduct.Name := 'wdsProduct';
    wdsProduct.Connection := dmData.dbConnect;
    wdsProduct.Left := 128;
    wdsProduct.Top := 408;
    wdsProductfueltype.SetParentComponent(wdsProduct);
    wdsProductfueltype.Name := 'wdsProductfueltype';
    wdsProductfueltype.FieldName := 'fueltype';
    wdsProductfueltypename.SetParentComponent(wdsProduct);
    wdsProductfueltypename.Name := 'wdsProductfueltypename';
    wdsProductfueltypename.FieldName := 'fueltypename';
    dsProduct.SetParentComponent(Self);
    dsProduct.Name := 'dsProduct';
    dsProduct.DataSet := wdsProduct;
    dsProduct.Left := 200;
    dsProduct.Top := 403;
    wcUserAccess.SetParentComponent(Self);
    wcUserAccess.Name := 'wcUserAccess';
    wcUserAccess.Connection := dmData.dbConnect;
    wcUserAccess.Left := 48;
    wcUserAccess.Top := 506;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    TempLabel.AfterLoadDFMValues;
    BitmapContainer1.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    WebPageControl1Sheet1.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    WebDBEdit8.AfterLoadDFMValues;
    WebDBEdit10.AfterLoadDFMValues;
    WebDBEdit11.AfterLoadDFMValues;
    WebDBEdit12.AfterLoadDFMValues;
    WebDBMemo1.AfterLoadDFMValues;
    WebDBEdit13.AfterLoadDFMValues;
    WebDBEdit14.AfterLoadDFMValues;
    WebDBEdit15.AfterLoadDFMValues;
    WebDBEdit16.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    WebDBCheckBox2.AfterLoadDFMValues;
    WebDBCheckBox3.AfterLoadDFMValues;
    WebDBCheckBox4.AfterLoadDFMValues;
    WebDBCheckBox5.AfterLoadDFMValues;
    WebDBEdit17.AfterLoadDFMValues;
    WebGroupBox1.AfterLoadDFMValues;
    WebDBCheckBox6.AfterLoadDFMValues;
    WebDBCheckBox7.AfterLoadDFMValues;
    WebDBCheckBox8.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    btnSaveDepotInfo.AfterLoadDFMValues;
    WebButton5.AfterLoadDFMValues;
    WebButton13.AfterLoadDFMValues;
    dbedtMasterAccount.AfterLoadDFMValues;
    WebPageControl1Sheet2.AfterLoadDFMValues;
    WebPanel7.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgDepotPriceListSetup.AfterLoadDFMValues;
    dgdbaDepotPriceListEdit.AfterLoadDFMValues;
    msgdlgDepotPriceList.AfterLoadDFMValues;
    WebPanel8.AfterLoadDFMValues;
    btnNewPrice.AfterLoadDFMValues;
    btnConfirmPrice.AfterLoadDFMValues;
    btnOpenPrice.AfterLoadDFMValues;
    WebPanel9.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    edtDepotPriceEdit.AfterLoadDFMValues;
    btnSaveDepotInfoPriceList.AfterLoadDFMValues;
    WebButton18.AfterLoadDFMValues;
    WebPageControl1Sheet3.AfterLoadDFMValues;
    WebPanel26.AfterLoadDFMValues;
    WebPanel10.AfterLoadDFMValues;
    PageControl.AfterLoadDFMValues;
    wpcSageAccounting.AfterLoadDFMValues;
    WebPanel11.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebDBEdit18.AfterLoadDFMValues;
    WebDBEdit19.AfterLoadDFMValues;
    WebDBEdit20.AfterLoadDFMValues;
    WebDBCheckBox9.AfterLoadDFMValues;
    WebButton12.AfterLoadDFMValues;
    wpcBulkOrderInfo.AfterLoadDFMValues;
    WebPanel12.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebDBEdit21.AfterLoadDFMValues;
    WebDBEdit22.AfterLoadDFMValues;
    WebDBEdit23.AfterLoadDFMValues;
    WebDBEdit24.AfterLoadDFMValues;
    WebDBEdit25.AfterLoadDFMValues;
    WebDBEdit26.AfterLoadDFMValues;
    wpcTFNLinkInformation.AfterLoadDFMValues;
    WebPanel13.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebDBCheckBox10.AfterLoadDFMValues;
    WebDBCheckBox11.AfterLoadDFMValues;
    WebButton25.AfterLoadDFMValues;
    dbedtTFNSupplier.AfterLoadDFMValues;
    WebDBEdit27.AfterLoadDFMValues;
    WebDBEdit28.AfterLoadDFMValues;
    WebDBEdit29.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebButton7.AfterLoadDFMValues;
    WebButton10.AfterLoadDFMValues;
    WebButton16.AfterLoadDFMValues;
    wpcSummatechLink.AfterLoadDFMValues;
    WebPanel14.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebButton26.AfterLoadDFMValues;
    WebDBCheckBox12.AfterLoadDFMValues;
    WebDBCheckBox13.AfterLoadDFMValues;
    WebButton14.AfterLoadDFMValues;
    WebDBEdit30.AfterLoadDFMValues;
    WebDBEdit9.AfterLoadDFMValues;
    WebButton21.AfterLoadDFMValues;
    WebDBEdit32.AfterLoadDFMValues;
    WebButton22.AfterLoadDFMValues;
    wpcFMSLink.AfterLoadDFMValues;
    WebPanel15.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebDBCheckBox14.AfterLoadDFMValues;
    WebDBEdit34.AfterLoadDFMValues;
    WebDBEdit35.AfterLoadDFMValues;
    WebButton30.AfterLoadDFMValues;
    WebDBEdit31.AfterLoadDFMValues;
    WebButton15.AfterLoadDFMValues;
    WebButton23.AfterLoadDFMValues;
    WebButton24.AfterLoadDFMValues;
    wpcShiptechLink.AfterLoadDFMValues;
    WebPanel16.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    WebDBCheckBox15.AfterLoadDFMValues;
    WebDBEdit37.AfterLoadDFMValues;
    WebDBEdit38.AfterLoadDFMValues;
    WebDBEdit39.AfterLoadDFMValues;
    WebButton31.AfterLoadDFMValues;
    WebButton32.AfterLoadDFMValues;
    WebButton33.AfterLoadDFMValues;
    wpcFuelULink.AfterLoadDFMValues;
    WebPanel17.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel35.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebDBCheckBox16.AfterLoadDFMValues;
    WebDBEdit40.AfterLoadDFMValues;
    WebDBEdit41.AfterLoadDFMValues;
    WebDBEdit42.AfterLoadDFMValues;
    WebButton34.AfterLoadDFMValues;
    WebButton35.AfterLoadDFMValues;
    WebButton36.AfterLoadDFMValues;
    WebButton40.AfterLoadDFMValues;
    wpcXFuelsLink.AfterLoadDFMValues;
    WebPanel24.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    WebLabel39.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    WebDBCheckBox17.AfterLoadDFMValues;
    WebDBEdit43.AfterLoadDFMValues;
    WebDBEdit44.AfterLoadDFMValues;
    WebButton38.AfterLoadDFMValues;
    WebButton37.AfterLoadDFMValues;
    WebDBEdit45.AfterLoadDFMValues;
    WebButton39.AfterLoadDFMValues;
    WebPanel25.AfterLoadDFMValues;
    WebButton19.AfterLoadDFMValues;
    btnSaveDepotInfoThirdParty.AfterLoadDFMValues;
    WebPageControl1Sheet4.AfterLoadDFMValues;
    WebPanel18.AfterLoadDFMValues;
    WebPanel19.AfterLoadDFMValues;
    WebPanel21.AfterLoadDFMValues;
    WebLabel40.AfterLoadDFMValues;
    WebButton44.AfterLoadDFMValues;
    edtDepotSearch.AfterLoadDFMValues;
    dgDepots.AfterLoadDFMValues;
    dgdbaDieselDepots.AfterLoadDFMValues;
    WebPanel22.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    edtDieselDepotsPC.AfterLoadDFMValues;
    WebPanel20.AfterLoadDFMValues;
    WebPanel23.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton12.AfterLoadDFMValues;
    edtDepotPriceList.AfterLoadDFMValues;
    TMSFNCDataGrid3.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter1.AfterLoadDFMValues;
    dgdbaDepotPriceListView.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    btnInsertDepot.AfterLoadDFMValues;
    btnEditDepot.AfterLoadDFMValues;
    btnSuspended.AfterLoadDFMValues;
    cbxSuspended.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebButton6.AfterLoadDFMValues;
    wcDieselDepots.AfterLoadDFMValues;
    wdsDieselDepots.AfterLoadDFMValues;
    wdsDieselDepotsDEPOTCODE.AfterLoadDFMValues;
    wdsDieselDepotsDEPOTNAME.AfterLoadDFMValues;
    wdsDieselDepotsDEPOTTEL.AfterLoadDFMValues;
    wdsDieselDepotsDEPOTFAX.AfterLoadDFMValues;
    wdsDieselDepotsDEPOTEMAIL.AfterLoadDFMValues;
    wdsDieselDepotsDEPOTCONTACTPERSONE.AfterLoadDFMValues;
    wdsDieselDepotsSUSPENDED.AfterLoadDFMValues;
    wdsDieselDepotsINVENTORYGL.AfterLoadDFMValues;
    wdsDieselDepotsAUTOPRINT.AfterLoadDFMValues;
    wdsDieselDepotsPRINTER.AfterLoadDFMValues;
    wdsDieselDepotsCOSTGL.AfterLoadDFMValues;
    wdsDieselDepotsSALESGL.AfterLoadDFMValues;
    wdsDieselDepotsCONTROLSTOCK.AfterLoadDFMValues;
    wdsDieselDepotsCRECODE.AfterLoadDFMValues;
    wdsDieselDepotsCARDSYSTEM.AfterLoadDFMValues;
    wdsDieselDepotsMERCHANTNO.AfterLoadDFMValues;
    wdsDieselDepotsTOWN.AfterLoadDFMValues;
    wdsDieselDepotsSAGEPROJECT.AfterLoadDFMValues;
    wdsDieselDepotsNONSAGEEXPORT.AfterLoadDFMValues;
    wdsDieselDepotsBOWSERCODE.AfterLoadDFMValues;
    wdsDieselDepotsBULKORDERPREFIX.AfterLoadDFMValues;
    wdsDieselDepotsDELVADDRESS1.AfterLoadDFMValues;
    wdsDieselDepotsDELVADDRESS2.AfterLoadDFMValues;
    wdsDieselDepotsDELVADDRESS3.AfterLoadDFMValues;
    wdsDieselDepotsDELVADDRESS4.AfterLoadDFMValues;
    wdsDieselDepotsDELVADDRESSCODE.AfterLoadDFMValues;
    wdsDieselDepotstfnonlinelink.AfterLoadDFMValues;
    wdsDieselDepotstfnsuppliercode.AfterLoadDFMValues;
    wdsDieselDepotstfndepotcode.AfterLoadDFMValues;
    wdsDieselDepotsfmsonlinelink.AfterLoadDFMValues;
    wdsDieselDepotsfmssupplier.AfterLoadDFMValues;
    wdsDieselDepotsstdepotcode.AfterLoadDFMValues;
    wdsDieselDepotstfnproduct.AfterLoadDFMValues;
    wdsDieselDepotstfnuseinvoice.AfterLoadDFMValues;
    wdsDieselDepotsstonlinelink.AfterLoadDFMValues;
    wdsDieselDepotsstsupplier.AfterLoadDFMValues;
    wdsDieselDepotsfmsdepotcode.AfterLoadDFMValues;
    wdsDieselDepotsstautocreateorder.AfterLoadDFMValues;
    wdsDieselDepotsautocancelorders.AfterLoadDFMValues;
    wdsDieselDepotsautocanceldays.AfterLoadDFMValues;
    wdsDieselDepotsshiptechlink.AfterLoadDFMValues;
    wdsDieselDepotsshiptechaccount.AfterLoadDFMValues;
    wdsDieselDepotsshiptechdepot.AfterLoadDFMValues;
    wdsDieselDepotssendexternalsms.AfterLoadDFMValues;
    wdsDieselDepotswholesalelic.AfterLoadDFMValues;
    wdsDieselDepotsfuelusupplier.AfterLoadDFMValues;
    wdsDieselDepotsfueludepotcode.AfterLoadDFMValues;
    wdsDieselDepotsfueluonlinelink.AfterLoadDFMValues;
    wdsDieselDepotsfuelonlinesystem.AfterLoadDFMValues;
    wdsDieselDepotsfuelmanmanualorders.AfterLoadDFMValues;
    wdsDieselDepotsfuelmancardpayments.AfterLoadDFMValues;
    wdsDieselDepotsxfuelsonlinelink.AfterLoadDFMValues;
    wdsDieselDepotsxfuelssuppliers.AfterLoadDFMValues;
    wdsDieselDepotsxfuelsdepotcode.AfterLoadDFMValues;
    wdsDieselDepotsregion.AfterLoadDFMValues;
    wdsDieselDepotsTFNDepotName.AfterLoadDFMValues;
    wdsDieselDepotsMasterAccount.AfterLoadDFMValues;
    wdsDieselDepotsTFNFuelTypeName.AfterLoadDFMValues;
    wdsDieselDepotsTFNProductName.AfterLoadDFMValues;
    wdsDieselDepotsSummaTechCRName.AfterLoadDFMValues;
    wdsDieselDepotsstdName.AfterLoadDFMValues;
    wdsDieselDepotsstFuelTypeName.AfterLoadDFMValues;
    wdsDieselDepotsFMSCRName.AfterLoadDFMValues;
    wdsDieselDepotsfmsDepotName.AfterLoadDFMValues;
    wdsDieselDepotsfmsFuelTypeName.AfterLoadDFMValues;
    wdsDieselDepotsshiptechDepotName.AfterLoadDFMValues;
    wdsDieselDepotsShipTechFuelTypeName.AfterLoadDFMValues;
    wdsDieselDepotsFuelUCRName.AfterLoadDFMValues;
    wdsDieselDepotsFuelUDepotName.AfterLoadDFMValues;
    wdsDieselDepotsFuelUFueltypeName.AfterLoadDFMValues;
    wdsDieselDepotsxFuelCRName.AfterLoadDFMValues;
    wdsDieselDepotsXFuelDepotName.AfterLoadDFMValues;
    wdsDieselDepotsxfuelFueleName.AfterLoadDFMValues;
    wdsDieselDepotsTFNCRName.AfterLoadDFMValues;
    wdsDieselDepotsShiptechCRName.AfterLoadDFMValues;
    wdsDieselDepotsfueltypename.AfterLoadDFMValues;
    wdsDieselDepotstfninternalproduct.AfterLoadDFMValues;
    wdsDieselDepotssummatechfueltype.AfterLoadDFMValues;
    wdsDieselDepotsfmsfueltype.AfterLoadDFMValues;
    wdsDieselDepotsshiptechfueltype.AfterLoadDFMValues;
    wdsDieselDepotsfuelufueltype.AfterLoadDFMValues;
    wdsDieselDepotsxfuelfueltype.AfterLoadDFMValues;
    dsDieselDepots.AfterLoadDFMValues;
    wcDepotPriceList.AfterLoadDFMValues;
    wdsDepotPriceList.AfterLoadDFMValues;
    wdsDepotPriceListAUTONO.AfterLoadDFMValues;
    wdsDepotPriceListDEPOTCODE.AfterLoadDFMValues;
    wdsDepotPriceListCOSTPRICE.AfterLoadDFMValues;
    wdsDepotPriceListSTDPRICE.AfterLoadDFMValues;
    wdsDepotPriceListDEDSUBPRICE.AfterLoadDFMValues;
    wdsDepotPriceListSPECIALPRICE.AfterLoadDFMValues;
    wdsDepotPriceListPRICELOADBY.AfterLoadDFMValues;
    wdsDepotPriceListPRICECONFIRMBY.AfterLoadDFMValues;
    wdsDepotPriceListPRICECONFIRMED.AfterLoadDFMValues;
    wdsDepotPriceListfueltype.AfterLoadDFMValues;
    wdsDepotPriceListfueltypename.AfterLoadDFMValues;
    wdsDepotPriceListFROMDATE.AfterLoadDFMValues;
    wdsDepotPriceListTODATE.AfterLoadDFMValues;
    wdsDepotPriceListPRICELOADDATE.AfterLoadDFMValues;
    wdsDepotPriceListPRICECONFIRMDATE.AfterLoadDFMValues;
    dsDepotPriceList.AfterLoadDFMValues;
    RESTClient1.AfterLoadDFMValues;
    wcTFNDepot.AfterLoadDFMValues;
    wdsTFNDepots.AfterLoadDFMValues;
    wdsTFNDepotsnumber.AfterLoadDFMValues;
    wdsTFNDepotsname.AfterLoadDFMValues;
    wdsTFNDepotsregion.AfterLoadDFMValues;
    dsTFNDepots.AfterLoadDFMValues;
    wdsTFNProducts.AfterLoadDFMValues;
    wdsTFNProductscode.AfterLoadDFMValues;
    wdsTFNProductsname.AfterLoadDFMValues;
    dsTFNProducts.AfterLoadDFMValues;
    wcTFNProduct.AfterLoadDFMValues;
    wcProduct.AfterLoadDFMValues;
    wdsProduct.AfterLoadDFMValues;
    wdsProductfueltype.AfterLoadDFMValues;
    wdsProductfueltypename.AfterLoadDFMValues;
    dsProduct.AfterLoadDFMValues;
    wcUserAccess.AfterLoadDFMValues;
  end;
end;

end.
